{
  "activities": {
    "addTask": "Task",
    "allPersons": "All people",
    "empty": "No activities",
    "filterByPerson": "Filter by person",
    "hideCompleted": "Hide completed",
    "open": "open",
    "showCompleted": "Show {{count}} completed",
    "title": "Activities",
    "viaContact": "via {{name}}"
  },
  "addresses": {
    "tabCompanies": "Organizations",
    "tabContacts": "Contacts",
    "title": "Addresses"
  },
  "admin": {
    "settings": {
      "pricing": {
        "analysisSection": "Property analysis",
        "developerSection": "Developer access",
        "errors": {
          "invalid": "Amount from 0 with at most two decimals",
          "required": "Required"
        },
        "fields": {
          "developerReport": "Property report per call (CHF)",
          "developerReportHint": "Price per call via the developer API.",
          "full": "Full analysis (CHF)",
          "fullHint": "Base price of the full analysis, excluding surcharges.",
          "lowThreshold": "Low balance warning (CHF)",
          "lowThresholdHint": "The customer is warned below this balance.",
          "reduced": "Short analysis (CHF)",
          "reducedHint": "Base price of the short analysis, excluding surcharges."
        },
        "loadFailed": "Prices could not be loaded.",
        "noChanges": "No changes",
        "noSources": "No licensed sources configured.",
        "note": "Applies immediately to new orders; running analyses keep their price.",
        "saveFailed": "Saving failed",
        "saved": "Saved",
        "sourceHint": "Surcharge in CHF when the buyer selects this source.",
        "sourcesSection": "Surcharges for licensed sources",
        "title": "Prices",
        "updatedBy": "Last changed by {{user}}, {{date}}"
      }
    },
    "vouchers": {
      "activated": "Code activated.",
      "colActive": "Active",
      "colAmount": "Amount",
      "colCode": "Code",
      "colNote": "Note",
      "colRedeemed": "Redeemed",
      "colValidUntil": "Valid until",
      "copied": "Copied",
      "copy": "Copy",
      "copyAll": "Copy all",
      "copyFailed": "Copying failed.",
      "create": "Create codes",
      "createFailed": "Codes could not be created.",
      "created": "{{count}} codes created",
      "createdHint": "These {{count}} codes are valid immediately.",
      "createdTitle": "Created codes",
      "csv": "Download CSV",
      "deactivated": "Code deactivated.",
      "empty": "No voucher codes yet.",
      "errors": {
        "amountInvalid": "Amount above 0 with at most two decimals",
        "countRange": "Quantity between 1 and 100",
        "noteTooLong": "Note at most 255 characters",
        "redemptionsRange": "Max. redemptions between 1 and 10000"
      },
      "fields": {
        "amount": "Amount (CHF)",
        "count": "Quantity",
        "maxRedemptions": "Max. redemptions",
        "note": "Note",
        "notePlaceholder": "e.g. Zurich trade fair 2026",
        "oncePerCompany": "Once per company",
        "oncePerCompanyHint": "Each company can redeem the code only once.",
        "validUntil": "Valid until",
        "validUntilHint": "Leave empty for unlimited."
      },
      "filterActive": "Active only",
      "filterAll": "All",
      "filterLabel": "Filter",
      "intro": "Create and manage codes for property analyses. Redeemed amounts are credited to the company's balance.",
      "loadFailed": "Voucher codes could not be loaded.",
      "saveFailed": "Saving failed",
      "search": "Search",
      "searchPlaceholder": "Code or note",
      "title": "Voucher codes",
      "toggleLabel": "Code {{code}} active"
    }
  },
  "agb": {
    "footer": {
      "address": "Uniplacement GmbH · c/o S&K Partners AG · Samstagernstrasse 55 · 8832 Wollerau · Schweiz",
      "registration": "UID CHE-265.053.706 · Handelsregister Kanton Schwyz"
    },
    "notice": "The German version is legally authoritative. Fees and conditions are governed by your individual contract.",
    "sections": {
      "account": "§ 3 Konto und Zugang",
      "availability": "§ 10 Verfügbarkeit und Änderungen",
      "circumvention": "§ 12 Umgehungsverbot (Plattformebene)",
      "dataProtection": "§ 8 Datenschutz und KI-Verarbeitung",
      "finalProvisions": "§ 14 Schlussbestimmungen",
      "identification": "§ 7 Identifikation und Sorgfaltspflichten",
      "liability": "§ 11 Haftung",
      "offers": "§ 5 Angebote und Verkaufsverfahren",
      "scope": "§ 1 Geltungsbereich",
      "services": "§ 2 Leistungen der Plattform",
      "signature": "§ 6 Elektronische Signatur",
      "teaserNda": "§ 4 Teaser, NDA und Dossiers",
      "terms": "§ 13 Laufzeit, Sperrung, Änderungen der AGB",
      "usageRights": "§ 9 Nutzungsrechte und Daten"
    },
    "serviceItems": {
      "communication": "Kommunikation zwischen den Beteiligten",
      "contracts": "Generierung und elektronische Signatur von Verträgen",
      "dataRoom": "Datenraum, Dossiers und Dokumentenverwaltung",
      "objectInfo": "Aufbereitung und Bereitstellung von Objektinformationen",
      "offers": "Abgabe und Verwaltung von Angeboten"
    },
    "subtitle": "Plattform-Nutzungsbedingungen der Uniplacement GmbH (Betreiberin der Plattform «Immotron») · Gültig ab 1. Oktober 2026",
    "title": "General Terms and Conditions (AGB)",
    "version": "Version 1.1 · Gültig ab 1. Oktober 2026"
  },
  "ai": {
    "aiAccuracy": "AI avg.",
    "cliUnavailable": "CLI unavailable",
    "confirmed": "Confirmed",
    "disabled": "Disabled",
    "enabled": "Active",
    "error": "An error occurred",
    "fieldsBetter": "fields better",
    "images": {
      "loadFailed": "Bild konnte nicht geladen werden",
      "notAvailable": "Bild nicht verfügbar",
      "primaryImage": "Hauptbild",
      "removeImage": "Bild entfernen",
      "selectAll": "Alle",
      "selectLabel": "Auswählen",
      "selectNone": "Keine",
      "selectRelevant": "Relevante",
      "selectedLabel": "Ausgewählt",
      "setAsPrimary": "Als Hauptbild setzen",
      "title": "Bilder"
    },
    "jobs": {
      "active": "Aktiv",
      "addWarning": "Hinweis hinzufügen",
      "archive": "Archivieren",
      "cancelFailed": "Abbrechen fehlgeschlagen",
      "cancelStarted": "Job wird abgebrochen",
      "core": "Pflicht",
      "cost": "Kosten",
      "coverage": "Abdeckung",
      "createProperty": "Objekt erstellen",
      "createPropertyFailed": "Objekt konnte nicht erstellt werden",
      "createPropertyRecovered": "Object #{{id}} was created (the connection was briefly interrupted)",
      "creating": "Erstellen...",
      "deleteConfirm": "Job endgültig löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteFailed": "Löschen fehlgeschlagen",
      "dismissFailed": "Konnte nicht abgeschlossen werden",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumentenzuordnung",
      "documents": "Dokumente",
      "done": "Fertig",
      "duration": "Dauer",
      "error": "Fehler",
      "feedbackResetFailed": "Feedback konnte nicht zurückgesetzt werden",
      "feedbackSendFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "files": "Dateien",
      "goToProperty": "Zum Objekt",
      "helpful": "hilfreich",
      "listRefreshed": "Liste aktualisiert",
      "model": "Modell",
      "noJobsFound": "Keine Jobs gefunden",
      "optional": "Optional",
      "pipeline": {
        "jumpToLatest": "Jump to latest",
        "live": "Live",
        "loadFailed": "Failed to load events",
        "loading": "Loading events...",
        "logTitle": "Processing log",
        "noEvents": "No events yet",
        "stages": {
          "classification": "Classification",
          "extraction": "Extraction",
          "persistence": "Persistence",
          "upload": "Upload",
          "validation": "Validation"
        },
        "title": "AI pipeline"
      },
      "processing": "Verarbeitung...",
      "quality": {
        "charsExtracted": "{{formatted}} characters extracted",
        "docType": "Type",
        "encryptedPdf": "Encrypted",
        "encryptedShort": "encrypted",
        "encryptedWarning": "Encrypted PDF — extraction not possible. Please upload an unprotected version.",
        "pages": "{{formatted}} pages",
        "scanPdf": "Scanned PDF",
        "scanShort": "scans",
        "scanWarning": "Scanned document — extraction may be incomplete.",
        "summary": "Summary",
        "textPdf": "Text PDF",
        "title": "PDF quality"
      },
      "reactivate": "Reaktivieren",
      "reactivateFailed": "Reaktivierung fehlgeschlagen",
      "recommended": "Empfohlen",
      "refreshFailed": "Aktualisierung fehlgeschlagen",
      "reset": "Zurücksetzen",
      "resetConfirm": "Job zurücksetzen? Das Ergebnis wird gelöscht.",
      "resetFailed": "Zurücksetzen fehlgeschlagen",
      "resetShort": "Reset",
      "retry": "Wiederholen",
      "retryFailed": "Retry fehlgeschlagen — Originaldateien evtl. nicht mehr vorhanden",
      "retryStarted": "Job wird wiederholt",
      "saveFailed": "Speichern fehlgeschlagen",
      "showAll": "Alle Jobs anzeigen",
      "showCompleted": "Auch abgeschlossene anzeigen",
      "startNewUpload": "Neuen Upload starten",
      "statistics": "Statistik",
      "status": {
        "cancelled": "Abgebrochen",
        "pending": "Wartend"
      },
      "timeAgo": {
        "justNow": "gerade eben"
      },
      "title": "KI-Extraktions-Jobs",
      "titleShort": "KI-Jobs",
      "tokens": "Tokens",
      "unhelpful": "nicht hilfreich",
      "warnings": "Hinweise",
      "warningsSaved": "Hinweise gespeichert"
    },
    "learningDescription": "Comparison: AI extraction vs. static sources (GeoAdmin)",
    "learningHint": "The system learns automatically with each confirmed extraction.",
    "learningMode": "AI Learning Mode",
    "model": "Model",
    "noComparisonData": "No comparison data yet",
    "noComparisonDataHint": "Data is collected automatically after each AI extraction + confirmation.",
    "prompt": "Prompt",
    "promptPlaceholder": "Ask a question...",
    "response": "Response",
    "send": "Send",
    "sending": "Sending...",
    "staticAccuracy": "Static avg.",
    "status": "Status",
    "subtitle": "Claude AI test environment",
    "title": "AI Assistant",
    "totalExtractions": "Extractions",
    "upload": {
      "addMoreDocs": "Weitere Dokumente ergänzen",
      "addMoreDocsHint": "Fehlende Dokumente hochladen — bestehende Daten werden ergänzt, nicht überschrieben.",
      "addMoreHint": "Weitere Dateien/Ordner oben hinzufügen, dann Analyse starten",
      "backOtherDocs": "Zurück / Andere Dokumente",
      "backToProperties": "Zurück zu Objekte",
      "batchFailed": "fehlgeschlagen",
      "batchObjectsProcessed": "Objekten verarbeitet",
      "batchOf": "von",
      "batchProcessing": "Portfolio-Verarbeitung",
      "batchResult": "Portfolio-Ergebnis",
      "batchSuccessful": "erfolgreich",
      "catCore": "Kern-Dokumente",
      "catOptional": "Optional",
      "catRecommended": "Empfohlen",
      "chooseDirectory": "Verzeichnis wählen",
      "clickToEdit": "Klicken zum Bearbeiten",
      "collapseAll": "Alle zuklappen",
      "confidence": "Confidence",
      "confidenceExplain": "Confidence-Score erklären",
      "confirmCreate": "Erstellen",
      "confirmTitle": "Objekt erstellen?",
      "coreComplete": "Kern komplett",
      "createProperty": "Objekt erstellen",
      "createdSuccess": "Objekt erfolgreich erstellt!",
      "detectedDocTypes": "Erkannte Dokumenttypen",
      "docTypesDetected": "Dokumenttypen erkannt",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumenten-Zuordnung",
      "documentPlural": "Dokumente",
      "documentSingular": "Dokument",
      "dropzoneHint": "Drop PDF, images, Excel or Word here, or choose a directory/files",
      "dropzoneTitle": "Objekt-Unterlagen hochladen",
      "editProperty": "Objekt bearbeiten",
      "expandAll": "Alle aufklappen",
      "feedbackFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "filePlural": "Dateien",
      "fileSingular": "Datei",
      "filterAll": "Alle",
      "filterOpen": "Offen",
      "filterRated": "Bewertet",
      "groupingFiles": "Dateien werden gruppiert und hochgeladen",
      "headerAncillary": "NK",
      "headerAreaFrom": "Fläche von",
      "headerAreaSqm": "Fläche m²",
      "headerAreaTo": "Fläche bis",
      "headerFloor": "Etage",
      "headerNetRent": "Nettomiete",
      "headerRented": "Vermietet",
      "headerRooms": "Zimmer",
      "headerRooms2": "Zimmer",
      "headerStatus": "Status",
      "headerTotal": "Total",
      "helpful": "Hilfreich",
      "hints": "Hinweise",
      "individualFiles": "Einzelne Dateien",
      "locationAnalysis": "Standort-Analyse",
      "lowConfidenceWarning": "Niedrige Confidence — manuelle Prüfung der Daten wird empfohlen.",
      "metaCost": "Kosten",
      "metaDuration": "Dauer",
      "metaModel": "Modell",
      "metaTokens": "Tokens",
      "newUpload": "Neuer Upload",
      "noData": "Keine Daten",
      "noPdfInDirectory": "No PDF files found in the directory",
      "noSupportedInDirectory": "No supported files found in the directory (PDF, images, Excel or Word)",
      "noValidFiles": "No valid files selected",
      "unsupportedFormat": "File type not supported — allowed: PDF, email (.eml), images (JPEG/PNG/WebP/GIF), Excel (.xlsx/.xls) and Word (.docx/.doc)",
      "notHelpful": "Nicht hilfreich",
      "objectCreatedEmail": "Objekt erstellt — E-Mail mit offenen Fragen wurde gesendet",
      "objectUpdatedEmail": "Objekt aktualisiert — E-Mail mit offenen Fragen wurde gesendet",
      "ofDocTypes": "von",
      "openHints": "Offene Hinweise",
      "preparing": "KI-Analyse wird vorbereitet...",
      "processingDirectory": "Verzeichnis wird verarbeitet...",
      "qualityGood": "Gute Datenqualität — bereit zur Bestätigung",
      "qualityLow": "Wenige Daten extrahiert — manuelle Eingabe empfohlen",
      "qualityPartial": "Teilweise Daten extrahiert — bitte prüfen",
      "ready": "bereit",
      "redirecting": "Sie werden zur Bearbeitungsseite weitergeleitet...",
      "removeAll": "Alle entfernen",
      "rentRollStats": "Mieterspiegel-Statistik",
      "retry": "Wiederholen",
      "retryAction": "Erneut versuchen",
      "retryFailed": "Wiederholung konnte nicht gestartet werden",
      "retryNotPossible": "Wiederholung nicht möglich",
      "retryStarted": "Wiederholung gestartet",
      "saveFailed": "Speichern fehlgeschlagen",
      "saving": "Objekt wird gespeichert...",
      "scoreCurrent": "Aktuell",
      "scoreHigh": "Alle wichtigen Felder extrahiert, Daten plausibel.",
      "scoreLow": "Wenige Daten — prüfen oder manuell ergänzen.",
      "scoreMedium": "Einige Felder fehlen oder Unstimmigkeiten.",
      "scoreTitle": "Was bedeutet der Score?",
      "sectionAnalysis": "Immobilienanalyse",
      "sectionFinance": "Finanzen",
      "sectionGeoAdmin": "Behörden-Daten (swisstopo)",
      "sectionImages": "Bilder",
      "sectionInsurance": "Versicherung",
      "sectionParking": "Parkierung",
      "sectionProperty": "Objekt",
      "sectionRentRoll": "Mieterspiegel",
      "sectionUnitMix": "Wohnungsmix",
      "startAnalysis": "KI-Analyse starten",
      "submitting": "Dokumente werden übermittelt...",
      "subtitle": "Laden Sie die relevanten Dateien hoch: Mieterspiegel, Baubeschrieb, Grundbuchauszug, Gebäudeversicherungsnachweis, Marktwertschätzungen — die KI extrahiert automatisch alle Objektdaten.",
      "supplement": "Ergänzen",
      "supplementDocs": "Dokumente ergänzen",
      "title": "KI-Objekterfassung",
      "uploadFailed": "Upload fehlgeschlagen",
      "uploadedFiles": "Hochgeladene Dateien",
      "uploading": "Hochladen...",
      "waitProcessing": "Bitte warten — Upload/Verarbeitung läuft noch.",
      "whatIsWrong": "Was stimmt nicht? (optional)",
      "whyHelpful": "Warum hilfreich? (optional)"
    }
  },
  "aiClauses": {
    "cancel": "Cancel",
    "confirmDelete": "Delete?",
    "confirmYes": "Confirm",
    "delete": "Delete",
    "edit": "Edit",
    "editClause": "Edit clause",
    "generate": "Generate",
    "generateFailed": "Failed to generate clause",
    "generateSuccess": "Clause generated successfully",
    "generating": "Generating...",
    "hint": "The AI clause generator creates tailored clauses and assigns them to the selected contract section. You can edit the generated text and adjust the order afterwards.",
    "moveDown": "Move down",
    "moveUp": "Move up",
    "noClauses": "No clauses generated yet",
    "prompt": "Describe clause",
    "promptPlaceholder": "Describe the desired clause, e.g. 'Right of withdrawal subject to financing'",
    "save": "Save",
    "section": "Section",
    "sections": {
      "BROKER_CONDITIONS": "Broker Special Conditions",
      "BUYER_CONDITIONS": "Buyer Special Conditions",
      "GENERAL_CONDITIONS": "General Conditions",
      "PAYMENT_TERMS": "Payment Terms",
      "SELLER_CONDITIONS": "Seller Special Conditions",
      "TERMINATION": "Termination Conditions"
    },
    "templates": "Templates",
    "title": "AI Clause Generator"
  },
  "analyses": {
    "admin": {
      "colCompany": "Company",
      "colDuration": "Duration",
      "filterCompany": "Company (ID)",
      "refund": "Refund",
      "refundConfirm": "Credit the price of this analysis back to the company?",
      "refundNotPossible": "Refund not possible (already done or analysis still open).",
      "refunded": "Refund booked.",
      "title": "Property analyses (all companies)"
    },
    "detail": {
      "again": "Analyse again",
      "backToList": "All analyses",
      "chipResult": "Result",
      "chipRunning": "Analysis",
      "dataroom": "Data room",
      "failed": "The analysis was aborted.",
      "openPoints": "Open points",
      "orderedBy": "ordered by {{name}}",
      "profileFits": "Fits the search profile",
      "profileNo": "Does not fit the search profile",
      "profilePartly": "Partly fitting",
      "profileRef": "Compared with: {{label}}, as of {{date}}",
      "progressCount": "{{done}} / {{total}} steps",
      "refunded": "The credit of {{amount}} has been refunded.",
      "related": "{{count}} earlier analyses by this company of this property",
      "remarks": "Your remarks",
      "report": "Report (PDF)",
      "showAll": "show all",
      "step": {
        "dataroom": "Data room",
        "inventories": "Federal inventories",
        "master_data": "Master data",
        "oereb": "Public-law restrictions",
        "popety": "Popety",
        "remarks": "Your remarks",
        "report": "Report",
        "site_facts": "Location facts",
        "site_map": "Site map",
        "verdict": "Verdict",
        "wp": "Wüest Partner",
        "zefix_hr": "Commercial register"
      },
      "verdict": {
        "go": "Pursue",
        "go_with_reservations": "Pursue with reservations",
        "stop": "Stop"
      },
      "waiting": "Waiting for the agent …"
    },
    "duplicate": {
      "colleague": "A colleague",
      "match": {
        "address": "match by address",
        "egrid": "match by EGRID",
        "title": "similar property (title)"
      },
      "more": "+ {{count}} more",
      "proceed": "Analyse again anyway",
      "reminder": "Note: earlier analysis of {{date}} ({{name}})",
      "sentence": "{{name}} analysed this property on {{date}} — result: {{result}}",
      "status": {
        "done": "finished",
        "failed": "aborted",
        "pending": "waiting",
        "refunded": "aborted, refunded",
        "running": "running"
      },
      "verdict": {
        "go": "Pursue",
        "go_with_reservations": "With reservations",
        "stop": "Stop"
      },
      "view": "View analysis"
    },
    "list": {
      "aborted": "aborted",
      "colDate": "Date",
      "colDepth": "Scope",
      "colPrice": "Price",
      "colSources": "Sources",
      "colStatus": "Status",
      "empty": "No analysis ordered yet.",
      "groupEarlier": "Earlier",
      "groupToday": "Today",
      "groupWeek": "This week",
      "new": "New analysis",
      "noResults": "No analysis found.",
      "report": "Report (PDF)",
      "running": "running {{done}}/{{total}}",
      "scopeAll": "All",
      "scopeMine": "Mine",
      "scopeOthers": "Colleagues",
      "search": "Search property or town …",
      "selectHint": "Select an analysis from the list.",
      "status": {
        "pending": "Waiting",
        "running": "In progress",
        "done": "Report ready",
        "failed": "Aborted",
        "refunded": "Aborted — credit refunded"
      },
      "title": "My analyses",
      "verdictAll": "All results",
      "waiting": "waiting"
    },
    "new": {
      "back": "Back",
      "balance": "Credit",
      "balanceAfter": "Credit after start",
      "change": "change",
      "createOwnProfile": "Create my own profile",
      "created": "Order placed — we will notify you when the report is ready.",
      "creditExhausted": "Insufficient credit: price CHF {{price}}, balance CHF {{balance}}. Please top up.",
      "dataroom": "Data room",
      "dataroomFiles": "Drop files here or choose them (PDF, ZIP, max. 250 MB each)",
      "dataroomLink": "Data room link (SwissTransfer, WeTransfer, data room URL)",
      "dataroomRequired": "Please provide a link or upload files.",
      "depth": "Scope",
      "depthFull": "Full — complete audit report",
      "depthFullHint": "Full report with every source",
      "depthReduced": "Reduced — decision pages (traffic light, red flags, key figures)",
      "depthReducedHint": "Traffic light, red flags, key figures",
      "fileTooLarge": "“{{name}}” is larger than 250 MB and was skipped.",
      "filesSummary": "{{count}} files · {{size}}",
      "group": {
        "amtlich": "Official data",
        "lizenziert": "Licensed data",
        "register": "Registers"
      },
      "haveVoucher": "I have a voucher code",
      "included": "included",
      "intro": "Upload the data room or paste its link, choose the sources and receive the analysis as PDF.",
      "matchCompany": "Company profile",
      "matchOwn": "My search profile",
      "matchWith": "Compare with",
      "next": "Next",
      "noCompany": "No company is assigned to your account. Please contact Immotron.",
      "noOwnProfile": "You have no profile of your own — the company profile will be used.",
      "noProfile": "No search profile stored — the analysis runs without a comparison.",
      "objectCity": "Town",
      "objectEgrid": "EGRID",
      "objectEgridHint": "Optional — helps to identify the property unambiguously.",
      "objectStreet": "Street and no.",
      "objectTitle": "Property title",
      "objectZip": "Postcode",
      "price": "Price",
      "profileAsOf": "As of {{date}}",
      "remarks": "Your remarks (what should we look at?)",
      "remarksPlaceholder": "What should the analysis look at in particular?",
      "remarksSuggestion1": "Contaminated sites?",
      "remarksSuggestion2": "Rent potential?",
      "remarksSuggestion3": "Roof renovated — documented?",
      "selectedFiles": "Selected files",
      "shortfall": "{{amount}} missing",
      "sourceDetail": {
        "site_facts": "Building register, zone, public transport class, noise, hazards",
        "oereb": "Cadastre of public-law restrictions with summary",
        "inventories": "ISOS, BLN, IVS, cultural property, moors, polluted sites",
        "site_map": "Orthophoto with cadastre and parcels",
        "zefix_hr": "Seller, executive bodies, commercial register notices",
        "wp": "Location report and market range",
        "popety": "Parcel, building, solar exposure, estimate"
      },
      "sources": "Sources",
      "sourcesRequired": "Please choose at least one source.",
      "step1": "Property & data room",
      "step2": "Sources",
      "step3": "Remarks & scope",
      "step4": "Review & start",
      "submit": "Start analysis",
      "title": "Order a property analysis",
      "titleRequired": "Please enter a property title (at least 3 characters).",
      "topUp": "Top up",
      "uploadProgress": "Uploading {{done}}/{{total}} …",
      "uploading": "Uploading files …"
    }
  },
  "app": {
    "name": "Immotron",
    "tagline": "Real Estate Investment Platform"
  },
  "pwa": {
    "newVersionAvailable": "New version available",
    "update": "Update"
  },
  "auth": {
    "errors": {
      "accountInactive": "Your account is not yet activated",
      "accountInactiveDescription": "Please sign the contract we sent to your email first. After signing, you will receive a link to set up your password.",
      "accountInactiveTitle": "Account not yet activated",
      "invalidCredentials": "Invalid email or password",
      "networkError": "Network error. Please try again.",
      "sessionExpired": "Your session has expired"
    },
    "forgotPassword": {
      "backToLogin": "Back to Sign In",
      "email": "Email Address",
      "networkError": "Connection error. Please try again.",
      "submit": "Send Link",
      "subtitle": "Enter your email address",
      "success": "If an account exists, you will receive an email.",
      "title": "Forgot Password"
    },
    "login": {
      "email": "Email Address",
      "emailPlaceholder": "your@email.com",
      "forgotPassword": "Forgot password?",
      "noAccount": "Don't have an account?",
      "password": "Password",
      "passwordError": "Incorrect email address or password.",
      "passwordPlaceholder": "Your password",
      "register": "Register",
      "rememberMe": "Remember me",
      "selectCompany": "Select Company",
      "selectCompanySubtitle": "Choose the company you want to sign in for",
      "submit": "Sign In",
      "subtitle": "Welcome back",
      "title": "Sign In",
      "withPassword": "Sign in with password"
    },
    "logout": "Sign Out",
    "magicLink": {
      "continueToApp": "Continue to platform",
      "emailFallbackHint": "Please enter your email address so we can send you a new link.",
      "expiredMessage": "For security reasons, this link is only valid for a limited time.",
      "expiredTitle": "Sign-in link expired",
      "networkError": "Connection error. Please try again.",
      "newLinkSent": "We've sent a new sign-in link to your registered email address. Please check your inbox.",
      "resend": "Send again",
      "sendNewLink": "Send new link",
      "sentHint": "No link received? Check your spam folder.",
      "sentMessage": "We've sent a sign-in link to {{email}}.",
      "sentTitle": "Link on its way!",
      "stillSignedIn": "You are already signed in.",
      "submit": "Request Sign-In Link",
      "subtitle": "We'll send you a sign-in link to your email address.",
      "switchedUser": "Previously signed in as {{from}} — now signed in as {{to}}",
      "title": "Sign In",
      "verifyingSubtitle": "Please wait a moment.",
      "verifyingTitle": "Signing you in…",
      "wrongAddress": "Wrong address? Back to input"
    },
    "passkey": {
      "cancelled": "Passkey sign-in cancelled.",
      "divider": "or",
      "error": "Passkey sign-in failed. Please try again.",
      "login": "Sign in with Passkey",
      "registerSuccess": "Passkey set up successfully!",
      "setupAction": "Set up now",
      "setupDialog": {
        "cancelled": "Passkey setup cancelled.",
        "created": "Passkey created. Optionally enter a device name.",
        "description": "With a passkey you can sign in quickly and securely using fingerprint, face recognition or device lock.",
        "deviceNameHint": "A name helps you identify this passkey later.",
        "deviceNameLabel": "Device name (optional)",
        "deviceNamePlaceholder": "e.g. Max's iPhone",
        "error": "Could not set up passkey. Please try again.",
        "notSupported": "Your browser does not support passkeys. Please use an up-to-date browser.",
        "register": "Set up Passkey",
        "saveError": "The passkey was created locally but could not be saved. Please try again.",
        "skipName": "Skip",
        "success": "Passkey set up successfully!",
        "title": "Set up Passkey"
      },
      "setupDismiss": "Later",
      "setupMessage": "Set up a passkey for faster and more secure sign-in.",
      "setupTitle": "Set up Passkey"
    },
    "passwordSetup": {
      "backToLogin": "Back to login",
      "confirmPassword": "Confirm Password",
      "emailPlaceholder": "Enter email address",
      "error": "Could not save password. Please try again.",
      "expiredMessage": "This link has expired. Please contact us for a new link.",
      "expiredMessageNew": "This link has expired. Please request a new one.",
      "expiredTitle": "Link Expired",
      "invalidMessage": "This link is invalid or has already been used.",
      "invalidTitle": "Invalid Link",
      "magicLinkError": "The magic link could not be sent.",
      "magicLinkSentHint": "Check your inbox and click the link.",
      "magicLinkSentMessage": "A login link has been sent to your email address.",
      "magicLinkSentTitle": "Link sent",
      "newPassword": "New Password",
      "reqDigit": "One digit",
      "reqLowercase": "One lowercase letter",
      "reqMinLength": "At least 8 characters",
      "reqUppercase": "One uppercase letter",
      "requestNewLink": "Request new link",
      "requirementsNotMet": "Password does not meet all requirements",
      "settingUpFor": "Setting up password for",
      "submit": "Save Password",
      "subtitle": "Create your password to access the platform",
      "successMessage": "Your password has been saved. You will be redirected to sign in.",
      "successTitle": "Password Set Successfully",
      "title": "Set Up Password",
      "weakPassword": "Password does not meet the requirements."
    },
    "profile": "Profile",
    "resetPassword": {
      "confirmPassword": "Confirm Password",
      "error": "Invalid or expired link",
      "newPassword": "New Password",
      "submit": "Set Password",
      "subtitle": "Enter your new password",
      "success": "Password changed successfully. You will be redirected to login.",
      "title": "Set New Password"
    },
    "settings": "Settings",
    "twoFactor": {
      "backToLogin": "Back to sign in",
      "codeLabel": "Verification code",
      "codeSent": "New code was sent",
      "expiredCode": "The code has expired. Please request a new one.",
      "invalidCode": "Invalid code",
      "maxAttempts": "Too many attempts. Please sign in again.",
      "resend": "Resend code",
      "resendCooldown": "Resend in {{seconds}}s",
      "resendSuccess": "A new code has been sent.",
      "submit": "Verify",
      "subtitle": "We sent a verification code to {{email}}",
      "title": "Enter verification code",
      "verify": "Verify",
      "wrongCode": "The code you entered is invalid."
    }
  },
  "buyerProfile": {
    "title": "Investor profile (AI)",
    "relevance": "Relevance",
    "notProfiled": "Not profiled yet",
    "notProfiledHint": "No investor profile has been created for this organisation yet.",
    "badgeTooltip": "Real estate relevance: {{score}}/100",
    "scoreOutOf": "{{score}} out of 100",
    "profiledAtValue": "Profiled on {{date}}",
    "openSearchProfile": "Open search profile",
    "run": "Create profile",
    "rerun": "Recreate profile",
    "runSuccess": "Investor profile updated",
    "runError": "The investor profile could not be created",
    "groupRun": "Create investor profiles for group",
    "batchSummary": "{{profiled}} profiled · {{skipped}} skipped · {{errors}} errors",
    "batchStarted": "{{count}} organisations are being profiled in the background — refresh the page later",
    "filterLabel": "Filter by investor relevance",
    "filterAll": "Relevance: all",
    "filterProfiled": "Profiled only",
    "filterMin": "Score ≥ {{min}}"
  },
  "campaigns": {
    "blocks": {
      "add": "Add Block",
      "fields": {
        "addItem": "Add item",
        "addRow": "Add Row",
        "alt": "Alt Text",
        "body": "Text",
        "buttonColor": "Button Color",
        "buttonText": "Button Text",
        "buttonUrl": "Button URL",
        "caption": "Caption",
        "cardColor": "Card Color",
        "cardText": "Card Text",
        "cardTitle": "Card Title",
        "heading": "Heading",
        "imageHeight": "Image height",
        "imageOpacity": "Image Opacity",
        "imageUrl": "Image URL",
        "itemText": "Item text",
        "itemTitle": "Item title",
        "label": "Label",
        "leftImage": "Left Image",
        "leftText": "Left Text",
        "list": "List",
        "overlayOpacity": "Overlay Darkness",
        "rightImage": "Right Image",
        "rightText": "Right Text",
        "subtitle": "Subtitle",
        "textAlign": "Alignment",
        "textOffsetY": "Text Position (vertical)",
        "title": "Title",
        "value": "Value"
      },
      "moveDown": "Move Down",
      "moveUp": "Move Up",
      "remove": "Remove Block",
      "title": "Content Blocks",
      "types": {
        "contract_details": "Contract Details",
        "cta": "Call-to-Action",
        "divider": "Divider",
        "expiry_notice": "Expiry Notice",
        "feature": "Feature Section",
        "hero": "Hero Image",
        "image": "Image",
        "key_value": "Data Table",
        "text": "Text",
        "two_column": "Two Columns"
      }
    },
    "company": "Company",
    "confirmDelete": "Are you sure you want to delete this campaign?",
    "confirmDeleteDescription": "Are you sure you want to delete this campaign?",
    "createSuccess": "Campaign created successfully",
    "deleteCampaign": "Delete Campaign",
    "deleteFailed": "Campaign could not be deleted.",
    "deleteSuccess": "Campaign deleted successfully",
    "editCampaign": "Edit Campaign",
    "errors": {
      "createFailed": "Failed to create campaign",
      "deleteFailed": "Failed to delete campaign",
      "loadFailed": "Failed to load campaigns",
      "noRecipients": "No recipients added",
      "previewFailed": "Failed to load preview",
      "sendFailed": "Failed to send campaign",
      "updateFailed": "Failed to update campaign"
    },
    "footer": {
      "address": "Address",
      "companyName": "Company Name",
      "email": "Email",
      "phone": "Phone",
      "title": "Footer",
      "website": "Website"
    },
    "fromEmail": "Sender Email",
    "fromName": "Sender Name",
    "header": {
      "backgroundColor": "Background Color",
      "headerSubtitle": "Slogan / Subtitle",
      "headerTitle": "Header Title",
      "logoUrl": "Logo URL",
      "textColor": "Text Color",
      "title": "Header"
    },
    "imagePicker": {
      "confirmDelete": "Are you sure you want to delete this image?",
      "delete": "Delete image",
      "deleteFailed": "Image could not be deleted.",
      "deleteSuccess": "Image deleted",
      "empty": "No images uploaded yet",
      "title": "Select Image",
      "upload": "Upload Image",
      "uploading": "Uploading..."
    },
    "list": {
      "empty": {
        "description": "Create your first email campaign",
        "title": "No campaigns yet"
      }
    },
    "name": "Name",
    "newCampaign": "New Campaign",
    "noTemplate": "Without template",
    "pause": {
      "button": "Pause",
      "confirm": "Pause campaign sending? The current recipient will still be sent.",
      "failed": "Campaign could not be paused.",
      "success": "Campaign has been paused.",
      "title": "Pause campaign"
    },
    "preview": {
      "refresh": "Refresh Preview",
      "title": "Preview"
    },
    "recipients": {
      "actions": "Actions",
      "add": "Add Recipients",
      "added": "{{count}} recipients added",
      "clear": "Remove All",
      "company": "Company",
      "confirmClear": "Remove all recipients?",
      "confirmDelete": "Really remove this recipient?",
      "delete": "Remove",
      "deleteFailed": "Recipient could not be removed.",
      "deleteSuccess": "Recipient removed",
      "existingCount": "{{count}} recipients already added",
      "filterAll": "All",
      "filterType": "Filter type",
      "limitReached": "Send limit reached ({{sent}}/{{limit}})",
      "mode": "Mode",
      "modeAll": "All Contacts",
      "modeByCompany": "By Company",
      "modeManual": "Manual Selection",
      "modeUpload": "Upload Excel/CSV",
      "noRecipients": "No recipients added",
      "onlyWithEmail": "Only with email",
      "previewTitle": "Recipient preview",
      "reset": "Reset",
      "resetConfirm": "Reset status for {{email}}?",
      "resetFailed": "Recipients could not be reset.",
      "resetStatus": "Reset",
      "resetSuccess": "Status reset",
      "search": "Search recipients...",
      "searchCompanies": "Search company...",
      "selectCompanies": "Select companies",
      "selectContacts": "Select contacts",
      "selected": "{{count}} selected",
      "send": "Send",
      "sendConfirm": "Send email to {{email}} now?",
      "sendFailed": "Campaign could not be sent.",
      "sendLimit": "Send limit",
      "sendLimitHint": "Max. recipients per send (empty = all)",
      "sendSingle": "Send",
      "sendSuccess": "Email sent",
      "statusTitle": "Recipient Status",
      "syncStatus": "Sync status",
      "title": "Recipients",
      "total": "{{count}} recipients total",
      "uploadBtn": "Upload File",
      "uploadErrors": "errors",
      "uploadHint": "Upload an Excel (.xlsx) or CSV file with email addresses",
      "uploadResult": "{{added}} added, {{skipped}} skipped ({{total}} total)",
      "viewAll": "View all {{count}} recipients"
    },
    "replyTo": "Reply-To",
    "resume": {
      "button": "Resume",
      "confirm": "Resume sending to {{count}} remaining recipients?",
      "failed": "Campaign could not be resumed.",
      "success": "Campaign has been resumed.",
      "title": "Resume campaign"
    },
    "selectTemplate": "Select template",
    "send": {
      "confirmSend": "Send campaign to {{count}} recipients now?",
      "paused": "Paused",
      "progress": "Progress: {{sent}} of {{total}}",
      "rateHint": "5-120 emails per minute (default: 30)",
      "rateLabel": "Send Rate",
      "send": "Send campaign",
      "sendNow": "Send Now",
      "sending": "Sending...",
      "testEmail": "Test Email Address",
      "testSend": "Send Test Email",
      "title": "Send"
    },
    "sendLimit": {
      "saveFailed": "Send limit could not be saved.",
      "saved": "Send limit saved."
    },
    "sendLimitSaved": "Send limit saved.",
    "sendSuccess": "Campaign is being sent",
    "stats": {
      "bounced": "Bounced",
      "clicked": "Clicked",
      "delivered": "Delivered",
      "failed": "Failed",
      "opened": "Opened",
      "recipients": "Recipients",
      "sent": "Sent"
    },
    "statuses": {
      "CANCELLED": "Cancelled",
      "DRAFT": "Draft",
      "PARTIALLY_SENT": "Partially Sent",
      "PAUSED": "Paused",
      "SENDING": "Sending",
      "SENT": "Sent"
    },
    "subject": "Subject",
    "subtitle": "Manage and send email campaigns",
    "syncStatus": "Sync Status",
    "template": "Template",
    "testSendSuccess": "Test email sent to {{email}}",
    "title": "Campaigns",
    "updateSuccess": "Campaign updated successfully"
  },
  "ceoAgent": {
    "batch": {
      "description": "Process multiple open tasks with AI at once.",
      "run": "Process 5 tasks",
      "title": "Batch processing"
    },
    "results": {
      "title": "Results"
    },
    "status": {
      "available": "AI available",
      "openTasks": "Open tasks",
      "pendingAI": "Waiting for AI",
      "processedToday": "Processed today"
    },
    "subtitle": "Autonomous AI assistant for tasks",
    "suggestions": {
      "empty": "No suggestions — all done!",
      "process": "Process",
      "title": "Suggestions"
    },
    "title": "Task Assistant"
  },
  "ceoComposer": {
    "refine": {
      "label": "What should I adjust?",
      "placeholder": "e.g. remove date/phone suggestions, ask for a written reply",
      "apply": "Adjust",
      "regenerate": "Regenerate",
      "regenerateHint": "Generate the mail afresh — includes pinned notes",
      "hint": "The base text is preserved — only the requested change is applied. The previous version stays in the history."
    },
    "emptyState": {
      "contextAnchor": "I know this task:",
      "loading": "Loading suggestions …",
      "quickStartHeading": "Get started",
      "linkCardTitle": "Link a contact, company or property",
      "linkCardDesc": "Link an entity so the assistant can make targeted, actionable suggestions.",
      "linkContact": "Link contact",
      "linkCompany": "Link company",
      "linkProperty": "Link property",
      "inlineEmpty": "No specific suggestions available right now."
    },
    "suggestions": {
      "button": "Suggestions"
    },
    "selection": {
      "asPostit": "📌 As post-it",
      "created": "Saved as post-it",
      "error": "Could not save post-it"
    },
    "investorMatch": {
      "manualButton": "Find AI buyers",
      "title": "AI buyer matching",
      "hint": "Finds matching buyers from the CRM — structured prefilter plus AI rating.",
      "run": "Find AI buyers",
      "rerun": "Recompute",
      "confirmAction": "Confirm & run",
      "linkProperty": "Link a property",
      "loading": "Finding buyers …",
      "loadFailed": "Matching failed.",
      "retry": "Try again",
      "empty": "No matching buyers found.",
      "close": "Close",
      "selectPropertyHint": "This task isn't linked to a property. Pick a property for the buyer matching.",
      "searchPlaceholder": "Search property…",
      "change": "Change",
      "candidateCount": "{{count}} candidates",
      "aiUsed": "AI-rated",
      "aiNotUsed": "Prefilter only",
      "fitScore": "Fit score: {{score}}%",
      "showReasoning": "Show reasoning",
      "hideReasoning": "Hide reasoning",
      "prefilterOnly": "Prefilter score (no AI rating)",
      "rankedHint": "Best match first — fit score as in the Quality Gate.",
      "entityCompany": "Company",
      "entityContact": "Person",
      "recommendation": {
        "strong": "Strong match",
        "possible": "Possible match",
        "weak": "Weak match",
        "none": "No match"
      },
      "rankLabel": "Rank {{rank}}"
    },
    "trace": {
      "title": "What the assistant did",
      "sectionLink": "Link",
      "sectionSearch": "Semantic search",
      "sectionSources": "Sources used",
      "sectionPortfolio": "Portfolio context",
      "linkContact": "Contact",
      "linkCompany": "Company",
      "linkProperty": "Property",
      "noLink": "no link",
      "searchHits": "Search {{count}} hits",
      "searchUsed": "{{count}} used",
      "searchNotRun": "Search not run",
      "query": "Query",
      "relevance": "Relevance {{pct}}%",
      "sourcesUsed": "{{count}} source(s) used",
      "noCrmContext": "no CRM context",
      "portfolioIncluded": "Portfolio data included",
      "portfolioRequested": "Portfolio requested but not included",
      "showWeakHits_one": "Show {{count}} more hit",
      "showWeakHits_other": "Show {{count}} more hits",
      "hideWeakHits": "Hide additional hits"
    },
    "aiUnavailable": "AI is not configured. Please add the API key under Admin > System.",
    "assignedTo": "Assigned to",
    "attachments": {
      "add": "Add attachment",
      "contextCount": "{{count}}/{{total}} in context",
      "deleted": "Attachment deleted",
      "excludedFromContext": "Not in context",
      "fileTooLarge": "File too large: {{name}}",
      "inContext": "In context",
      "uploadError": "Attachment could not be uploaded",
      "uploaded": "Attachment uploaded"
    },
    "backToTasks": "Back to tasks",
    "bccPlaceholder": "bcc@example.com",
    "ccPlaceholder": "cc1@example.com, cc2@example.com",
    "chatReset": "Chatverlauf zurückgesetzt",
    "chatResetError": "Chatverlauf konnte nicht zurückgesetzt werden",
    "chips": {
      "email": "Compose email",
      "followup": "Follow-up",
      "noContact": "No contact linked. Please assign a contact first.",
      "noEmail": "The contact has no email address on file.",
      "research": "Research contact",
      "summary": "Summary",
      "companyResearch": "Firma recherchieren"
    },
    "chunks": {
      "title": "Notes",
      "save": "Save as note",
      "alreadySaved": "Already saved as note",
      "saved": "Note saved",
      "saveError": "Could not save note",
      "delete": "Delete note",
      "deleted": "Note deleted",
      "deleteError": "Could not delete note",
      "deleteConfirm": "Really delete this note?",
      "empty": "No notes yet — pin chat answers to save knowledge",
      "sourceCompany": "Company",
      "sourcePerson": "Person",
      "sourceManual": "Manual",
      "sourceUserNote": "Note",
      "sourceEmailContext": "Email",
      "sourceAi": "AI",
      "sourceChat": "Chat",
      "emailNoSubject": "(No subject)",
      "emailFrom": "From:",
      "emailTo": "To:",
      "emailCc": "CC:",
      "emailExpand": "Expand email",
      "emailCollapse": "Collapse email",
      "addNote": "Add note",
      "edit": "Edit note",
      "expand": "Show more",
      "collapse": "Show less",
      "detach": "Remove link",
      "notePlaceholder": "Note for AI context (e.g. \"no video call\", \"write formally\") — Enter to save, Shift+Enter for new line",
      "noteHint": "Automatically used in AI context",
      "noteAdded": "Note saved",
      "noteAddError": "Could not save note",
      "pinFromChat": "Save as note",
      "pinnedFromChat": "Saved as note",
      "pinnedFromChatBadge": "Already saved as note",
      "pinFromChatError": "Could not save note",
      "researchSaved": "{{count}} research notes created",
      "researchSavedRaw": "Research saved as note",
      "researchSaveError": "Could not save research notes",
      "sourceAiResponse": "Chat reply",
      "sourceStrategyCards": "Strategy",
      "sourceChatCard": "Chat card",
      "sourceContract": "Contract",
      "sourceAppKnowledge": "App knowledge",
      "sourceCrmProfile": "CRM profile",
      "sourceDocument": "Document",
      "sourceResearchQuestion": "Research question",
      "sourceEmailSent": "Sent email",
      "sourceOfficialData": "Official data",
      "noteUpdated": "Note updated",
      "noteUpdateError": "Could not update note",
      "emptyWithNotes": "No notes yet — type a note above or pin chat answers",
      "scopeLocal": "Local (this task only)",
      "scopeLocalBadge": "Here only",
      "scopeAtProperty": "On property #{{id}}",
      "scopeAtPropertyLabel": "On property: {{label}}",
      "scopeAtContact": "On contact: {{name}}",
      "scopeAtContactId": "On contact #{{id}}",
      "scopeAtCompany": "On organisation: {{name}}",
      "scopeAtCompanyId": "On organisation #{{id}}",
      "pin": "Mark as relevant",
      "unpin": "Remove pin",
      "pinned": "Note pinned",
      "unpinned": "Pin removed",
      "pinError": "Could not pin note",
      "pinnedSection": "Pinned ({{count}})",
      "historyShow": "Show history ({{count}})",
      "historyHide": "Hide history",
      "historyBadge": "History",
      "historyBadgeHint": "Auto-saved from chat — not pinned as a note",
      "pinToCompany": "Pin to company",
      "pinToCompanyNamed": "Pin to company «{{name}}»",
      "pinToCompanyShort": "To company",
      "pinToContact": "Pin to contact",
      "pinToContactNamed": "Pin to contact «{{name}}»",
      "pinToContactShort": "To contact",
      "pinToProperty": "Pin to property",
      "pinToPropertyNamed": "Pin to property «{{label}}»",
      "pinToPropertyShort": "To property",
      "createContact": "Create contact in CRM",
      "createContactShort": "Contact",
      "createCompany": "Create organisation in CRM",
      "createCompanyShort": "Organisation",
      "createSubtask": "Create sub-task",
      "attachToExisting": "Attach to existing entry",
      "attachShort": "Attach",
      "dragHandle": "Move note",
      "dragHint": "Drag & drop notes into the target area — order determines the email layout",
      "pinnedEmptyDropHint": "Drag notes here to define the email order",
      "reorderSaved": "Order saved",
      "reorderError": "Order could not be saved",
      "a11yDragStart": "Note {{id}} is being dragged",
      "a11yDragOverPinned": "Note {{id}} over the target area",
      "a11yDragOverUnpinned": "Note {{id}} over the research area",
      "a11yDragEndPinned": "Note {{id}} dropped into target area",
      "a11yDragEndUnpinned": "Note {{id}} removed from target area",
      "a11yDragCancel": "Move cancelled",
      "pinnedToMain": "Pinned to main task",
      "convertedToSubtask": "→ Sub-task #{{id}}",
      "convertedToSubtaskHint": "Go to sub-task"
    },
    "clearContext": "Kontext-Auswahl leeren",
    "contextIncluded": "Pendenzen als Kontext",
    "contextView": {
      "agentPreview": "Was der CEO-Agent sieht",
      "ancestors": "Pfad im Baum",
      "inherited": "Vererbter Kontext",
      "own": "Eigener Kontext",
      "placeholder": "Kontext für diese Pendenz definieren...\\n\\nz.B. Warum existiert diese Aufgabe? Welche Informationen soll der CEO-Agent berücksichtigen?",
      "treeSelector": "Kontext-Auswahl im Baum"
    },
    "createdBy": "Created by",
    "creating": "Creating...",
    "edit": "Edit",
    "emailPreview": "Email Preview",
    "emailSettings": {
      "title": "Email Settings",
      "options": "Options",
      "tone": "Tone",
      "length": "Length",
      "purpose": "Purpose",
      "language": "Language",
      "contextHint": "Context: {{docs}} document(s), {{nodes}} task(s) selected. Controlled via the attachments and context selection.",
      "brief": "Brief",
      "briefPlaceholder": "What should the email achieve? (leave empty for context-only)",
      "recipient": "Recipient",
      "noRecipient": "No contact linked",
      "emailsInHistory": "{{count}} email(s) in history",
      "autoContext": {
        "pinnedKnowledge": "{{count}} pinned notes"
      },
      "create": "Create email",
      "fromContext": "Create email from goal and context",
      "tones": {
        "visionary": "Visionary",
        "pragmatic": "Pragmatic",
        "formal": "Formal"
      },
      "lengths": {
        "short": "Short",
        "medium": "Medium",
        "detailed": "Detailed"
      },
      "purposes": {
        "first_contact": "First contact",
        "follow_up": "Follow-up",
        "offer": "Offer",
        "forward": "Forward"
      },
      "languages": {
        "de": "German",
        "en": "English",
        "fr": "French",
        "it": "Italian"
      }
    },
    "error": "Error processing your request. Please try again.",
    "errorInvalidInput": "Invalid input — please try again.",
    "findings": "Erkenntnisse",
    "from": "From",
    "fromCompany": "Company",
    "fromDefault": "Default",
    "fromPrivate": "Private",
    "hierarchy": "Hierarchie",
    "hint": "Write freely — the agent helps with emails, research, follow-ups and more.",
    "noEmail": "No email generated yet. Ask the agent to compose an email.",
    "noResearch": "No research results. Ask the agent to research a contact or company.",
    "panel": {
      "actionPreview": "Aktions-Vorschau",
      "companyResearch": "AI Research",
      "contextView": "Kontext",
      "details": "Details",
      "email": "Email Preview",
      "findings": "Erkenntnisse",
      "overview": "Übersicht",
      "research": "Research",
      "subtasks": "Sub-Tasks",
      "treeDetail": "Baum-Navigation",
      "workflow": "Workflow",
      "contactOrg": "Contact/Company"
    },
    "panels": {
      "companyResearch": "KI Recherche",
      "details": "Details",
      "email": "E-Mail",
      "overview": "Übersicht",
      "research": "Recherche"
    },
    "participantHint": "Participants available as suggestions — type in CC field",
    "pinError": "Pin konnte nicht gesetzt werden",
    "pinRemoved": "Pin entfernt",
    "pinSaved": "Erkenntnis gespeichert",
    "placeholder": "Enter message...",
    "preview": "Preview",
    "removePin": "Pin entfernen",
    "researchPanel": {
      "keyPersons": "Schlüsselpersonen (aus Recherche)"
    },
    "richMarkdown": {
      "miniCardsLabel": "Structured data",
      "nextStepsTitle": "Next steps"
    },
    "saveInsight": "Als Erkenntnis speichern",
    "send": "Send",
    "sendError": "Email could not be sent.",
    "sendNow": "Send now",
    "sending": "Sending...",
    "sent": "Sent",
    "skills": {
      "actionError": "Aktion konnte nicht ausgeführt werden",
      "addNote": "Notiz erstellen",
      "companyUpdated": "Firmendaten aktualisiert",
      "contactUpdated": "Kontaktdaten aktualisiert",
      "createSubtask": "Sub-Pendenz erstellen",
      "enrichCompany": "Firma anreichern",
      "enrichContact": "Kontakt anreichern",
      "noteSaved": "Notiz gespeichert",
      "subtaskCreated": "Sub-Pendenz erstellt"
    },
    "skillChips": {
      "ariaLabel": "Skill for the next message",
      "modeHint": "Mode: {{mode}}",
      "research": "Research",
      "email": "Email",
      "companyResearch": "Research company",
      "personResearch": "Research person",
      "textGenerate": "Generate text",
      "contextResearch": "Research context",
      "emailDraft": "Draft email",
      "noteCreate": "Create note",
      "subtask": "Sub-task",
      "summarize": "Summarize",
      "matchInvestors": "AI buyers"
    },
    "researchType": {
      "label": "Research type",
      "auto": "auto-detected",
      "autoReset": "Auto-detect",
      "menuAria": "Choose research type",
      "deepRunning": "Deep research running …",
      "types": {
        "firmen_profil": "Company",
        "person": "Person",
        "produkt_api": "Product/API",
        "preise": "Pricing",
        "markt": "Market"
      }
    },
    "strategyPostIts": {
      "title": "Suggestions — as note",
      "subtitle": "Pin, create a sub-task or attach to a contact, company or property.",
      "types": {
        "research": "Research",
        "email": "Email",
        "note": "Note",
        "subtask": "Sub-task"
      },
      "actions": {
        "pin": "Pin to goal/context",
        "subtask": "Create sub-task",
        "attach": "Attach to contact / company / property",
        "attachShort": "Attach to…"
      },
      "pinned": "Suggestion pinned as note",
      "pinError": "Suggestion could not be pinned",
      "subtaskCreated": "Sub-task created",
      "subtaskError": "Sub-task could not be created",
      "attachError": "Attachment failed"
    },
    "postItCard": {
      "kinds": {
        "advice": "Advice",
        "strategy": "Strategy",
        "research": "Research",
        "fact": "Fact",
        "action": "Action"
      },
      "handled": "Done",
      "attachedTo": "📎 pinned to {{label}}",
      "actions": {
        "pin": "Pin",
        "subtask": "Sub-task",
        "attach": "Attach to…"
      },
      "notFound": "Note not found",
      "pinned": "Pinned as note",
      "pinError": "Card could not be pinned",
      "subtaskCreated": "Sub-task created",
      "subtaskError": "Sub-task could not be created",
      "attachError": "Attachment failed"
    },
    "statusChangeError": "Status konnte nicht geändert werden",
    "subject": "Subject",
    "subjectPlaceholder": "E-Mail-Betreff",
    "taskNotFound": "Task not found",
    "template": "Template",
    "progress": {
      "queued": "Preparing …",
      "elapsed": "{{seconds}}s",
      "longRunning": "Extended research is running – the result will appear automatically. You can cancel at any time."
    },
    "thinking": "Thinking...",
    "to": "To",
    "treeNav": {
      "addToContext": "Zum Kontext hinzufügen",
      "contextSelected": "im Kontext ausgewählt",
      "hint": "Klick = Details, Doppelklick = Öffnen",
      "navigateTo": "Zur Pendenz navigieren",
      "noHierarchy": "Keine Hierarchie verfügbar",
      "openTask": "Pendenz öffnen",
      "removeFromContext": "Aus Kontext entfernen",
      "selectHint": "Klicke auf einen Eintrag im Baum, um die Details zu sehen.",
      "title": "Pendenzen-Baum"
    },
    "ttsError": "Read-aloud failed.",
    "ttsPlay": "Read answer aloud",
    "ttsStop": "Stop reading",
    "voiceDenied": "Microphone access denied. Please allow it in your browser settings.",
    "voiceError": "Speech recognition error.",
    "voiceMaxDurationHint": "Max. {{minutes}} min",
    "voiceMicError": "Microphone could not be activated.",
    "voiceNoSpeech": "No speech detected. Please try again.",
    "voiceNotSupported": "Voice input is not supported in this browser. Please use Chrome or Edge.",
    "voiceStart": "Start voice input",
    "voiceStop": "Stop recording",
    "voiceTimeout": "Recording too long – transcription timed out. Please make shorter recordings.",
    "voiceTooLong": "Recording too long (max. 25 MB / ~25 min). Please make shorter recordings.",
    "voiceTranscribing": "Transcribing...",
    "voiceTranscribingShort": "Transcribing…",
    "welcome": "What would you like to do with this task?",
    "workflow": {
      "advanceError": "Workflow-Schritt konnte nicht fortgesetzt werden",
      "completed": "Workflow abgeschlossen!",
      "startError": "Workflow konnte nicht gestartet werden"
    },
    "pinTarget": {
      "title": "Where to pin?",
      "description": "You're in a sub-task. Choose which task the note should appear in.",
      "sub": "To this sub-task",
      "main": "To the main task",
      "mainFallback": "Main task"
    },
    "company": "Company",
    "contact": "Contact",
    "property": "Property",
    "noContactLinked": "No contact or company linked.",
    "demoMessage": {
      "label": "Message from the prospect"
    }
  },
  "changelog": {
    "title": "What's New",
    "typeFixed": "Fixed",
    "typeImproved": "Improved",
    "typeNew": "New"
  },
  "chunkAttach": {
    "attachAction": "Attach to entity",
    "attachError": "Could not link note",
    "attached": "Note linked",
    "badgeCompany": "Organization",
    "badgeContact": "Contact",
    "badgeProperty": "Property",
    "badgeTask": "Task",
    "detachConfirm": "Really remove this link?",
    "detachError": "Could not remove link",
    "detachHint": "Click to remove",
    "detached": "Link removed",
    "minChars": "Enter at least 2 characters",
    "noResults": "No results found",
    "searchCompany": "Search organization...",
    "searchContact": "Search contact...",
    "searchProperty": "Search property...",
    "startTyping": "Start typing to search.",
    "subtitle": "Which entity should the note be linked to?",
    "tabCompany": "Organization",
    "tabContact": "Contact",
    "tabProperty": "Property",
    "tabsAriaLabel": "Select entity type",
    "title": "Attach note"
  },
  "createFromChunk": {
    "headerContact": "Create contact in CRM",
    "headerCompany": "Create organization in CRM",
    "subtitle": "From this note",
    "chunkSource": "Note",
    "parsing": "Analyzing note...",
    "parseError": "Could not analyze note.",
    "parseFailed": "Analysis failed",
    "parsedContact": "Detected contact",
    "parsedCompany": "Detected organization",
    "unnamed": "Unnamed",
    "possibleDuplicates": "Possible duplicates ({{count}})",
    "duplicateHint": "Entries with this name already exist. Choose an action:",
    "actionMerge": "Merge",
    "actionAttach": "Attach as note",
    "actionCreateContact": "Create contact",
    "actionCreateCompany": "Create organization",
    "actionCreateAnyway": "Create new anyway",
    "created": "New entry has been created.",
    "createdToast": "Entry created",
    "createError": "Could not create entry",
    "merged": "Entry has been updated with new information.",
    "mergedToast": "Entry enriched with new info",
    "mergeError": "Enrichment failed",
    "attached": "Note has been attached.",
    "attachedToast": "Attached as note",
    "attachError": "Attaching failed",
    "success": "Done!"
  },
  "commissions": {
    "chart": {
      "atPrice": "at",
      "commission": "Fee",
      "rate": "Eff. Rate",
      "title": "Fee Curve"
    },
    "default": "Default",
    "loading": "Loading fee models...",
    "settings": {
      "addBracket": "Add bracket",
      "bracketFrom": "From",
      "bracketRate": "Rate",
      "bracketTo": "To",
      "brackets": "brackets",
      "bracketsHint": "The first bracket always starts at CHF 0. Each rate applies only to the amount within its bracket.",
      "bracketsLabel": "Marginal Brackets",
      "createNew": "New Model",
      "createSuccess": "Fee model created successfully",
      "createTitle": "Create Fee Model",
      "default": "Default",
      "defaultBadge": "Default",
      "deleteConfirm": "Do you really want to delete the model \"{{name}}\"? This action cannot be undone.",
      "deleteError": "Error deleting fee model",
      "deleteSuccess": "Fee model deleted successfully",
      "deleteTitle": "Delete Fee Model",
      "editTitle": "Edit Fee Model",
      "flatRate": "Flat Rate",
      "namePlaceholder": "e.g. Standard Marginal Model",
      "noModels": "No fee models found",
      "rate": "Rate / Brackets",
      "saveError": "Error saving fee model",
      "setActive": "Active",
      "setDefault": "Set as default model",
      "subtitle": "Create and manage fee models for contracts",
      "title": "Fee Models",
      "type": "Type",
      "typeHints": {
        "FLAT": "Single rate",
        "MARGINAL": "Degressive brackets"
      },
      "types": {
        "FLAT": "Flat Rate",
        "MARGINAL": "Marginal"
      },
      "updateSuccess": "Fee model updated successfully"
    },
    "source": {
      "appendix_b": "Appendix B",
      "property": "Property",
      "framework": "Framework agreement",
      "default": "Standard",
      "none": "None",
      "hint": "Source of the applicable terms: {{source}}"
    }
  },
  "common": {
    "actions": "Actions",
    "active": "Active",
    "add": "Add",
    "address": "Address",
    "all": "All",
    "back": "Back",
    "cancel": "Cancel",
    "check": "Check",
    "city": "Ort",
    "clearFilters": "Clear filters",
    "clearSelection": "Clear selection",
    "close": "Close",
    "confirm": "Confirm",
    "copy": "Kopieren",
    "create": "Create",
    "createNew": "Create new",
    "date": "Date",
    "days": "days",
    "delete": "Delete",
    "deleted": "Removed",
    "description": "Description",
    "deselectAll": "Deselect all",
    "details": "Details",
    "done": "Done",
    "download": "Herunterladen",
    "edit": "Edit",
    "email": "Email",
    "employees": "Mitarbeiter",
    "error": "Error",
    "export": "Export",
    "field": "Field",
    "filter": "Filter",
    "filtered": "filtered",
    "firstName": "Vorname",
    "import": "Import",
    "inactive": "Inactive",
    "industry": "Branche",
    "info": "Info",
    "languages": {
      "de": "Deutsch",
      "en": "English",
      "fr": "Français",
      "it": "Italiano"
    },
    "lastName": "Nachname",
    "less": "Less",
    "linkedin": "LinkedIn",
    "loading": "Loading...",
    "location": "Standort",
    "merge": "Merge",
    "more": "More",
    "name": "Name",
    "new": "NEU",
    "next": "Next",
    "no": "No",
    "noResults": "No results",
    "none": "None",
    "notFound": "Nicht gefunden",
    "notes": "Notes",
    "nothingRecorded": "Nothing recorded yet",
    "phone": "Phone",
    "pin": "Pin",
    "position": "Position",
    "preview": "Preview",
    "previous": "Previous",
    "refresh": "Refresh",
    "refreshed": "Aktualisiert",
    "remove": "Remove",
    "required": "Required field",
    "reset": "Reset",
    "resizeColumn": "Resize column (double-click to reset)",
    "resizePanes": "Resize panes (use arrow keys to adjust)",
    "retry": "Retry",
    "revenue": "Umsatz",
    "save": "Save",
    "saveAndClose": "Save and close",
    "saved": "Saved",
    "saving": "Saving...",
    "saveStatus": {
      "idle": "Synced",
      "pending": "Unsaved changes",
      "saving": "Saving…",
      "saved": "Saved",
      "error": "Save failed"
    },
    "unsavedChanges": {
      "title": "Unsaved changes",
      "description": "You have unsaved changes. Discard them and close?",
      "discard": "Discard & close",
      "keepEditing": "Keep editing"
    },
    "search": "Search",
    "select": "Please select",
    "selectAll": "Select all",
    "showAll": "Show all",
    "skip": "Skip",
    "status": "Status",
    "street": "Strasse",
    "success": "Success",
    "uid": "UID",
    "unknown": "Unbekannt",
    "unknownError": "Unknown error",
    "unpin": "Unpin",
    "view": "View",
    "warning": "Warning",
    "website": "Website",
    "yes": "Yes",
    "zip": "PLZ",
    "optional": "Optional",
    "print": "Drucken",
    "clear": "Clear"
  },
  "companies": {
    "merge": {
      "activities": "Activities",
      "campaigns": "Campaigns",
      "clickToSelect": "Click a value to select it",
      "contacts": "Contacts",
      "contracts": "Contracts",
      "dataMergeDirection": "Daten werden in die Hauptfirma uebernommen",
      "emailAccounts": "Email accounts",
      "emails": "Email addresses",
      "investorGroups": "Investor groups",
      "listings": "Listings",
      "mergeButton": "Merge",
      "offers": "Offers",
      "phones": "Phone numbers",
      "previewError": "The comparison could not be loaded",
      "previewFailed": "Preview failed.",
      "properties": "Properties",
      "relatedRecords": "Linked records",
      "secondaryDeactivated": "Secondary organisations are deactivated, not deleted.",
      "tasks": "Tasks",
      "companiesSelected": "{{count}} organisations selected"
    },
    "name": "Company name"
  },
  "company": {
    "all": "All Companies",
    "count": "{{count}} Companies",
    "done": "Done",
    "filter": "Company Filter",
    "noSelection": "No Company",
    "switch": "Switch Company",
    "switchError": "Could not switch company"
  },
  "companyContacts": {
    "columns": {
      "actions": "Actions",
      "email": "Email",
      "functions": "Function(s)",
      "name": "Name",
      "organisation": "Organisation",
      "signature": "Signature",
      "source": "Source",
      "status": "Status",
      "verified": "Verified"
    },
    "duplicate": {
      "dialogLabel": "Merge contacts",
      "hint": "Possibly the same person",
      "merge": "Merge",
      "mergeSuccess": "Contacts merged",
      "mergeWith": "Merge with {{name}}",
      "notSame": "Not the same person",
      "notSameAs": "Not the same person as {{name}}",
      "notSameSaved": "Saved as different people",
      "reasonFirstName": "Same last name, similar first name",
      "reasonInitial": "Same last name, matching initial"
    },
    "filters": {
      "active": "Active",
      "import": "Import",
      "inactive": "Inactive",
      "label": "Filter contacts",
      "labelCompanies": "Filter organisations",
      "manual": "Manual",
      "search": "Search contacts",
      "searchCompanies": "Search organisations",
      "withoutEmail": "Without email",
      "zefix": "Commercial register"
    },
    "functions": {
      "add": "Add function",
      "empty": "No function recorded",
      "listLabel": "Recorded functions",
      "remove": "Remove function \"{{name}}\""
    },
    "groups": {
      "inactive": "Inactive ({{count}})",
      "other": "Other contacts",
      "otherCompanies": "Other organisations",
      "register": "Authorised signatories (commercial register)",
      "registerCompanies": "Authorised to sign (commercial register)"
    },
    "noResults": "No contacts match these filters",
    "noResultsCompanies": "No organisations match these filters",
    "removeCompany": "Remove organisation",
    "removeFromContact": "remove from this contact?",
    "tableCaption": "Contacts of this organisation",
    "tableCaptionCompanies": "Organisations of this contact",
    "verified": "Verified",
    "verifiedOn": "Verified on {{date}}"
  },
  "companyDedup": {
    "fieldComparison": "Field comparison",
    "loadingPreview": "Loading comparison...",
    "mergeSuccess": "Organisations merged successfully",
    "mergeTitle": "Merge organisations"
  },
  "companyLookup": {
    "address": "Adresse",
    "createError": "Kontakte konnten nicht erstellt werden",
    "creating": "Kontakte werden erstellt...",
    "legalForm": "Rechtsform",
    "noSignatories": "Keine Zeichnungsberechtigten gefunden",
    "noSignatoriesHint": "Die SHAB-Daten für diese Firma sind nicht verfügbar (ältere Firmen oder fehlende Publikationen). Bitte tragen Sie die Zeichnungsberechtigten manuell ein.",
    "purpose": "Zweck",
    "searchLabel": "Firma aus Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "uid": "UID"
  },
  "companyRelations": {
    "add": "Link",
    "added": "Organisation linked",
    "addTitle": "Link organisation",
    "auditedBy": "Auditor",
    "audits": "audits",
    "confirmDelete": "Really remove this link?",
    "editTitle": "Edit link",
    "empty": "No linked organisations yet",
    "emptyHint": "Link organisations that belong together (e.g. parent/subsidiary, partner or sister company).",
    "loadFailed": "Could not load links",
    "notesLabel": "Note",
    "notesPlaceholder": "Optional note about the relation (e.g. subsidiary, sister company)...",
    "removed": "Link removed",
    "targetLabel": "Organisation",
    "title": "Linked organisations",
    "types": {
      "auditor": "Auditor",
      "customer": "Customer",
      "other": "Other",
      "parent_subsidiary": "Parent/subsidiary",
      "partner": "Partner",
      "predecessor": "Predecessor",
      "sister": "Sister company",
      "supplier": "Supplier"
    },
    "updated": "Link updated"
  },
  "companyResearch": {
    "approveError": "Fehler beim Anlegen",
    "approved": "Firma und Kontakte wurden angelegt",
    "approving": "Wird angelegt...",
    "extracting": "Extrahiere Firma und Kontakte...",
    "unknownCompany": "Firma",
    "openFullProfile": "Vollständiges Profil anzeigen",
    "companyDraft": "Firma-Entwurf",
    "name": "Firmenname",
    "legalForm": "Rechtsform",
    "street": "Strasse",
    "houseNr": "Nr.",
    "zip": "PLZ",
    "city": "Ort",
    "canton": "Kanton",
    "website": "Website",
    "phone": "Telefon",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "role": "Funktion",
    "results": "Recherche-Ergebnis",
    "contacts": "Kontakte",
    "addContact": "Kontakt hinzufügen",
    "approve": "Firma + Kontakte anlegen",
    "empty": "Keine KI-Recherche vorhanden. Frage den Agenten, eine Firma oder Person zu recherchieren."
  },
  "contactDedup": {
    "assignCompany": "Assign additional company (optional)",
    "backToScan": "Back to scan",
    "companySection": "Company Associations",
    "companySectionDesc": "All company links will be transferred to the primary contact.",
    "companyWillBeAssigned": "Will be assigned after merge",
    "contactsAffected": "Affected contacts",
    "empty": "(leer)",
    "executeMerge": "Merge",
    "field": "Feld",
    "fieldComparison": "Field comparison",
    "fieldComparisonDesc": "Choose which value to keep for each field.",
    "groupsFound": "Duplicate groups",
    "loadingCompanies": "Loading companies...",
    "loadingPreview": "Vergleich wird geladen...",
    "merge": "Merge",
    "mergeError": "Error during merge:",
    "mergeSuccess": "Contacts merged successfully!",
    "mergeWarning": "Secondary contacts will be deactivated (not deleted).",
    "minScore": "Min. score",
    "noCompanyLinks": "No company associations found",
    "noDuplicates": "No duplicates found",
    "noDuplicatesDesc": "All contacts are unique.",
    "primaryContact": "Primary contact",
    "related": {
      "activities": "Activities",
      "campaignRecipients": "Kampagnen-Empfänger",
      "companyAssignments": "Firmen-Zuordnungen",
      "contracts": "Verträge",
      "emailAddresses": "E-Mail-Adressen",
      "infoOwners": "Info permissions",
      "investorGroups": "Investor groups",
      "knowledgeChunks": "Knowledge sections",
      "notifications": "Benachrichtigungen",
      "propertyRefs": "Property links",
      "signatures": "Unterschriften",
      "syncedEmails": "Synced emails",
      "tags": "Tags",
      "tasks": "Pendenzen",
      "tokens": "Access links",
      "userAccount": "User account"
    },
    "relatedSection": "Will be transferred",
    "relatedSectionDesc": "These records of the secondary contacts will be moved to the primary contact.",
    "scan": "Find duplicates",
    "scanMore": "Find more duplicates",
    "searchCompany": "Search and assign company...",
    "selectPrimary": "Select primary contact",
    "selectPrimaryDesc": "The primary contact will be kept. All others will be merged.",
    "setAsPrimary": "Als Hauptkontakt",
    "source": "Source",
    "step1": "Find duplicates",
    "step2": "Review & merge",
    "step3": "Result",
    "subtitle": "Detect and merge duplicates",
    "title": "Contact deduplication",
    "totalContacts": "Total contacts",
    "userAccountConflictDesc": "A contact may only have one user account, so the merge is rejected. Deactivate one of the two accounts first, or choose the contact with the desired account as the primary contact.",
    "userAccountConflictTitle": "Both contacts have a user account"
  },
  "contactImport": {
    "backToOverview": "Back to overview",
    "clickToExclude": "Klicke auf einen Kontakt um ihn vom Import auszuschliessen.",
    "confirmImport": "Import bestätigen",
    "connected": "Connected",
    "continueImport": "Import fortsetzen",
    "duplicates": "Duplikate",
    "enrichExisting": "Bestehende anreichern:",
    "enrichableLabel": "Anreicherbar",
    "errorLoading": "Fehler beim Laden",
    "finishAnyway": "Trotzdem abschliessen",
    "goToContacts": "Zu den Kontakten",
    "goToSettings": "Go to settings",
    "google": {
      "checkAccount": "Bitte Google-Konto prüfen.",
      "contacts": "Google Kontakte",
      "enrichExisting": "Bestehende Kontakte mit Google-Daten anreichern",
      "loading": "Google Kontakte werden geladen...",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Google-Konto in Immotron.",
      "title": "Google Kontakte importieren",
      "titleShort": "Google Import"
    },
    "importButton": "Import",
    "importComplete": "Import abgeschlossen",
    "importFailed": "Import fehlgeschlagen",
    "importNow": "Jetzt importieren",
    "importing": "Importiere...",
    "inImmotron": "In Immotron",
    "inactive": "Inactive",
    "linkedinDesc": "JSON upload or browser extension",
    "microsoft": {
      "allFolders": "Alle Ordner (empfohlen)",
      "allFoldersHint": "Durchsucht das gesamte Postfach — alle Kontaktordner ab Root rekursiv",
      "backToFolders": "Zurück zur Ordnerübersicht",
      "changeFolder": "Ordner wechseln",
      "checkAccount": "Bitte Microsoft-Konto prüfen.",
      "chooseAnotherFolder": "Anderen Ordner wählen",
      "chooseFolderHint": "Wähle den Kontaktordner oder nutze «Alle Ordner» um das gesamte Postfach ab Root rekursiv zu durchsuchen.",
      "contacts": "Microsoft Kontakte",
      "empty": "Leer",
      "emptyFolderHint": "Der gewählte Ordner ist leer — versuche «Alle Ordner» um das gesamte Postfach zu durchsuchen.",
      "enrichExisting": "Bestehende Kontakte mit Microsoft-Daten anreichern",
      "expiredHint": "Die Microsoft-Verbindung ist abgelaufen — verbinde dein Konto unter Einstellungen neu.",
      "includeSubfolders": "Unterordner einschliessen",
      "includeSubfoldersHint": "Beim Import eines Ordners werden auch alle darunter liegenden Ordner durchsucht.",
      "loading": "Microsoft Kontakte werden geladen...",
      "loadingFolders": "Kontaktordner werden geladen...",
      "noContactsFound": "Keine Kontakte gefunden",
      "noContactsHint": "Dieser Ordner enthält keine Kontakte. Das kann folgende Gründe haben:",
      "reconnectAccount": "Konto neu verbinden",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Microsoft 365 Konto in Immotron.",
      "title": "Microsoft 365 Kontakte importieren",
      "titleShort": "Microsoft Import",
      "tokenExpired": "Microsoft-Verbindung abgelaufen",
      "tokenExpiredDetail": "Der Zugriff auf dein Microsoft-Konto ist abgelaufen. Bitte verbinde dein Konto unter Einstellungen neu und versuche es erneut."
    },
    "needsReauth": "Reconnect required",
    "newContacts": "Neue Kontakte",
    "newContactsToImport": "Neue Kontakte importieren:",
    "newImport": "Neu importieren",
    "nextConfirm": "Weiter: Import bestätigen",
    "nextReview": "Weiter: Kontakte prüfen",
    "noAccounts": "No email accounts connected",
    "noAccountsHint": "Connect a Google or Microsoft account in Settings → Email Accounts to import contacts.",
    "noEmail": "Ohne E-Mail",
    "noLastName": "Ohne Nachnamen",
    "noLastNameBadge": "Kein Nachname",
    "noLastNameDescription": "Diese Kontakte haben keinen Nachnamen und werden standardmässig nicht importiert. Klicke um einzelne hinzuzufügen.",
    "notInImmotron": "noch nicht in Immotron",
    "onlyInImmotron": "Nur in Immotron",
    "partiallyDone": "Import teilweise abgeschlossen",
    "progressSoFar": "Bisheriger Fortschritt:",
    "refresh": "Refresh",
    "selectSeparately": "separat auswählbar",
    "skipped": "Übersprungen:",
    "steps": {
      "analyze": "Analysieren",
      "done": "Fertig",
      "folders": "Ordner",
      "import": "Import",
      "review": "Prüfen"
    },
    "subtitle": "Import contacts from connected accounts or LinkedIn",
    "summary": "Import-Zusammenfassung",
    "title": "Contact Import"
  },
  "contacts": {
    "addAddress": "Add address",
    "addCompany": "Add Organization",
    "addContact": "New Contact",
    "addInfoOwner": "Add info owner",
    "newContactPlaceholder": "New Contact",
    "addTagPlaceholder": "Add tag...",
    "address": "Address",
    "addressAdded": "Address added",
    "addressCity": "City",
    "addressCountry": "Country",
    "addressRemoved": "Address removed",
    "addressStreet": "Street",
    "addressZip": "ZIP",
    "allCompanies": "All Companies",
    "allTags": "Tags",
    "alreadyRecorded": "Already recorded",
    "privatePerson": "Person",
    "assignedViaCompanies": "Über Firmen zugeordnet",
    "birthday": "Birthday",
    "companies": "Organizations",
    "company": "Company",
    "companyAdded": "Organization added successfully",
    "companyAssignments": "Firmenzuordnungen",
    "companyCreated": "Company created from Zefix",
    "companyOnly": "Company only",
    "companyRemoved": "Association removed",
    "companyRoles": "Organization Associations",
    "companyUpdated": "Association updated",
    "confirmDelete": "Are you sure you want to delete this contact?",
    "confirmRemoveCompany": "Are you sure you want to remove this association?",
    "contact": "Kontakt",
    "createNewCompany": "Create as company: «{{query}}»",
    "createNewPerson": "Create as person: «{{query}}»",
    "createSuccess": "Contact created successfully",
    "createUser": "Create User",
    "createdAt": "Created",
    "creatingCompany": "Creating company...",
    "currentPosition": "Aktuelle Position",
    "deleteContact": "Delete Contact",
    "deleteSuccess": "Contact deleted successfully",
    "detailsLoadFailed": "Could not load company details",
    "directlyAssigned": "Direkt zugeordnet",
    "duplicateBannerHint": "Review and merge if needed.",
    "duplicateBannerMany": "{{count}} possible duplicates",
    "duplicateBannerOne": "1 possible duplicate",
    "duplicateCheckAria": "Check duplicate {{name}}",
    "editContact": "Edit Contact",
    "email": "Email",
    "emailOptional": "E-Mail (optional)",
    "emailStatuses": {
      "BOUNCED": "Bounced",
      "CLICKED": "Clicked",
      "DELIVERED": "Delivered",
      "FAILED": "Failed",
      "OPENED": "Opened",
      "PENDING": "Pending",
      "SENT": "Sent"
    },
    "emails": {
      "campaign": "Campaign",
      "contract": "Contract",
      "empty": "No emails sent",
      "property": "Property",
      "resend": "Resend",
      "resendSuccess": "Email has been resent",
      "source": "Source",
      "subject": "Subject",
      "title": "Emails"
    },
    "existingCompanies": "Existing companies",
    "firstName": "First Name",
    "function": "Funktion",
    "functionPlaceholder": "e.g. Managing Director",
    "gender": "Gender",
    "genderFemale": "Female",
    "genderMale": "Male",
    "genderNotSet": "Not specified",
    "googleImport": "Google Import",
    "hasAccount": "Active",
    "import": "Import",
    "infoOwnerAdded": "Info owner added",
    "infoOwnerRemoved": "Info owner removed",
    "infoOwners": "Info Owners",
    "langDe": "Deutsch",
    "langEn": "English",
    "langFr": "Français",
    "langIt": "Italiano",
    "languageAuto": "Automatic (German)",
    "lastName": "Last Name",
    "lastNameRequired": "Nachname *",
    "localOnly": "Local",
    "location": "Ort",
    "manuallySelected": "Manuell ausgewählt",
    "markVerified": "Mark as verified",
    "merge": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "contact": "Kontakt",
      "createAndImport": "Neu erstellen & Importieren",
      "enrichCompany": "Bestehende Firma wird mit neuen Infos ergänzt (leere Felder)",
      "enrichContact": "Bestehender Kontakt wird mit neuen Infos ergänzt",
      "existingRecord": "Bestand (Immotron)",
      "field": "Feld",
      "leadResearch": "Lead (Recherche)",
      "loadingComparison": "Lade Vergleichsdaten...",
      "match": "Übereinstimmung",
      "matchLabel": "Match",
      "mergeAndImport": "Zusammenführen & Importieren",
      "newEntry": "Neuer Eintrag",
      "researchExtras": "Zusatzinfos aus der Recherche",
      "source": "Quelle",
      "subtitleCompare": "Prüfe die Übereinstimmung vor dem Import",
      "subtitleNew": "Kein bestehendes Match gefunden — wird neu erstellt",
      "titleCompare": "Lead importieren — Vergleich",
      "titleNew": "Lead als neu importieren",
      "whatHappens": "Was passiert beim Import?",
      "willBeCreated": "wird neu erstellt",
      "willBeCreatedShort": "Wird neu erstellt"
    },
    "mergeSuccess": "Kontakte erfolgreich zusammengeführt",
    "metadata": "Metadata",
    "microsoftImport": "Microsoft Import",
    "name": "Name",
    "noAccount": "No Account",
    "noCompanies": "No organisation assignments",
    "noCompaniesFound": "No companies found",
    "noCompanyAssignment": "Keine Firmenzuordnung",
    "noCompanyAssignmentHint": "Fügen Sie eine Firma hinzu, um Rollen und Zeichnungsrechte zu definieren.",
    "noContacts": "No contacts found",
    "noContactsFound": "Keine Kontakte gefunden",
    "noLinkedinData": "Keine LinkedIn-Daten",
    "noLinkedinDataHint": "Dieser Kontakt wurde noch nicht mit LinkedIn synchronisiert.",
    "noTags": "No tags",
    "notes": "Notes",
    "notesPlaceholder": "Internal notes about the contact...",
    "openProfile": "Profil öffnen",
    "owner": "Primary Owner",
    "ownerAll": "All owners",
    "personsRegistered": "{{count}} registered persons",
    "phone": "Phone",
    "position": "Position",
    "possibleDuplicate": "Mögliches Duplikat",
    "possibleDuplicates": "Mögliche Duplikate",
    "preferredLanguage": "Language",
    "primaryAddress": "Primary address",
    "rawDataJson": "Rohdaten (JSON)",
    "reSyncPending": "Re-Sync angefordert",
    "reSyncRequested": "Re-Sync angefordert. Starten Sie einen neuen Sync im LinkedIn Scraper.",
    "requestReSync": "Re-Sync anfordern",
    "resultsLabel": "Contacts",
    "searchCompanyPlaceholder": "Search company...",
    "searchContact": "Search contact...",
    "searchCriteria": {
      "areaRange": "Area m²",
      "areaRangePlaceholder": "e.g. 800–2,500",
      "cantons": "Cantons",
      "condition": "Condition",
      "constructionYear": "Year built",
      "constructionYearPlaceholder": "e.g. from 1990 or new build",
      "decisionProcess": "Decision process",
      "energyRequirements": "Energy / sustainability",
      "excluded": "Excluded",
      "grossYieldMin": "Gross yield min.",
      "grossYieldMinPercent": "Gross yield min. (%)",
      "location": "Location",
      "locationNotes": "Location notes",
      "macro": "Macro",
      "macroLocation": "Macro location",
      "micro": "Micro",
      "microLocation": "Micro location",
      "minUnits": "Minimum size",
      "minUnitsPlaceholder": "e.g. 6 apartments",
      "netYieldTarget": "Target net yield",
      "noGos": "No-gos",
      "price": "Price (CHF million)",
      "priceMax": "Price max. (CHF million)",
      "priceMin": "Price min. (CHF million)",
      "priceMinHard": "Exclude below min. price (hard limit)",
      "priceNotes": "Price note",
      "propertyTypes": "Property types",
      "regions": "Regions",
      "sought": "Sought",
      "specialRequirements": "Special requirements",
      "timeline": "Timeline"
    },
    "searchFailed": "Search failed",
    "searchNameOrEmail": "Name oder E-Mail suchen...",
    "searchPlaceholder": "Search by name or email...",
    "selectCompany": "Firma wählen...",
    "selectMergeTarget": "Kontakt zum Zusammenführen auswählen",
    "sendPasswordReset": "Send password reset",
    "setPrimary": "Set as primary",
    "showCampaignContacts": "Campaign contacts",
    "signature": "Signature",
    "signatureCollectiveMore": "Kollektivunterschrift zu mehreren",
    "signatureCollectiveTwo": "Kollektivunterschrift zu zweit",
    "signatureNone": "Keine",
    "signatureSingle": "Einzelunterschrift",
    "signatureType": "Zeichnungsberechtigung",
    "signatures": "Signatures",
    "source": "Quelle",
    "sourceAll": "Source",
    "sourceCampaign": "Campaign",
    "sourceGoogle": "Google",
    "sourceLabel": "Source",
    "sourceManual": "Manual",
    "subtitle": "All authorized signatories and contact persons",
    "syncStatus": "Sync Status",
    "synced": "Synchronisiert",
    "contracts": {
      "empty": "No contracts available",
      "propertyLabel": "Property"
    },
    "tabs": {
      "addressContact": "Adresse & Kontakt",
      "companies": "Organizations",
      "contracts": "Contracts",
      "knowledge": "Knowledge",
      "linkedin": "LinkedIn",
      "masterData": "Stammdaten",
      "notes": "Notizen",
      "responsibility": "Zuständigkeit"
    },
    "tagAdded": "Tag assigned",
    "tagRemoved": "Tag removed",
    "tags": "Tags",
    "title": "Contacts",
    "tryZefix": "Search in Zefix",
    "typeNameOrEmail": "Tippen Sie einen Namen oder eine E-Mail-Adresse...",
    "unverified": "Not verified",
    "updateSuccess": "Contact updated successfully",
    "userAccount": "User Account",
    "verified": "Verified",
    "verifiedSuccess": "Association verified",
    "verifiedVia": "Verified via",
    "website": "Website",
    "withUser": "With User Account",
    "withUserOnly": "With user only",
    "withoutUser": "Without User Account",
    "zefixSearch": "Zefix search",
    "zefixSearchPlaceholder": "Search company in Zefix (name or UID)...",
    "phoneAdded": "Telefonnummer hinzugefuegt",
    "phoneRemoved": "Telefonnummer entfernt",
    "phones": "Telefonnummern",
    "noCompanyAssigned": "Keine Firma zugeordnet",
    "addresses": "Adressen",
    "researchSuccess": "Recherche abgeschlossen",
    "researchFailed": "Recherche fehlgeschlagen",
    "researching": "Recherchiere...",
    "startResearch": "KI-Recherche starten",
    "researchError": "Recherche fehlgeschlagen. Bitte erneut versuchen.",
    "researchResult": "Recherche-Ergebnis",
    "lastResearch": "Letzte Recherche",
    "noResearchYet": "Noch keine KI-Recherche durchgeführt",
    "researchDescription": "Perplexity durchsucht das Web nach Informationen zu dieser Person",
    "infoOwnerRole": "Info",
    "noOwner": "-- No primary owner --",
    "notesAutoSaveHint": "Changes are saved automatically.",
    "removeInfoOwner": "Remove info owner"
  },
  "contractTermination": {
    "clause": "Clause",
    "clauseLabel": "Violated Clause (optional)",
    "confirmButton": "Terminate now",
    "confirmSummary": "Summary:",
    "contract": "Contract",
    "description": "Contract {{number}} will be terminated. Please provide a reason.",
    "error": "Error terminating contract",
    "reason": "Reason",
    "reasonLabel": "Reason",
    "reasonPlaceholder": "Describe the reason for termination...",
    "reasonRequired": "Please provide a reason",
    "selectClause": "-- Select clause --",
    "success": "Contract has been terminated",
    "title": "Terminate Contract",
    "warningText": "After termination, all protection clauses (§6 Contact Protection, §7 Contractual Penalty) remain in effect for an additional 6 months.",
    "warningTitle": "Note: Run-off period applies"
  },
  "contractWizard": {
    "errors": {
      "generateFailed": "Failed to generate contract",
      "loadCompaniesFailed": "Failed to load companies",
      "loadSignatoriesFailed": "Failed to load signatories",
      "noCompany": "Please select a company",
      "noPartner": "Please specify a contract partner",
      "noPartnerContact": "Please select a signatory for the contract partner",
      "noRoles": "Please select at least one role",
      "noSignatories": "Please select at least one signatory"
    },
    "hidePreview": "Hide preview",
    "navigation": {
      "back": "Back",
      "cancel": "Cancel",
      "next": "Next"
    },
    "showPreview": "Show preview",
    "signatories": {
      "loading": "Loading signatories...",
      "none": "No signatories available",
      "subtitle": "Select the signatories for this contract",
      "title": "Signatories"
    },
    "step1": {
      "loading": "Loading companies...",
      "subtitle": "Choose the company issuing the contract",
      "title": "Select Company"
    },
    "step2": {
      "city": "City",
      "contactName": "Contact Person (Signatory)",
      "email": "Email",
      "manualEntry": "Manual entry",
      "name": "Name / Company",
      "partnerSignatory": "Partner Signatories",
      "partnerSignatoryHint": "For collective signatures, select multiple persons.",
      "searchPartner": "Search contract partner (person/company — CRM & Zefix)",
      "searchPartnerPlaceholder": "Search by name, company or Zefix...",
      "searchPartnerHint": "Searches CRM contacts, CRM companies and the Zefix commercial register. Not found? Create a new CRM record directly.",
      "creatingPartner": "Creating contract partner in the CRM...",
      "partnerCreated": "Contract partner created in the CRM",
      "partnerCreateFailed": "Contract partner could not be created",
      "personBadge": "Private person (CRM)",
      "companyBadge": "Company (CRM/Zefix)",
      "personIsSignatory": "This person is the signatory of the contract.",
      "signerEmail": "Signatory email",
      "emailSavedToCrm": "Email saved to the CRM",
      "sourceCrm": "In CRM",
      "sourceZefixNew": "Zefix — not yet in CRM",
      "sourceCrmGone": "In CRM — no longer in the register",
      "noSignatoriesFound": "No signatories found. Please add one in the CRM first.",
      "searchCompany": "Search company (Zefix)",
      "searchPlaceholder": "Search company...",
      "signingEmailPlaceholder": "Email for signing link",
      "street": "Street",
      "subtitle": "Search for an existing partner or create a new one",
      "title": "Contract Partner",
      "zipCode": "Zip Code"
    },
    "step3": {
      "broker": "Broker",
      "brokerDesc": "Co-brokerage, network access, fee splitting",
      "brokerDescription": "Fee sharing with partner broker",
      "buyer": "Buyer",
      "buyerDesc": "Access to off-market properties, search profile, due diligence support",
      "buyerDescription": "Buyer agreement with finders fee and search profile",
      "seller": "Seller",
      "sellerDesc": "Property marketing, buyer matching, transaction support",
      "sellerDescription": "Broker mandate with fee and exclusivity",
      "subtitle": "What role does the partner have?",
      "title": "Choose Contract Type"
    },
    "step4": {
      "brokerCommission": "Fee",
      "brokerSection": "Broker Conditions",
      "buyerSection": "Buyer Conditions",
      "commission": "Broker Fee",
      "commissionMode": "Conditions",
      "commissionModeFixed": "Fixed in the contract",
      "commissionModeFixedDesc": "The percentages are fixed in the contract.",
      "commissionModeFixedRequired": "Please enter a rate greater than 0% for every selected role.",
      "commissionModeVariable": "Per property (Appendix B)",
      "commissionModeVariableDesc": "Conditions are agreed per property.",
      "commissionModeVariableHint": "No fixed percentages in the contract: conditions are agreed per property in Appendix B and confirmed before access to the property.",
      "conditions": "Brokerage Conditions",
      "contractDuration": "Contract Duration",
      "exclusivity": "Exclusivity",
      "exclusivityDuration": "Exclusivity Duration",
      "exclusivityHint": "Exclusive marketing mandate",
      "findersFee": "Finders Fee",
      "globalSection": "General Conditions",
      "ourShare": "Our Share",
      "partnerShare": "Partner Share",
      "protectionDuration": "Protection Duration (Months)",
      "searchProfile": "Search Profile",
      "sellerSection": "Seller Conditions",
      "subtitle": "Type-specific settings",
      "title": "Configuration"
    },
    "step5": {
      "company": "Company",
      "configuration": "Configuration",
      "contractType": "Contract Type",
      "generate": "Generate Contract",
      "generating": "Generating...",
      "partner": "Partner",
      "subtitle": "Review the details and generate the contract",
      "title": "Summary & Generation"
    },
    "steps": {
      "company": "Company",
      "config": "Configuration",
      "partner": "Partner",
      "preview": "Preview",
      "type": "Contract Type"
    },
    "subtitle": "Create new contract",
    "success": "Contract successfully created",
    "title": "New Contract",
    "validation": {
      "collectiveMore": "Collective signature: Please select at least 2 signatories.",
      "collectiveTwo": "Collective signature (two): Please select exactly 2 signatories.",
      "singleOnly": "Single signature: Please select exactly 1 signatory."
    },
    "searchMandate": {
      "companyLoadError": "Firma konnte nicht geladen werden",
      "onlyImages": "Nur Bilddateien erlaubt (PNG, JPG, WebP)",
      "fileTooLarge": "Maximale Dateigroesse: 2 MB",
      "logoUploaded": "Logo hochgeladen",
      "logoUploadFailed": "Logo-Upload fehlgeschlagen",
      "letterGenerated": "Anschreiben-Text generiert",
      "letterGenerateFailed": "Text konnte nicht generiert werden",
      "mandateCreated": "Suchmandat erstellt!",
      "createError": "Fehler beim Erstellen des Suchmandats",
      "title": "Suchmandat erstellen",
      "ourCompany": "Unsere Firma",
      "client": "Auftraggeber (Investor)",
      "searchCompany": "Firma suchen (Zefix)",
      "manualEntry": "Manuell eingeben",
      "signatories": "Unterzeichner des Vertragspartners",
      "signatoriesHint": "Bei Kollektivunterschrift mehrere Personen auswählen.",
      "clientLogo": "Logo des Auftraggebers",
      "clientLogoHint": "Das Logo erscheint oben rechts im Anschreiben. Das Anschreiben wird im Namen des Auftraggebers erstellt.",
      "logoUploadHint": "Logo hochladen oder hierhin ziehen (PNG, JPG, max. 2 MB)",
      "aiCoverLetter": "Anschreiben — KI-Textgenerator",
      "aiCoverLetterHint": "Stichworte zum Auftraggeber eingeben — die KI generiert ein professionelles Anschreiben.",
      "clientKeywords": "Stichworte zum Auftraggeber",
      "generating": "Wird generiert...",
      "generateLetter": "Anschreiben generieren",
      "generatedText": "Generierter Text (bearbeitbar)",
      "textEditable": "Text kann vor dem Erstellen angepasst werden.",
      "searchCriteria": "Suchkriterien",
      "propertyType": "Objektart",
      "noGoCriteria": "No-Go Kriterien",
      "noGoHint": "Was kommt fuer den Investor nicht in Frage?",
      "noGoCustom": "Weitere No-Gos (Freitext)",
      "regionLabel": "Region (Mehrfachauswahl)",
      "cantonsLabel": "Kantone (Mehrfachauswahl)",
      "macroLocation": "Makrolage",
      "noRestriction": "Keine Einschraenkung",
      "macroA": "A — Top-Standort (Zuerich, Genf, Basel)",
      "macroB": "B — Guter Standort (Agglomeration, Mittelstaedte)",
      "macroC": "C — Peripherer Standort (laendlich, Kleinstaedte)",
      "microLocation": "Mikrolage",
      "microA": "A — Beste Mikrolage (zentral, ruhig, top Anbindung)",
      "microB": "B — Gute Mikrolage (durchschnittlich, solide)",
      "microC": "C — Einfache Mikrolage (Randlage, maessige Anbindung)",
      "investmentVolume": "Investitionsvolumen",
      "investmentAndYield": "Investitionsvolumen & Rendite",
      "priceRange": "Kaufpreis-Bandbreite",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "grossYieldMin": "Bruttorendite min.",
      "netYieldTarget": "Nettorendite Ziel",
      "timeline": "Zeitrahmen",
      "buildingAndTimeline": "Gebaeude & Zeitrahmen",
      "conditionLabel": "Zustand (Mehrfachauswahl)",
      "timelineNow": "Sofort",
      "timeline3m": "Innerhalb 3 Monaten",
      "timeline6m": "Innerhalb 6 Monaten",
      "timeline12m": "Innerhalb 12 Monaten",
      "timelineFlexible": "Flexibel",
      "specialRequirements": "Besondere Anforderungen",
      "conditions": "Konditionen",
      "feeNote": "des Kaufpreises, zzgl. MWST",
      "protectionDuration": "Kontaktschutz (Monate)",
      "contractDuration": "Mandatsdauer (Monate)",
      "hidePreview": "Vorschau ausblenden",
      "showPreview": "Vorschau anzeigen",
      "tabCoverLetter": "Anschreiben",
      "tabCriteria": "Suchkriterien",
      "tabAgreement": "Mandatsvereinbarung",
      "creating": "Wird erstellt...",
      "createMandate": "Suchmandat erstellen"
    }
  },
  "contracts": {
    "actions": {
      "cancel": "Cancel contract",
      "createNew": "Create New Contract",
      "downloadPdf": "Download PDF",
      "generate": "Create Contract",
      "preview": "Show Preview",
      "proceedToSign": "Proceed to Signing",
      "send": "Send contract",
      "terminate": "Terminate contract"
    },
    "cancel": "Cancel",
    "cancelFailed": "Contract could not be cancelled.",
    "cancelSuccess": "Contract has been cancelled.",
    "categories": {
      "compliance": "Compliance",
      "contracts": "Contracts",
      "legitimation": "Legitimation",
      "v2": "New Contracts"
    },
    "collectiveSignatureWarning": "Collective signature (two required): Please select at least 2 persons.",
    "complete": {
      "contractNumber": "Contract Number",
      "createdAt": "Created At",
      "description": "Your contract {{number}} has been generated.",
      "sentDescription": "Contract {{number}} has been sent for signing. The signatories will receive an email.",
      "sentTitle": "Contract Sent!",
      "signedDescription": "Contract {{number}} has been signed by all parties.",
      "signedTitle": "Contract Signed Successfully!",
      "status": "Status",
      "title": "Contract Created Successfully!",
      "usersCreated": "{{count}} user accounts automatically created"
    },
    "confirmCancel": "Are you sure you want to cancel this contract?",
    "confirmCancelCustomerSigned": "WARNING: External parties have already signed this contract. Do you still want to cancel it?",
    "confirmCancelSent": "This contract has already been sent. Signatories have received the link. Cancel anyway?",
    "confirmDelete": "Are you sure you want to delete this contract?",
    "confirmDeleteDescription": "Are you sure you want to delete this contract?",
    "confirmSend": "Are you sure you want to send this contract?",
    "confirmTerminate": "Are you sure you want to terminate this contract? This action cannot be undone.",
    "confirmTerminateDescription": "Are you sure you want to terminate this contract?",
    "deleteFailed": "Contract could not be deleted.",
    "deleteSuccess": "Contract has been deleted.",
    "detail": {
      "aiSuggest": "AI Suggestion",
      "aiSuggestFailed": "AI suggestion failed",
      "appendices": "Appendices ({{count}})",
      "appendicesInvestorHint": "Appendices record the terms that apply to an individual property.",
      "appendixProperty": "Property #{{id}}",
      "autoRenewal": "automatische Verlängerung",
      "brokerCommission": "Broker fee",
      "buyer": "Buyer",
      "buyerCommission": "Buyer fee",
      "cancelContract": "Cancel Contract",
      "commissionRate": "Fee",
      "companyLink": "View company",
      "companyName": "Company",
      "config": "Configuration",
      "confirmSend": "Send contract?",
      "confirmSendDescription": "The contract will be sent to all signatories via email.",
      "contactLink": "View contact",
      "contractDuration": "Contract duration",
      "contractNumber": "Contract Number",
      "contractTerms": "Contract Terms",
      "createdAt": "Created on",
      "deleteContract": "Delete Contract",
      "documents": "Documents",
      "downloadPdf": "Download PDF",
      "emailStatus": "Email Delivery",
      "exclusive": "Exclusive Mandate",
      "exclusivity": "Exclusivity",
      "expiresAt": "Valid until",
      "goToCountersign": "Go to Countersign",
      "hidePdf": "Hide PDF",
      "months": "months",
      "noAppendices": "This contract has no appendices yet.",
      "noData": "No data available",
      "nonExclusive": "Non-exclusive",
      "parties": "Contract Parties",
      "partner": "Partner",
      "pdfNotAvailable": "PDF not available",
      "pdfNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "pdfPreviewNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "personalMessage": "Personal message (optional)",
      "personalMessagePlaceholder": "e.g. Please sign by Friday...",
      "plotNumber": "Plot No.",
      "property": "Property",
      "propertyDetails": "Property Details",
      "propertyType": "Property Type",
      "protectionDuration": "Protection Duration",
      "resetSignaturesConfirm": "Zurücksetzen & neu versenden",
      "resetSignaturesDescription": "Alle Unterschriften werden gelöscht und neue Unterzeichnungslinks per E-Mail versendet. Die Unterzeichner müssen erneut unterschreiben.",
      "resetSignaturesFailed": "Zurücksetzen fehlgeschlagen",
      "resetSignaturesTitle": "Unterschriften zurücksetzen?",
      "roles": "Roles",
      "seller": "Seller",
      "sellerCommission": "Seller fee",
      "sendContract": "Send Contract",
      "sentAt": "Sent on",
      "signatures": "Signatures",
      "signedAt": "Signed on",
      "template": "Template",
      "terminateContract": "Terminate Contract",
      "title": "Contract Details",
      "viewDetails": "View Details",
      "viewPdf": "Show PDF"
    },
    "download": "Download",
    "downloadFailed": "Download failed.",
    "errors": {
      "downloadFailed": "Download failed",
      "generateFailed": "Failed to create contract",
      "loadFailed": "Failed to load templates",
      "missingEmails": "Email missing for",
      "missingSignatures": "Missing signatures",
      "previewFailed": "Failed to generate preview",
      "sendFailed": "Failed to send contract",
      "signingFailed": "Signing failed"
    },
    "form": {
      "agentEmail": "Agent Email",
      "agentName": "Agent",
      "authorizedEmail": "Authorized Person Email",
      "authorizedPerson": "Authorized Person",
      "buyerAddress": "Buyer Address",
      "buyerCommissionRate": "Buyer fee rate",
      "buyerEmail": "Buyer Email",
      "buyerName": "Buyer Name",
      "commissionRate": "Fee Rate",
      "companyAddress": "Company Address",
      "companyName": "Company Name",
      "exclusive": "Exclusive",
      "exclusiveDescription": "Exclusive mandate: The seller undertakes not to engage any third parties for marketing and not to contact potential buyers directly if they were identified through Immotron.",
      "exclusivity": "Exclusivity",
      "exclusivityDescription": "§5 Exclusivity — Determines whether the seller may engage other brokers during the contract term.",
      "exclusivityDuration": "Exclusivity Duration",
      "groups": {
        "agent": "Agent",
        "buyer": "Buyer",
        "company": "Organization",
        "config": "Configuration",
        "general": "General",
        "partner": "Partner",
        "property": "Property",
        "seller": "Seller"
      },
      "nonExclusive": "Non-exclusive",
      "nonExclusiveDescription": "Non-exclusive mandate: The seller remains obligated to immediately report to Immotron any contact or inquiry initiated through Immotron.",
      "partnerAddress": "Partner Address",
      "partnerEmail": "Partner Email",
      "partnerName": "Partner Name",
      "plotNumber": "Plot Number",
      "principalName": "Principal",
      "propertyAddress": "Property Address",
      "propertyType": "Property Type",
      "protectionDuration": "Protection Duration",
      "protectionDurationBuyerDescription": "§8 No-Circumvention — Protection clause against circumvention. Any transaction with a seller or property introduced by the platform is deemed brokered. Penalty for breach: double fee.",
      "protectionDurationSellerDescription": "§7 No-Circumvention — Protection clause against circumvention. Any transaction with a buyer introduced by the platform is deemed brokered. Penalty for breach: double fee.",
      "sellerAddress": "Seller Address",
      "sellerCommissionRate": "Seller fee rate",
      "sellerEmail": "Seller Email",
      "sellerName": "Seller Name"
    },
    "generate": "Generate Contract",
    "generateClause": "Generate AI clause",
    "generatingClause": "Generating...",
    "generator": {
      "subtitle": "Create professional contracts in just a few steps",
      "title": "Contract Generator"
    },
    "issuer": "Contract Issuer",
    "list": {
      "allSigned": "alle",
      "appendix": "Appendix",
      "appendixTypes": {
        "ANHANG_A": "Appendix A",
        "ANHANG_B": "Appendix B"
      },
      "buyer": "Buyer",
      "contractNumber": "Contract Number",
      "created": "Erstellt",
      "createdAt": "Created At",
      "dates": "Datum",
      "empty": {
        "description": "Create your first contract",
        "title": "No contracts yet"
      },
      "page": "Page {{current}} of {{total}}",
      "parties": "Parteien",
      "searchMandate": "Suchmandat",
      "searchNoResults": "No contracts found",
      "searchPlaceholder": "Search by contract number, buyer, seller...",
      "seller": "Seller",
      "sent": "Versendet",
      "signatories": "Unterzeichner",
      "signed": "unterschrieben",
      "signedDate": "Unterschrieben",
      "subtitle": "Manage your created contracts",
      "template": "Template",
      "toParentContract": "to master agreement",
      "typeFilter": "Contract Type",
      "typeGroups": {
        "ALL": "All",
        "BROKER": "Broker",
        "BUYER": "Buyer",
        "OTHER": "Other",
        "SELLER": "Seller"
      },
      "us": "Uns"
    },
    "livePreview": {
      "error": "Preview could not be updated.",
      "hidePreview": "Show Form",
      "loading": "Generating preview...",
      "pages": "pages",
      "placeholder": "Please fill in form data to activate the preview.",
      "previewLabel": "Preview",
      "print": "Print",
      "printTitle": "Contract Preview",
      "showPreview": "Show Preview",
      "title": "Live Preview"
    },
    "loadingSignatories": "Loading signatories...",
    "newContract": "New contract",
    "newSearchMandate": "Search mandate",
    "noContracts": "No contracts",
    "ourCompany": "Our company",
    "preview": {
      "document": "Document Preview",
      "title": "Preview"
    },
    "resultsLabel": "Contracts",
    "roles": {
      "BROKER": "Broker",
      "BUYER": "Buyer",
      "SELLER": "Seller",
      "buyer": "Käufer",
      "partner": "Partner",
      "seller": "Verkäufer"
    },
    "selectSignatoriesFor": "Select the authorised signatories for {{company}}:",
    "selectedPersons": "{{count}} person(s) selected",
    "send": "Send",
    "sendFailed": "Contract could not be sent.",
    "sendSuccess": "Contract has been sent.",
    "sign": "Sign",
    "signatoryLoadError": "Failed to load signatories.",
    "signatoryTypes": {
      "AGENT": "Agent",
      "BUYER": "Buyer",
      "COMPANY_REP": "Authorized Representative",
      "IMMOTRON": "Broker",
      "PARTNER": "Partner",
      "SELLER": "Seller",
      "USER": "User"
    },
    "signaturePad": {
      "complete": "Complete Contract",
      "description": "Please sign in the fields below. All signatures are required.",
      "placeholder": "signs here",
      "signaturesRequired": "signature(s) required",
      "signed": "signed",
      "skipAndSaveDraft": "Save as Draft",
      "title": "Collect Signatures"
    },
    "signing": {
      "modeDescription": "How should the contract be signed?",
      "modeTitle": "Choose Signing Mode",
      "onsite": "Sign On-Site",
      "onsiteDescription": "Collect signatures directly on the device (e.g. iPad, tablet).",
      "remote": "Send for Signing",
      "remoteDescription": "Send the contract via email to the signatories."
    },
    "slider": {
      "months": "Months",
      "monthsUnit": "mo.",
      "months_one": "{{count}} month",
      "months_other": "{{count}} months",
      "noProtection": "No Protection",
      "years": "Years",
      "yearsAndMonths": "{{years}} year(s) and {{months}} month(s)",
      "years_one": "{{count}} year",
      "years_other": "{{count}} years"
    },
    "specialConditions": "Special conditions",
    "statuses": {
      "CANCELLED": "Cancelled",
      "CUSTOMER_SIGNED": "Customer Signed",
      "DRAFT": "Draft",
      "EXPIRED": "Expired",
      "PARTIALLY_SIGNED": "Partially Signed",
      "PENDING": "Pending",
      "SENT": "Sent",
      "SIGNED": "Signed",
      "TERMINATED": "Terminated"
    },
    "steps": {
      "complete": "Complete",
      "form": "Enter Data",
      "preview": "Preview",
      "select": "Select Template",
      "sign": "Signature"
    },
    "terminate": "Terminate",
    "terminateFailed": "Termination failed.",
    "terminateSuccess": "Contract has been terminated.",
    "termination": {
      "clause": "Termination clause",
      "clauseLabel": "Select clause",
      "confirmButton": "Confirm termination",
      "confirmSummary": "Termination summary",
      "contract": "Contract",
      "description": "Please provide the reason for termination.",
      "error": "Termination could not be processed.",
      "reason": "Reason for termination",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Please enter the reason for termination...",
      "reasonRequired": "A reason for termination is required.",
      "selectClause": "Select clause",
      "success": "Contract has been successfully terminated.",
      "title": "Terminate contract",
      "warningText": "This action cannot be undone.",
      "warningTitle": "Warning"
    },
    "title": "Contracts",
    "types": {
      "BROKER_AGREEMENT": "Broker Agreement",
      "PLATFORM_AGREEMENT": "Platform Agreement",
      "SEARCH_MANDATE": "Search mandate"
    },
    "v2": {
      "addAppendixB": "Create new Appendix B",
      "aiClause": {
        "clauseNumber": "Clause {{number}}",
        "confirmDelete": "Delete?",
        "context": "Context (optional)",
        "contextPlaceholder": "e.g. renovation backlog, estate community, leasehold...",
        "defaultDescription": "Special provision",
        "editClause": "Edit clause",
        "empty": "No clauses yet. Enter a context and generate.",
        "error": "Error generating clause",
        "generate": "Generate clause",
        "generating": "Generating...",
        "hint": "The AI clause generator creates customised special clauses based on property data. You can edit the generated text afterwards.",
        "placeholder": "AI-generated special clauses will appear here...",
        "regenerate": "Regenerate",
        "tags": {
          "buildingRight": "Leasehold",
          "divorce": "Divorce",
          "estateManagement": "Estate management",
          "forcedSale": "Forced sale",
          "heirsCompany": "Estate community",
          "liquidityShortfall": "Liquidity shortfall",
          "relocation": "Relocation",
          "renovationBacklog": "Renovation backlog"
        },
        "title": "AI Clause Generator"
      },
      "appendices": "Appendices",
      "appendix": {
        "b": "Anhang B: Objektfreigabe"
      },
      "appendixB": {
        "add": "Add property release",
        "commissionModel": "Fee model",
        "description": "Release properties to be marketed via the platform.",
        "empty": "No property releases yet. You can add Appendix B to the framework agreement later.",
        "exclusivity": "Exclusivity",
        "inheritedFromParent": "from framework agreement",
        "newProperty": {
          "canton": "Canton",
          "city": "City",
          "cityPlaceholder": "e.g. Zurich",
          "create": "Create new property",
          "createError": "Error creating the property",
          "hint": "Property details can be added later.",
          "propertyType": "Property type",
          "streetAddress": "Address",
          "streetAddressPlaceholder": "e.g. Sample Street 1",
          "submit": "Create & select",
          "title": "Create new property"
        },
        "overrideExclusivity": "Different from framework agreement",
        "protectionDuration": "Protection duration",
        "selectCommissionModel": "Choose model...",
        "selectProperty": "Select property",
        "selectPropertyPlaceholder": "Choose a property...",
        "title": "Property Release"
      },
      "buyerPlatform": "Buyer Platform Agreement",
      "noAppendices": "No appendices available.",
      "parentContract": "Belongs to framework agreement",
      "sellerFramework": "Seller Framework Agreement",
      "viewParent": "View framework agreement"
    },
    "validation": {
      "collectiveRequiresTwo": "Joint signature: at least 2 authorized signatories are required"
    },
    "searchMandate": "Suchauftrag",
    "countersign": "Gegenzeichnung"
  },
  "countersignPage": {
    "breadcrumb": {
      "contracts": "Contracts",
      "countersign": "Countersign"
    },
    "buyer": "Buyer",
    "contractDetails": "Contract Details",
    "contractNumber": "Contract Number",
    "contractType": "Contract Type",
    "customerSignedAt": "Customer signed on",
    "days": "days",
    "error": {
      "loadFailed": "Contract data could not be loaded.",
      "noSlots": "No signature slots available that you are authorized for.",
      "notFound": "Contract not found.",
      "submitFailed": "The countersignature could not be submitted. Please try again.",
      "title": "Error",
      "unauthorized": "You are not authorized to sign this signature slot.",
      "wrongStatus": "This contract is not ready for countersigning."
    },
    "geoConsent": "Share location for legal documentation",
    "hidePdf": "Hide contract",
    "legalNotice": "By countersigning, you confirm as an authorized representative that the contract has been reviewed and approved.",
    "loading": "Loading contract data...",
    "pdfTitle": "Contract preview",
    "selectSlot": "Select",
    "selectedSlot": "Selected",
    "seller": "Seller",
    "signatureLabel": "Signature",
    "signatureSlots": "Signature Slots",
    "signatureTitle": "Your Countersignature",
    "slotAvailable": "Available for you",
    "slotLocked": "Not authorized",
    "slotSigned": "Already signed",
    "submit": "Countersign",
    "submitting": "Countersigning...",
    "subtitle": "Internal countersigning of the contract",
    "success": {
      "allComplete": "All signatures are complete. The contract is now legally binding.",
      "description": "Your countersignature has been submitted successfully.",
      "moreRequired": "Additional internal signatures are still required.",
      "title": "Successfully countersigned!"
    },
    "title": "Countersign",
    "viewPdf": "View contract",
    "waitingDays": "Waiting time"
  },
  "crm": {
    "activities": {
      "placeholder": "Activity Management",
      "placeholderDescription": "CRM activity management will be available in a future release.",
      "title": "Activities"
    },
    "contacts": {
      "addFirst": "Go to Contacts",
      "backToContacts": "Back to contacts",
      "backToList": "Back to list",
      "companySearchCriteria": "Suchprofile verknüpfter Firmen",
      "contactInfo": "Contact Details",
      "dedup": "Deduplication",
      "details": "Details",
      "emptyDescription": "Erstellen Sie Ihren ersten Kontakt, um mit der CRM-Verwaltung zu beginnen.",
      "emptyTitle": "Noch keine Kontakte",
      "filterAll": "All",
      "filterWithCompany": "With Company",
      "filterWithoutCompany": "Without Company",
      "goToCompany": "Zur Firma",
      "import": "Import",
      "keyFigures": "Key figures",
      "lastActivity": "Letzte Aktivität",
      "noCompanyCriteria": "Keine Suchkriterien hinterlegt",
      "noResults": "Keine Kontakte gefunden",
      "notFound": "Contact not found",
      "openDetail": "Open",
      "ownSearchCriteria": "Eigenes Suchprofil",
      "ownership": "Ownership",
      "personalData": "Kontaktdaten",
      "placeholder": "Contact Management",
      "placeholderDescription": "CRM contact management will be available in a future release.",
      "previewTitle": "Quick preview",
      "searchPlaceholder": "Search name, email, phone or company...",
      "subtitle": "CRM Contact Management",
      "tabOverview": "Overview",
      "tabResearch": "KI-Recherche",
      "tabSearchCriteria": "Search profile",
      "tabTimeline": "Activities",
      "title": "Contacts",
      "tryDifferentSearch": "Try a different search term",
      "unverifyConfirmText": "This person will lose the CRM verification for contract signing. Without Zefix signing authority, the onboarding gate will reject them. This change is audit-relevant.",
      "unverifyConfirmTitle": "Remove verification?",
      "verificationSection": "Verification",
      "verifiedBadge": "Verified for contract signing",
      "verifiedForSigningHint": "Opens the self-service contract request for this person even without Zefix signing authority.",
      "verifiedForSigningLabel": "Verified for contract signing",
      "verifiedRemovedSuccess": "Verification removed",
      "verifiedSetSuccess": "Verification set",
      "verifiedUpdateError": "Verification could not be updated",
      "verifyConfirmText": "This person will be cleared for contract signing and can complete onboarding even without a Zefix entry. This change is audit-relevant.",
      "verifyConfirmTitle": "Set verification?",
      "masterDataCard": "Master data",
      "channelsCard": "Address & contact details",
      "rolesCard": "Company roles",
      "addRole": "Add role",
      "roleAlreadyLinked": "This organisation is already linked",
      "rolePersonNotAllowed": "Please select an organisation, not a person",
      "contractsCard": "Contracts",
      "linkedinCard": "LinkedIn",
      "knowledgeTab": "Knowledge"
    },
    "organizations": {
      "addContact": "Add contact",
      "addFirst": "Go to Organizations",
      "addInvestorGroup": "Assign investor group",
      "addNew": "New Organization",
      "addSearchCriteria": "Create search profile",
      "address": "Address",
      "allContacts": "Contacts: all",
      "canton": "Canton",
      "capital": "Capital",
      "contactAdded": "Contact added",
      "contactCreatedAndLinked": "Contact created and linked",
      "contactInfo": "Master data",
      "contactRemoved": "Contact removed",
      "createdAt": "Created on",
      "details": "Details",
      "employees": "Employees",
      "emptyDescription": "Create your first organization to start managing your CRM.",
      "emptyTitle": "No organizations yet",
      "hasContacts": "With contacts",
      "hasSearchCriteria": "Search profile available",
      "industry": "Industry",
      "industryPlaceholder": "Select industry...",
      "industriesFilter": "Industries",
      "removeIndustry": "Remove industry",
      "investorGroupsTab": "Investor groups",
      "investorGroupsFilter": "Investor groups",
      "lastActivity": "Last activity",
      "lastResearched": "Last researched",
      "legalForm": "Legal form",
      "newContact": "New contact",
      "noContacts": "Without contacts",
      "noContactsFound": "No contacts found",
      "noInvestorGroups": "No investor groups assigned",
      "noResults": "No organizations found",
      "noResultsDescription": "Try adjusting your search terms or filters.",
      "noSearchCriteria": "No search profile stored",
      "notes": "Notes",
      "overviewTab": "Overview",
      "ownership": "Responsibility",
      "parentCompany": "Parent company",
      "pendingProposal": "Research suggestion pending — click to review",
      "placeholder": "Organization Management",
      "placeholderDescription": "CRM organization management will be available in a future release.",
      "primaryContact": "Primary Contact",
      "properties": {
        "contractActive": "Contract active",
        "contractExpired": "Contract expired",
        "contractMissing": "No contract",
        "empty": "No properties for this organization",
        "groupBy": "Group by",
        "groupByCanton": "Canton",
        "groupByNone": "none",
        "groupByStatus": "Status",
        "groupByType": "Use",
        "groupByVia": "Relation",
        "groupCount": "{{count}} properties",
        "groupCountOne": "1 property",
        "groupNoValue": "Not specified",
        "groupSumMillions": "CHF {{value}}M",
        "groupTotal": "{{count}} properties · {{sum}}",
        "groupTotalOne": "1 property · {{sum}}",
        "groupViaCompany": "Company",
        "groupViaContact": "via contact",
        "propertyLabel": "Property",
        "sectionImmotron": "On Immotron",
        "viaContact": "via contact: {{name}}"
      },
      "propertiesTab": "Properties",
      "purpose": "Purpose",
      "registerDetails": "Commercial register extract",
      "removeContact": "Remove contact",
      "removeFromOrg": "remove from this organisation?",
      "removePrimaryContact": "Remove Primary Contact",
      "knowledgeTab": "Knowledge",
      "researchTab": "AI research",
      "roleUpdated": "Role updated",
      "searchContact": "Search contact...",
      "searchCriteriaTab": "Search profile",
      "nlSearch": {
        "placeholder": "Ask freely, e.g. «all looking for commercial in Zurich»",
        "ariaLabel": "Natural-language organisation search",
        "submit": "Search",
        "understoodAs": "Understood as:",
        "reset": "Reset",
        "searchIn": "Searches in:",
        "sourceCriteria": "Search mandates",
        "sourcePurpose": "Zefix purpose",
        "onlyWithCriteria": "with mandate only",
        "parseError": "Could not interpret the question. Please try again.",
        "unrecognizedHint": "Not clearly mapped — not applied as a filter",
        "removeChip": "Remove filter",
        "reasonMandate": "Search-mandate match",
        "reasonPurpose": "Zefix-purpose match",
        "noMandate": "no search mandate on file",
        "chipType": "Property type",
        "chipRegion": "Region",
        "chipCanton": "Canton",
        "chipYield": "Yield from",
        "chipPriceMin": "Price from",
        "chipPriceMax": "Price up to",
        "chipUnits": "Min. units",
        "chipText": "Text",
        "noResultsTitle": "No matches",
        "noResultsHelp": "Try loosening a filter:",
        "loosenRemove": "Without «{{label}}»",
        "loosenSources": "Search both sources",
        "loosenMandate": "Also without a mandate"
      },
      "searchPlaceholder": "Search name, UID or industry...",
      "selectGroup": "Select group...",
      "setPrimaryContact": "Set as Primary Contact",
      "subtitle": "Manage companies and organizations",
      "title": "Organizations",
      "backToList": "Back to list",
      "notFound": "Organisation not found",
      "openDetail": "Open",
      "previewTitle": "Quick preview",
      "keyFigures": "Key figures",
      "recentActivities": "Recent activities",
      "noActivities": "No activities recorded yet",
      "zefixRevert": "Remove Zefix link",
      "zefixRevertTitle": "Undo Zefix data",
      "zefixRevertConfirm": "All Zefix contacts of this organisation are deactivated and the Zefix link is removed. Pinned contacts are kept.",
      "zefixRevertConfirmLabel": "Undo",
      "zefixRevertFailed": "Undoing the Zefix link failed"
    },
    "createOrganization": {
      "stepSearch": "Step 1 of 2 — Search",
      "stepDetails": "Step 2 of 2 — Details",
      "searchIntro": "Search the CRM and the commercial register first — this avoids duplicate entries.",
      "manualEntry": "Enter without searching",
      "existingCompany": "This organisation already exists",
      "existingContact": "This entry already exists as a person",
      "openExisting": "Go to existing entry",
      "duplicateGeneric": "This organisation already exists.",
      "fromZefix": "Taken from the commercial register",
      "nameRequired": "Name is required",
      "seat": "Registered office",
      "seatRequired": "Registered office is required",
      "detailsHint": "Everything else — addresses, contact details, notes — is added on the detail page.",
      "submit": "Create organisation"
    },
    "createContact": {
      "subtitle": "Only the essentials — everything else on the detail page.",
      "duplicateEmail": "This e-mail address already exists",
      "openExisting": "Go to existing entry",
      "lastNameRequired": "Last name is required",
      "firstNameRequired": "First name is required",
      "emailOptional": "E-mail (optional)",
      "checkingEmail": "Checking e-mail...",
      "organizationOptional": "Organisation (optional)",
      "personPicked": "That is a person — please select an organisation.",
      "companyWillBeCreated": "This organisation will be created and linked.",
      "submit": "Create person"
    }
  },
  "crmActivities": {
    "activityType": "Type",
    "addFailed": "Could not create activity",
    "addSuccess": "Activity created",
    "description": "Description",
    "descriptionPlaceholder": "Optional details...",
    "emptyTimeline": "No activities",
    "emptyTimelineHint": "No activities recorded for this entry yet.",
    "entityCompany": "Company",
    "entityContact": "Contact",
    "filterActivities": "Activities",
    "filterEmails": "Emails",
    "filterTasks": "Tasks",
    "loadFailed": "Could not load activities",
    "newActivity": "New Activity",
    "searchPlaceholder": "Search contact or company...",
    "selectEntity": "Select contact or company",
    "selectEntityHint": "Search for a contact or company to view their activity timeline.",
    "subject": "Subject",
    "subjectPlaceholder": "Short description...",
    "subtitle": "CRM timeline for contacts and companies",
    "title": "Activities",
    "types": {
      "call": "Call",
      "email": "Email",
      "meeting": "Meeting",
      "note": "Note",
      "task": "Task"
    }
  },
  "dashboard": {
    "actions": {
      "addProperty": "Add new property",
      "createContract": "Create contract",
      "manageUsers": "Manage users",
      "searchProperties": "Search properties"
    },
    "activity": {
      "daysAgo": "{{count}}d ago",
      "hoursAgo": "{{count}}h ago",
      "justNow": "Just now"
    },
    "awaitingCountersign": "Countersign",
    "conversionRate": "Conversion Rate",
    "countersign": "Countersignature Required",
    "customize": "Customize Dashboard",
    "dealflowPipeline": "Dealflow Pipeline",
    "errors": {
      "loadFailed": "Failed to load dashboard"
    },
    "investor": {
      "availableProperties": "Other Available Properties",
      "dossierAccess": "Dossier Access",
      "goToSearch": "Go to Property Search",
      "kpi": {
        "activeListings": "Active Teasers",
        "availableForYou": "Available for You",
        "buying": "Buying",
        "inPreparation": "In Preparation",
        "inSale": "In Sale",
        "myProperties": "My Properties",
        "selling": "Selling",
        "sold": "Sold",
        "viewed": "Viewed"
      },
      "myProperties": "My Approved Properties",
      "noProperties": "No properties available",
      "noPropertiesHint": "No properties are currently visible for you.",
      "pendingAccess": "Without Access",
      "propertiesAvailable": "Available Properties",
      "recentlyViewed": "Recently viewed",
      "recentlyViewedEmpty": "No properties viewed yet — start with the search!",
      "ndaSigned": "NDA signed",
      "favorites": "Favourites",
      "newlyAdded": "Newly added"
    },
    "noActivity": "No recent activity",
    "overdue": "Overdue",
    "pendingSignatures": "Sent — Awaiting Signature",
    "quickActions": "Quick Actions",
    "recentActivity": "Recent Activity",
    "resetLayout": "Reset",
    "role": "Role: {{role}}",
    "showAll": "Show all",
    "statistics": "Statistics",
    "stats": {
      "contactsTotal": "Total Contacts",
      "contractsDraft": "Drafts",
      "contractsPending": "Pending Contracts",
      "contractsSigned": "Signed",
      "contractsTotal": "Total Contracts",
      "propertiesActive": "Active Properties",
      "propertiesTotal": "Total Properties"
    },
    "statusBreakdown": "Contract Status Overview",
    "statusCancelled": "Cancelled",
    "statusDraft": "Draft",
    "statusPending": "Pending",
    "statusSigned": "Signed",
    "title": "Dashboard",
    "welcome": "Welcome, {{name}}",
    "widgets": {
      "activity": "Recent Activity",
      "countersign": "Countersignature",
      "dealflow": "Dealflow Pipeline",
      "investorAvailable": "Available Properties",
      "investorKpi": "KPI Overview",
      "investorNetflix": "Discover Properties",
      "investorProperties": "My Properties",
      "pendingSignatures": "Pending Signatures",
      "statCards": "Statistics Cards",
      "tasks": "Tasks"
    },
    "colSpan": {
      "title": "Spaltenbreite"
    },
    "customizeHint": "Widgets per Drag & Drop sortieren. Klicke auf das Spalten-Icon für die Breite."
  },
  "deals": {
    "actions": {
      "cancel": "Cancel Deal"
    },
    "confirmCancel": "Are you sure you want to cancel this deal?",
    "confirmDelete": "Are you sure you want to delete this deal?",
    "confirmPhaseChange": "Change phase to {{phase}}?",
    "create": "New Deal",
    "detail": {
      "dealNumber": "Deal No.",
      "financingPhase": "Financing Phase",
      "listing": "Teaser / Property",
      "ourCompany": "Our Company",
      "phaseDetails": "Phase Details",
      "qaPhase": "Q&A Phase",
      "seller": "Seller",
      "title": "Title"
    },
    "documents": {
      "noneRequired": "No documents required.",
      "progress": "Completeness",
      "title": "Documents"
    },
    "empty": {
      "description": "Create a new deal to get started.",
      "title": "No deals yet"
    },
    "errors": {
      "cancelFailed": "Failed to cancel deal.",
      "loadFailed": "Failed to load deals.",
      "phaseChangeFailed": "Phase change failed."
    },
    "phases": {
      "ACTIVE": "Active",
      "CANCELLED": "Cancelled",
      "CLOSING": "Closing",
      "COMPLETED": "Completed",
      "DRAFT": "Draft",
      "DUE_DILIGENCE": "Due Diligence",
      "FINANCING": "Financing",
      "QA_PHASE": "Q&A"
    },
    "searchPlaceholder": "Search deal number or title...",
    "subtitle": "Manage real estate transactions",
    "timeline": {
      "addEvent": "Add Event",
      "empty": "No events yet.",
      "eventPlaceholder": "Event description...",
      "title": "Timeline"
    },
    "title": "Deals"
  },
  "deletionBlockers": {
    "description": "cannot be deleted because dependencies still exist:",
    "forceDelete": "Force delete (Admin)",
    "hint": "Please remove or reassign the dependencies listed above first.",
    "title": "Cannot delete"
  },
  "deletionWizard": {
    "actionDelete": "Delete",
    "actionIgnore": "Ignore",
    "actionReassign": "Reassign",
    "confirmDelete": "Delete permanently",
    "confirmDescription": "\"{{name}}\" and the selected dependencies will be permanently deleted.",
    "confirmWarning": "Warning: This action cannot be undone!",
    "continue": "Continue",
    "deleteSuccess": "Organization and dependencies deleted",
    "dependencySummary": "This organization has {{count}} dependency(ies). Choose an action for each group.",
    "endpointNotReady": "The dependency check is not yet available.",
    "loadError": "Failed to load dependencies.",
    "loadingDependencies": "Checking dependencies…",
    "noDependencies": "No dependencies found — organization can be deleted.",
    "selectTargetCompany": "Search target company…",
    "stepActions": "Choose actions",
    "stepConfirm": "Confirm",
    "title": "Delete organization — Dependencies"
  },
  "developer": {
    "booking": {
      "amount": "Amount (CHF)",
      "amountInvalid": "Top-up must be greater than 0, correction must not be 0.",
      "forbidden": "You may not book credit for this company.",
      "kind": "Type",
      "kindCorrection": "Correction",
      "kindTopupInvoice": "Top-up by invoice",
      "note": "Note",
      "open": "Book credit",
      "reference": "Reference (invoice number)",
      "saved": "Booked — new balance CHF {{balance}}",
      "sectionTitle": "Credit of this company",
      "submit": "Book"
    },
    "credits": {
      "amount": "Amount (CHF)",
      "balance": "Current credit",
      "bookings": "Bookings",
      "colAmount": "Amount",
      "colBalance": "Balance after",
      "colDate": "Date",
      "colKind": "Type",
      "colReference": "Reference",
      "empty": "No bookings yet.",
      "kinds": {
        "charge": "Property evaluation",
        "correction": "Correction",
        "topup_card": "Top-up card/Twint",
        "topup_invoice": "Top-up by invoice",
        "voucher": "Voucher"
      },
      "low": "Credit almost used up — please top up.",
      "noCompany": "No company is assigned to this access.",
      "paymentsDisabled": "Payment is currently unavailable. Please contact Immotron.",
      "receipt": "Receipt",
      "tab": "Credit",
      "topup": "Top up credit",
      "topupCancelled": "Payment cancelled.",
      "topupHint": "Pay by credit card or Twint via Stripe. The credit is booked right after payment.",
      "topupSuccess": "Payment received — the credit has been booked.",
      "voucher": {
        "alreadyRedeemed": "Code already redeemed",
        "error": "Redeeming failed. Please check the code.",
        "exhausted": "This code has been used up.",
        "hint": "Have a voucher code? Redeem it here — the amount is credited to your balance right away.",
        "invalid": "Invalid code",
        "label": "Voucher code",
        "placeholder": "IMMO-XXXX-XXXX",
        "redeemed": "{{amount}} credited",
        "submit": "Redeem",
        "title": "Voucher code"
      }
    },
    "guide": {
      "copied": "Copied",
      "copy": "Copy",
      "intro": "Three steps to connect your assistant.",
      "priceNote": "Each property evaluation is one call and deducts CHF 30 from your credit. Top up in the «Credit» tab; your usage is shown in the «Usage» tab.",
      "step1": "Create a key in the «API keys» tab and copy it right away — it is shown only once.",
      "step1Title": "Create an API key",
      "step2": "Your assistant connects to this address (MCP, streamable HTTP) and sends the key as a bearer token.",
      "step2Title": "Service address",
      "step3": "Examples for common assistants — enter address and key, then the «Property evaluation» tool is available.",
      "step3Title": "Configure your assistant"
    },
    "navLabel": "Developer",
    "signup": {
      "acceptTerms": "I accept the <0>terms and conditions</0>.",
      "acceptTermsRequired": "Please accept the terms and conditions.",
      "backToLogin": "Back to login",
      "companyName": "Company",
      "email": "E-mail",
      "firstName": "First name",
      "intro": "Connect your AI assistant to Immotron and obtain property evaluations via API. After confirming your e-mail address you create your API keys and top up credit.",
      "lastName": "Last name",
      "loginLink": "Request developer access",
      "sentHint": "The link is valid for 72 hours. No e-mail? Check your spam folder.",
      "sentMessage": "We sent an e-mail to {{email}}. Set your password via the link to activate the access.",
      "sentTitle": "E-mail on its way",
      "submit": "Request access",
      "title": "Request developer access",
      "unavailable": "Sign-up is currently unavailable. Please try again later."
    },
    "subtitle": "Manage API keys and connect your AI assistant to Immotron.",
    "tabs": {
      "guide": "Guide",
      "keys": "API keys",
      "usage": "Usage"
    },
    "title": "Developer access",
    "usage": {
      "colCalls": "Calls",
      "colChf": "CHF",
      "colMonth": "Month",
      "colTool": "Tool",
      "csv": "Download CSV",
      "empty": "No calls in the selected period.",
      "forbidden": "No permission for this company.",
      "mandantTitle": "Developer usage (API)",
      "rangeLastMonth": "Last month",
      "rangeThisMonth": "This month",
      "rangeThisYear": "This year",
      "title": "Usage",
      "tools": {
        "property_evaluate": "Property evaluation"
      },
      "total": "Total"
    }
  },
  "documentViewer": {
    "deselectAll": "Deselect all",
    "downloadComplete": "Download complete",
    "downloadDossier": "Download complete dossier",
    "downloadFailed": "Download failed",
    "downloading": "Downloading...",
    "exitFullscreen": "Exit fullscreen",
    "fullscreen": "Fullscreen",
    "noDocuments": "No documents available",
    "of": "of",
    "page": "Document",
    "selectDocuments": "Select documents",
    "selectedCount": "{{count}} documents",
    "viewer": "Document Viewer",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out"
  },
  "documents": {
    "addCustomCategory": "Add category",
    "allCategories": "All categories",
    "categories": {
      "bo": "BO – binding offer",
      "grundbuchauszug": "Land registry extract",
      "korrespondenz": "Correspondence",
      "legitimation": "Identification",
      "nbo": "NBO – indicative offer",
      "nda": "NDA",
      "sonstiges": "Other",
      "vertrag": "Contract"
    },
    "categoriesFilled": "{{done}} of {{total}} categories filled",
    "category": "Category",
    "categoryChanged": "Category changed",
    "changeCategory": "Change category",
    "combinedDownload": "Combined download",
    "customCategoryPlaceholder": "Category name...",
    "delete": "Delete document",
    "deleteConfirm": "Are you sure you want to delete \"{{name}}\"?",
    "deleteSuccess": "Document deleted",
    "description": "Description",
    "documentPlural": "documents",
    "documentSingular": "document",
    "documentsCount": "document(s)",
    "dossierCategories": {
      "amtliche_schaetzung": "Official Appraisal",
      "baubeschrieb": "Building Description",
      "bewertungsgutachten": "Valuation Report",
      "grundbuchauszug": "Land Registry Extract",
      "grundrisse": "Floor Plans / Blueprints",
      "investitionen": "Investments",
      "investorendossier": "Exposé",
      "katasterplan": "Cadastral Plan / OEREB",
      "liegenschaftenabrechnung": "Property Statement",
      "mieterspiegel": "Rent Index",
      "mietvertraege": "Lease Agreements",
      "renovationen": "Renovations"
    },
    "dossierGroups": {
      "custom": "Custom",
      "investor_dossier": "Exposé",
      "supplementary": "Supplementary Documents",
      "valuation": "Valuation Documents"
    },
    "dossierProgress": "Dossier Completeness",
    "dossierSummary": "{{total}} document(s) in {{categories}} of {{totalCategories}} categories",
    "dossierTooltips": {
      "amtliche_schaetzung": "Current official valuation report from the cantonal tax authority or building insurance.",
      "baubeschrieb": "Official building description as per building application or sales documentation, including construction method, materials and finishing standard.",
      "bewertungsgutachten": "Independent fair market value or market valuation report by a recognised valuation expert.",
      "grundbuchauszug": "Current official land register extract from the competent land registry office (no older than 6 months). Must include owner, parcel number, easements and liens.",
      "grundrisse": "Scale floor plans of all storeys including area specifications.",
      "investitionen": "Documented investments from recent years with invoices or summary of major renovations.",
      "investorendossier": "Complete exposé with property description, financial key figures and location analysis.",
      "katasterplan": "Official cadastral plan from the surveying office showing parcel boundaries, plot numbers and location designation. Including OEREB extract if available.",
      "liegenschaftenabrechnung": "Latest annual property statement with operating and maintenance costs.",
      "mieterspiegel": "Overview of all tenants with rent, area and lease start date.",
      "mietvertraege": "Complete, signed lease agreements for all existing tenancies including amendments and supplementary agreements.",
      "renovationen": "Overview or documentation of completed renovations with dates and scope of work."
    },
    "download": "Download",
    "fileSize": "Size",
    "fileTooLarge": "File \"{{name}}\" is too large (max 50 MB)",
    "filename": "Filename",
    "generate": "Generate",
    "generateFailed": "Document generation failed",
    "generated": "{{type}} successfully generated",
    "generatedAt": "Generated on",
    "immotronDocuments": "Immotron documents",
    "inCategories": "in {{count}} categories",
    "link": "Link",
    "linkExisting": "Link document",
    "linkNoResults": "No documents found",
    "linkSearchPlaceholder": "Search document...",
    "linkSuccess": "Document linked",
    "mergingDocuments": "Merging documents...",
    "noCategory": "No category",
    "noDocuments": "No documents yet",
    "noDocumentsShort": "No documents yet",
    "notGenerated": "Not yet generated",
    "onlyMissing": "Only missing",
    "openInBrowser": "Open in browser",
    "originalDocuments": "Original documents",
    "pageOf": "Page {{current}} of {{total}}",
    "preview": "Preview",
    "previewUnavailable": "Preview not available",
    "regenerate": "Regenerate",
    "requiredDocsTitle": "Required documents",
    "requiredDocsProgress": "{{done}} of {{total}} required documents available",
    "saveAsDraft": "Save as Draft",
    "saveFirstForDocuments": "Please save the property first to upload documents.",
    "selectCategory": "Select category",
    "showOnlyMissing": "Show only missing documents",
    "subgroup": {
      "label": "Subgroup",
      "placeholder": "e.g. ÖREB extracts",
      "saved": "Subgroup saved"
    },
    "title": "Documents",
    "uncategorized": "Uncategorized documents",
    "unsupportedType": "File type of \"{{name}}\" is not supported",
    "upload": "Upload document",
    "uploadCategory": "Category for new documents",
    "uploadDragDrop": "Drag files here or click to upload",
    "uploadFirst": "Upload your first document",
    "uploadHint": "PDF, Word, Excel, Images. Max 50 MB.",
    "uploadMore": "Upload more files",
    "uploadSuccess": "Document uploaded",
    "uploadedAt": "Uploaded at",
    "viaContact": "via {{name}}"
  },
  "emailAccounts": {
    "addImap": "Add IMAP Account",
    "autoFillHint": "Fields were pre-filled from your profile",
    "cancel": "Cancel",
    "changeScope": "Firmenzuordnung ändern",
    "company": "Firma",
    "companyAccounts": "Company Mailboxes",
    "connect": "Connect",
    "connectGoogle": "Google verbinden",
    "connectMicrosoft": "Microsoft verbinden",
    "connected": "Verbunden",
    "connecting": "Connecting...",
    "deactivated": "Deaktiviert",
    "disconnect": "Konto trennen",
    "displayName": "Display Name",
    "emailAddress": "Email Address",
    "errors": {
      "connectFailed": "Connection failed",
      "deleteFailed": "Error disconnecting",
      "invalidOAuthState": "Ungültiger OAuth-State — bitte erneut versuchen",
      "loadFailed": "Could not load email accounts",
      "oauthFailed": "OAuth-Verbindung fehlgeschlagen",
      "scopeChangeFailed": "Could not change company assignment",
      "tokenRefreshFailed": "Token-Erneuerung fehlgeschlagen — erneut verbinden"
    },
    "goToSettings": "Zu den Einstellungen",
    "imapFormTitle": "Manually add IMAP/SMTP account",
    "imapHost": "IMAP Server",
    "imapPort": "IMAP Port",
    "loadError": "E-Mail-Konten konnten nicht geladen werden",
    "loading": "Konten werden geladen...",
    "noAccounts": "No email accounts connected yet",
    "noAccountsHint": "Connect a Google, Microsoft or IMAP account",
    "notSynced": "Noch nicht synchronisiert",
    "password": "Password",
    "private": "Privat",
    "privateAccounts": "Private Mailboxes",
    "reconnect": "Erneut verbinden",
    "refreshToken": "Token erneuern",
    "scope": "Assignment",
    "scopePrivate": "Private (only for me)",
    "smtpHost": "SMTP Server",
    "smtpPort": "SMTP Port",
    "subtitle": "Connect Google, Microsoft or IMAP mailboxes",
    "success": {
      "connected": "Email account connected",
      "deleted": "Email account disconnected",
      "scopeChanged": "Company assignment updated",
      "tokenRefreshed": "Token erneuert"
    },
    "syncTime": {
      "justNow": "gerade eben"
    },
    "thisCompany": "diese Firma",
    "title": "Email Accounts",
    "useTls": "Use TLS"
  },
  "emailScore": {
    "level": "Email score: {{level}}/5",
    "star1": "Valid syntax",
    "star2": "Domain exists",
    "star3": "MX record found",
    "star4": "Mailbox reachable",
    "star5": "Delivery confirmed"
  },
  "emailAttachments": {
    "addShort": "Attach",
    "all": "All",
    "confirm": "Confirm",
    "empty": "No documents available. Upload a file.",
    "emptyFilter": "No documents in this category.",
    "selected": "{{count}} selected",
    "sourceCompany": "Company",
    "sourceContact": "Contact",
    "sourceProperty": "Property",
    "sourceTask": "Task",
    "title": "Attach documents",
    "uploadHint": "Upload file",
    "uploading": "Uploading..."
  },
  "emailSignature": {
    "defaultTemplate": "Default Template",
    "emailHint": "Taken from your email account (tab «Email Accounts»).",
    "errors": {
      "loadFailed": "Could not load signatures",
      "previewFailed": "Could not load preview",
      "saveFailed": "Could not save signature"
    },
    "fields": {
      "email": "Email",
      "function": "Function",
      "name": "Name",
      "phone": "Phone"
    },
    "fullPreview": "Full Email Preview",
    "infoText": "Configure your personal email signature per tenant. Name, function and email are taken from your profile. You can adjust the phone number and template here.",
    "livePreview": "Live Preview",
    "noCompanies": "No Company Assignment",
    "noCompaniesDesc": "You are not assigned to any tenant. Ask an administrator to add you.",
    "noSignatureYet": "No signature data available yet. Please complete your profile.",
    "noTemplate": "No template (signature only)",
    "personal": "Personal",
    "preview": "Preview",
    "previewTitle": "Email Preview — {{company}}",
    "saved": "Email signature saved",
    "signatureDetails": "Signature Details",
    "signaturePreview": "Signature Preview",
    "subtitle": "Configure your email signature and default template per tenant",
    "tabLabel": "Email Signature",
    "template": "Template",
    "templateHint": "Only personal templates are shown. The template is used for CEO Agent emails.",
    "templateReadonlyHint": "The template is managed by the administrator under Settings > Email Templates.",
    "title": "Personal Email Signature"
  },
  "emailTemplates": {
    "active": "Active",
    "allCompanies": "All Tenants",
    "categories": {
      "all": "All",
      "contract-signing": "Contract Signing",
      "marketing": "Marketing",
      "notification": "Notifications"
    },
    "category": "Category",
    "categoryPlaceholder": "z.B. Immobilien, Newsletter",
    "confirmDelete": "Are you sure you want to delete this template?",
    "confirmDeleteDescription": "Are you sure you want to delete this template?",
    "createSuccess": "Template created successfully",
    "deleteSuccess": "Template deleted successfully",
    "deleteTemplate": "Delete Template",
    "deleted": "Template has been deleted.",
    "description": "Description",
    "editTemplate": "Edit Template",
    "errors": {
      "deleteFailed": "Template could not be deleted.",
      "loadFailed": "Failed to load templates",
      "saveFailed": "Template could not be saved."
    },
    "inactive": "Inactive",
    "list": {
      "empty": {
        "description": "Create your first email template",
        "title": "No templates yet"
      }
    },
    "name": "Name",
    "newTemplate": "New Template",
    "personalOnly": "Persönliche Vorlage (nur für mich sichtbar)",
    "saved": "Template has been saved.",
    "scopeCompany": "Firmenvorlage",
    "scopeCompanyLabel": "Firma",
    "scopePersonal": "Persönliche Vorlage",
    "scopePersonalLabel": "Persönlich",
    "search": "Search templates...",
    "subtitle": "Reusable templates for campaigns",
    "title": "Email Templates",
    "updateSuccess": "Template updated successfully"
  },
  "emailTracking": {
    "expired": "Expired",
    "pending": "Pending",
    "resend": "Resend",
    "resendConfirm": "Resend signing email to {{name}}?",
    "resendFailed": "Failed to send email",
    "resendSuccess": "Email resent to {{email}}",
    "steps": {
      "clicked": "Link Clicked",
      "opened": "Opened",
      "sent": "Sent",
      "signed": "Signed"
    },
    "title": "Signatures & Delivery"
  },
  "emails": {
    "account": "Konto:",
    "attachments": "Anhänge",
    "bulkDeleteConfirmDescription": "Die ausgewählten Emails werden dauerhaft gelöscht und können nicht wiederhergestellt werden. Sie werden auch beim E-Mail-Provider entfernt.",
    "bulkDeleteConfirmLabel": "Alle löschen",
    "bulkDeleteFailed": "Emails konnten nicht gelöscht werden",
    "classification": {
      "actionable": "Aktion",
      "ignored": "Ignoriert"
    },
    "createTask": "Pendenz erstellen",
    "date": "Datum:",
    "deleteConfirmDescription": "Die Email wird dauerhaft gelöscht und kann nicht wiederhergestellt werden. Sie wird auch beim E-Mail-Provider entfernt.",
    "deleteConfirmTitle": "Email löschen?",
    "deleteEmail": "Email löschen",
    "deleteFailed": "Email konnte nicht gelöscht werden",
    "deleted": "Email gelöscht",
    "deselectAll": "Auswahl aufheben",
    "detailLoadFailed": "Email konnte nicht geladen werden",
    "editor": {
      "bold": "Fett (Ctrl+B)",
      "bulletList": "Aufzählung",
      "enterImageUrl": "Bild-URL eingeben:",
      "enterUrl": "URL eingeben:",
      "heading1": "Überschrift 1",
      "heading2": "Überschrift 2",
      "heading3": "Überschrift 3",
      "insertImage": "Bild einfügen (URL)",
      "insertLink": "Link einfügen",
      "italic": "Kursiv (Ctrl+I)",
      "orderedList": "Nummerierte Liste",
      "redo": "Wiederholen (Ctrl+Shift+Z)",
      "removeColor": "Farbe entfernen",
      "removeLink": "Link entfernen",
      "textColor": "Textfarbe",
      "underline": "Unterstrichen (Ctrl+U)",
      "undo": "Rückgängig (Ctrl+Z)"
    },
    "enrichContact": "Kontakt anreichern",
    "filters": {
      "actionable": "Aktion nötig",
      "alert": "Alert",
      "allAccounts": "Alle Konten",
      "allDirections": "Alle Richtungen",
      "allTypes": "Alle Typen",
      "ignored": "Ignoriert",
      "inbound": "Eingehend",
      "informational": "Info",
      "outbound": "Gesendet",
      "read": "Gelesen",
      "unread": "Ungelesen"
    },
    "from": "Von:",
    "goToTask": "Zur Pendenz",
    "loadFailed": "Emails konnten nicht geladen werden",
    "markRead": "Als gelesen markieren",
    "markUnread": "Als ungelesen markieren",
    "noContent": "Kein Inhalt verfügbar",
    "noEmails": "Keine Emails vorhanden",
    "noResults": "Keine Ergebnisse",
    "noSubject": "(Kein Betreff)",
    "replyNotAvailable": "Replies are sent from your own mail account — Immotron only displays the conversation.",
    "searchPlaceholder": "Emails durchsuchen...",
    "syncFailed": "Sync fehlgeschlagen",
    "taskCreateFailed": "Pendenz konnte nicht erstellt werden",
    "thread": {
      "empty": "No messages in this conversation",
      "inbound": "Received",
      "loadFailed": "Conversation could not be loaded",
      "messages": "{{count}} messages",
      "openEmail": "Open email: {{subject}}",
      "openInInbox": "Open in mailbox",
      "outbound": "Sent",
      "reply": "Reply",
      "title": "Conversation"
    },
    "title": "Emails",
    "to": "An:",
    "updateFailed": "Fehler beim Aktualisieren"
  },
  "entityInput": {
    "addPersonManually": "Person manuell hinzufügen",
    "address": "Adresse",
    "addressPlaceholder": "Strasse, PLZ Ort",
    "available": "verfügbar",
    "buyerName": "Name des Käufers",
    "capital": "Kapital",
    "clearSelection": "Auswahl löschen",
    "collectiveMoreRequired": "Kollektivunterschrift: mindestens 2 Personen erforderlich",
    "collectiveTwoRequired": "Kollektivunterschrift zu zweien: mindestens 2 Personen erforderlich",
    "company": "Firma",
    "companyName": "Firmenname",
    "crmBadge": "CRM",
    "crmContactsSection": "CRM Contacts",
    "deselectAll": "Keine auswählen",
    "email": "E-Mail",
    "emailForSignature": "E-Mail-Adresse für Vertragsunterschrift",
    "emailPlaceholder": "E-Mail-Adresse eingeben",
    "emailRequiredForSignature": "E-Mail wird für die Signatur benötigt",
    "fetchPdfFromRegister": "PDF vom Handelsregister abrufen",
    "fetchedAt": "Abgerufen",
    "fullNamePlaceholder": "Vor- und Nachname",
    "loadingCrmContacts": "Loading CRM contacts...",
    "manualPersonHint": "Erfassen Sie eine Person, die gemäss internem Kontrollsystem (IKS) zeichnungsberechtigt ist, aber nicht im Handelsregister eingetragen.",
    "manuallyAdded": "Manuell erfasst (IKS)",
    "noSignatoriesFound": "Keine Zeichnungsberechtigten in der Zefix-API gefunden.",
    "noSignatoriesInPdf": "Keine Zeichnungsberechtigten im PDF gefunden",
    "partnerName": "Name des Partners",
    "pdfFetchFailed": "PDF konnte nicht abgerufen werden",
    "pdfFetchHint": "Dies kann einige Sekunden dauern",
    "pdfFetching": "PDF wird abgerufen...",
    "private": "Privatperson",
    "searchCommercialRegister": "Firma im Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "selectAll": "Alle auswählen",
    "selectSignatories": "Zeichnungsberechtigte auswählen",
    "sellerName": "Name des Verkäufers",
    "signatories": "Zeichnungsberechtigte",
    "signatureType": "Unterschriftstyp",
    "zefixBadge": "Zefix",
    "zefixRevert": "Remove Zefix",
    "zefixRevertTitle": "Undo Zefix data",
    "zefixRevertConfirm": "All Zefix contacts of this organization will be deactivated and the Zefix link removed. Pinned contacts will be kept.",
    "zefixRevertConfirmLabel": "Undo",
    "zefixRevertFailed": "Zefix revert failed"
  },
  "entityAttachPicker": {
    "title": "Attach note",
    "subtitle": "Which entity should the note be pinned to?",
    "tabsAriaLabel": "Choose entity type",
    "tabContact": "Contact",
    "tabCompany": "Company",
    "tabProperty": "Property",
    "searchContact": "Search contact...",
    "searchCompany": "Search company...",
    "searchProperty": "Search property...",
    "minChars": "Type at least 2 characters",
    "noResults": "No results found",
    "startTyping": "Start typing to search.",
    "suggestionsHeading": "From task context",
    "suggestionCount": "{{count}} suggestion",
    "suggestionCount_other": "{{count}} suggestions",
    "attached": "Note pinned to {{label}}",
    "attachError": "Pinning failed"
  },
  "entityKnowledge": {
    "createdBy": "Created by {{name}}",
    "emptyCompany": "No knowledge for this company yet. Pin notes in a task to the company so they show up here.",
    "emptyContact": "No knowledge for this contact yet. Pin notes in a task to the contact so they show up here.",
    "emptyProperty": "No knowledge for this property yet. Pin notes in a task to the property so they show up here.",
    "loadError": "Could not load knowledge.",
    "openTask": "Open task",
    "subtitle": "{{count}} knowledge items — pinned from tasks."
  },
  "errors": {
    "duplicateEmail": {
      "companyTitle": "Email already linked to an organisation",
      "contactTitle": "Email already linked to a contact",
      "existingEntry": "Existing entry",
      "openCompany": "Open organisation",
      "openContact": "Open contact"
    },
    "forbidden": "Access denied",
    "general": "An error occurred",
    "network": "Network error",
    "notFound": "Not found",
    "server": "Server error",
    "unauthorized": "Unauthorized",
    "unexpected": "Unexpected error",
    "unexpectedDescription": "An unexpected error occurred. Please try again.",
    "validation": "Validation error"
  },
  "favorites": {
    "addToList": "Add to watchlist",
    "added": "Added to watchlist",
    "allCantons": "All cantons",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "browseProperties": "Browse properties",
    "empty": "No favorites saved",
    "emptyHint": "Mark properties with the bookmark icon to see them here",
    "filterCanton": "Canton",
    "filterStatus": "Status",
    "filterType": "Property type",
    "notifications": {
      "active": "active",
      "award": "Award",
      "disableAll": "All off",
      "enableAll": "All on",
      "newDocuments": "New documents",
      "offerPhase": "Offer phase",
      "priceChange": "Price changes",
      "statusChange": "Status changes",
      "title": "Notifications"
    },
    "properties": "properties",
    "removeFromList": "Remove from watchlist",
    "removed": "Removed from watchlist",
    "sortBy": "Sort by",
    "sortCity": "City",
    "sortDate": "Date",
    "sortPrice": "Price",
    "title": "Watchlist",
    "toggleFailed": "Failed to update watchlist"
  },
  "fundRadar": {
    "asOf": "As of: {{date}}",
    "capacity": "Buying power",
    "capacityGreen": "fresh money",
    "capacityGrey": "no indication",
    "capacityRed": "blocked",
    "capacityYellow": "possible",
    "colAgio": "Premium",
    "colAsOf": "As of",
    "colAum": "AUM",
    "colCompany": "Company",
    "colFund": "Vehicle",
    "colLtv": "LTV",
    "colReason": "Why",
    "colSignals": "Signals",
    "empty": "No vehicles with this signal.",
    "filterAll": "All",
    "filterAria": "Filter by signal",
    "filterBuy": "Buying",
    "filterNone": "No signal",
    "filterSell": "Selling",
    "noValue": "No data",
    "openCompany": "Open organization «{{name}}»",
    "pressure": "Selling pressure",
    "pressureGrey": "no indication",
    "pressureRed": "high",
    "pressureYellow": "medium",
    "searchLabel": "Search vehicle or company",
    "searchPlaceholder": "Search vehicle or company …",
    "subtitle": "Red selling pressure = end of term, merger or redemptions. Green buying power = fresh money (capital increase, subscriptions open). A discount means the vehicle cannot raise equity, but it does not have to sell.",
    "title": "Fund radar"
  },
  "help": {
    "close": "Close",
    "contacts": {
      "description": "Manage all contact persons and authorized signatories.",
      "steps": [
        "Create new contacts with 'New Contact'",
        "Assign contacts to one or more companies",
        "Create a user account for the contact if needed"
      ],
      "tips": [
        "Contacts can be assigned to multiple companies",
        "Signing authority is set per company",
        "User accounts enable login to the platform"
      ],
      "title": "Contacts"
    },
    "contextual": "Help for this page",
    "contractGenerator": {
      "description": "Create professional contracts in a few steps.",
      "steps": [
        "Step 1: Select a template (Terms, Buyer Agreement, etc.)",
        "Step 2: Fill in the required data",
        "Step 3: Review the contract preview",
        "Step 4: Collect signatures",
        "Step 5: Download the finished PDF"
      ],
      "tips": [
        "Use Zefix search to automatically load company data",
        "Signatures can be made with mouse or finger on touch devices",
        "Email addresses are validated (MX record check)"
      ],
      "title": "Contract Generator"
    },
    "contracts": {
      "description": "Create and manage your contracts digitally.",
      "steps": [
        "Click 'New Contract' to create a contract",
        "Select a contract template",
        "Fill in the parties and data",
        "Review the preview",
        "Collect digital signatures"
      ],
      "tips": [
        "Contracts can only be deleted in 'Draft' status",
        "You can save contracts as drafts and sign them later",
        "All signatures are saved with timestamp and optionally with location"
      ],
      "title": "Contracts"
    },
    "dashboard": {
      "description": "Your central overview of all important information and quick actions.",
      "steps": [
        "View your statistics at a glance",
        "Use quick actions for frequent tasks",
        "Switch between your assigned companies"
      ],
      "tips": [
        "Use the company filter at the top right to filter data by company"
      ],
      "title": "Dashboard"
    },
    "general": "General help",
    "organizations": {
      "description": "Manage companies and their authorized signatories.",
      "steps": [
        "Companies are automatically recorded when contracts are concluded",
        "Click on a company to view contacts",
        "Use 'Update from Zefix' to load current commercial register data"
      ],
      "tips": [
        "Pinned contacts are not deactivated during Zefix sync",
        "Manual contacts are automatically pinned",
        "Contacts with contract signatures cannot be deleted"
      ],
      "title": "Organizations"
    },
    "properties": {
      "description": "Manage your property portfolio.",
      "steps": [
        "Add new properties with all details",
        "Upload images and documents",
        "Manage status (Draft, Active, Reserved, Sold)"
      ],
      "tips": [
        "Properties in 'Draft' status are not publicly visible",
        "Multi-language descriptions are possible"
      ],
      "title": "Properties"
    },
    "settings": {
      "description": "System configuration and administration.",
      "steps": [
        "Manage internal authorized signatories",
        "View the database schema"
      ],
      "tips": [
        "Internal authorized signatories are managed here"
      ],
      "title": "Settings"
    },
    "signatories": {
      "description": "Manage the internal authorized signatories of your company.",
      "steps": [
        "Select an existing contact",
        "Set the function (e.g., CEO)",
        "Define signing authority (Individual or Collective)"
      ],
      "tips": [
        "These persons appear as signers on Immotron contracts",
        "The signature text appears below the signature in the PDF"
      ],
      "title": "Authorized Signatories"
    },
    "title": "Help",
    "users": {
      "description": "Manage user accounts and permissions.",
      "steps": [
        "Create new users with 'Add User'",
        "Assign a role (Admin, Sales, Investor)",
        "Optional: Link the user to a contact"
      ],
      "tips": [
        "Admins have access to all functions",
        "Sales users can manage contracts and properties",
        "Investors can only search and view their portfolio"
      ],
      "title": "User Management"
    }
  },
  "investor": {
    "access": {
      "accessCount": "{{count}} investor(s) with access",
      "accessGranted": "Access granted",
      "accessViaDirect": "direct",
      "accessViaGroup": "via group {{name}}",
      "date": "Date",
      "emailBounced": "Email not deliverable",
      "emailClicked": "Link clicked",
      "emailNotSent": "Email not sent",
      "emailOpened": "Email opened",
      "emailSent": "Email sent",
      "grantAccess": "Grant Access",
      "grantSuccess": "Access granted successfully",
      "grantSuccessWithEmail": "Access granted — investor will be notified by email",
      "groupAccessHint": "Access via group — can only be revoked by removing from group",
      "manual": "Manual",
      "noInvestors": "No investors with access yet",
      "revokeAccess": "Revoke Access",
      "revokeConfirm": "Are you sure you want to revoke access for this investor?",
      "revokeSuccess": "Access revoked successfully",
      "searchHint": "Search by name or email",
      "searchInvestor": "Search investor...",
      "selfService": "Self",
      "source": "Source",
      "title": "Investor Access"
    },
    "activity": {
      "bounced": "Not deliverable",
      "clicked": "Clicked",
      "failed": "Failed",
      "noActivity": "No notifications yet",
      "opened": "Opened",
      "sent": "Sent",
      "title": "Notifications",
      "type": {
        "ACCESS_GRANTED": "Access granted",
        "DOSSIER_UPDATE": "New document",
        "INTEREST_EXPRESSED": "Interest confirmed",
        "INTEREST_SALES_NOTIFY": "Sales notified"
      }
    },
    "dossier": {
      "backToTeaser": "Back to Overview",
      "clearSelection": "Clear selection",
      "documentsCount": "{{count}} document(s)",
      "documentsLabel": "Documents",
      "download": "Download",
      "downloadPdf": "Dossier as PDF",
      "downloadUnavailable": "Download not available",
      "groups": {
        "custom": "Custom",
        "investor_dossier": "Exposé",
        "supplementary": "Supplementary Documents",
        "valuation": "Valuation Documents"
      },
      "lastUpload": "Last Upload",
      "newBadge": "New",
      "newCount": "{{count}} new",
      "noAccess": "No Access",
      "noAccessHint": "You need access to the exposé. Please express your interest first.",
      "noDocuments": "No documents in this category",
      "offerHint": "Fixed-price sale — submit your offer on the property page.",
      "pdfDownloaded": "Dossier PDF downloaded",
      "pdfFailed": "PDF download failed",
      "previewSelected": "Preview",
      "selected": "selected",
      "subtitle": "Complete Documentation",
      "title": "Exposé"
    },
    "expose": {
      "pages": "{{count}} pages",
      "read": "Read exposé",
      "title": "Exposé"
    },
    "interest": {
      "agbNote": "By expressing interest, you confirm that the applicable terms and NDA provisions of your platform subscription apply.",
      "alreadyExpressed": "You have already expressed interest in this property.",
      "confirm": "Confirm Interest",
      "description": "You are expressing interest in the following property:",
      "salesNotified": "The sales team has been notified about your interest.",
      "success": "Interest expressed successfully",
      "successHint": "You now have access to the full exposé.",
      "successWithEmail": "Confirmation sent by email. You now have access to the dossier.",
      "title": "Express Interest"
    },
    "listing": {
      "includedProperties": "Included properties",
      "ndaConfirmAccess": "Confirm NDA & get access",
      "ndaConfirmHint": "Confirm the non-disclosure agreement to access the full dossier.",
      "properties": "Properties",
      "propertyIndex": "Property {{index}}",
      "submitOffer": "Submit offer",
      "totalPrice": "Total price"
    },
    "nda": {
      "bracketFrom": "from {{from}}",
      "bracketRange": "{{from}} to {{to}}",
      "bracketsTitle": "Buyer's commission (tiers on the purchase price):",
      "checkbox": "I have read the non-disclosure agreement and accept it.",
      "commissionModel": "Commission model",
      "conditionsCheckbox": "I have read the conditions for this property and accept them.",
      "conditionsLoading": "Loading conditions …",
      "conditionsTitle": "Conditions for this property",
      "confidentialityText": "All information provided to you as part of this exposé is strictly confidential. You agree not to disclose this information to third parties and to use it solely for the purpose of evaluating the investment opportunity.",
      "confidentialityTitle": "Confidentiality",
      "confirm": "Confirm & Open Dossier",
      "criteriaText": "You confirm that this property meets your investment criteria and that you have the necessary financial resources to carry out a potential transaction.",
      "criteriaTitle": "Investment Criteria",
      "decline": "Back",
      "dueNote": "The commission is due upon notarisation of the purchase agreement.",
      "findersFeeText": "Upon completion of a transaction, a finder's fee will be due in accordance with the agreed terms. Circumventing the intermediary is not permitted.",
      "findersFeeTitle": "Finder's Fee",
      "flatRate": "Flat rate: {{rate}} of the purchase price.",
      "noModel": "No commission model is currently defined for this property. The conditions are governed by the buyer framework agreement or by Appendix B to the property.",
      "sourceAppendixB": "Property-specific (Appendix B)",
      "sourceDefault": "Standard conditions",
      "specialConditionsTitle": "Special conditions",
      "successContinue": "Continue to dossier",
      "successText": "Your confirmation has been recorded. You agreed to these conditions:",
      "successTitle": "NDA and conditions confirmed",
      "title": "Non-Disclosure Agreement (NDA)",
      "vatNote": "All commission figures are exclusive of statutory VAT.",
      "objection": {
        "button": "Do not accept terms",
        "title": "Reject terms",
        "intro": "State the rate you propose and explain your objection. The seller side reviews the counter-proposal — until then you will not get access to the property data.",
        "rateLabel": "Proposed rate (optional)",
        "ratePlaceholder": "e.g. 2.5",
        "rateHint": "Percent of the purchase price. Without a rate only the reason is submitted.",
        "reasonLabel": "Reason",
        "reasonPlaceholder": "Why do you not accept the terms?",
        "reasonRequired": "Without a reason the objection cannot be sent.",
        "back": "Back",
        "submit": "Send objection",
        "sentTitle": "Objection submitted",
        "sentText": "Your objection has been recorded. The seller side reviews your counter-proposal and will contact you. Until then the property data stays closed."
      }
    },
    "search": {
      "accessGranted": "Access Granted",
      "allCantons": "All Cantons",
      "allTypes": "All Types",
      "areaFrom": "Area from (m²)",
      "areaTo": "Area to (m²)",
      "canton": "Canton",
      "clearFilters": "Clear filters",
      "contractError": {
        "CONTRACT_EXPIRED": {
          "message": "Your platform contract has expired. Please contact your account manager for renewal.",
          "title": "Platform contract expired"
        },
        "NO_ACTIVE_CONTRACT": {
          "message": "There is no active platform contract. Please contact your account manager.",
          "title": "No active platform contract"
        }
      },
      "errorTitle": "Loading error",
      "filters": "Filters",
      "loadError": "Properties could not be loaded. Please try again.",
      "noResults": "No properties found",
      "noResultsHint": "Adjust your search criteria",
      "placeholder": "City, region or postal code...",
      "priceFrom": "Price from (CHF)",
      "priceRange": "Price Range",
      "priceTo": "Price to (CHF)",
      "resultsCount": "{{count}} properties found",
      "sortNewest": "Newest first",
      "sortPriceAsc": "Price ascending",
      "sortPriceDesc": "Price descending",
      "sortSizeDesc": "Largest first",
      "subtitle": "Find your next investment",
      "title": "Property Search"
    },
    "teaser": {
      "accessGranted": "Access granted",
      "accessGrantedHint": "You have access to the full exposé for this property.",
      "approximateLocation": "Approximate location",
      "atAGlance": "At a glance",
      "backToSearch": "Back to search",
      "buildingPermit": "Building Permit",
      "confirmNda": "I confirm the non-disclosure agreement (NDA)",
      "description": "Description",
      "emptyGallery": "Images coming soon",
      "exclusiveMandate": "Exclusive off-market mandate",
      "financial": {
        "title": "Financial snapshot",
        "grossYield": "Gross yield",
        "netYield": "Net yield",
        "annualIncome": "Rental income p.a.",
        "factor": "Factor (× annual rent)",
        "vacancy": "Vacancy",
        "pricePerSqm": "Price/m²",
        "rentPerSqm": "Rent/m² p.a.",
        "netYieldAssumption": "Assumption: 18% operating costs"
      },
      "locked": "After NDA",
      "lockedLocation": "Location after NDA",
      "lockedLocationHint": "The exact location becomes visible after signing the non-disclosure agreement.",
      "region": "Region {{canton}}",
      "regionAddress": "{{region}} · exact address after NDA",
      "ndaRequired": "NDA required",
      "lockedLocationPlaceholder": "The property is conveniently located in an established municipality with good public transport links as well as shopping facilities and schools in the immediate vicinity.",
      "signNda": "Sign NDA",
      "technicalDetails": "Technical details",
      "detailLabels": {
        "buildingCount": "Number of Buildings",
        "cadastreNumber": "Cadastral No.",
        "commercialUnits": "Commercial Units",
        "condition": "Condition",
        "constructionYear": "Year of Construction",
        "egridNumber": "E-GRID No.",
        "garageParking": "Garage Parking",
        "heatingSystem": "Heating System",
        "lotSize": "Lot Size",
        "outdoorParking": "Outdoor Parking",
        "propertyType": "Category / Use Type",
        "renovation": "Renovation",
        "residentialUnits": "Residential Units",
        "usableArea": "Usable Area",
        "utilizationFactor": "Floor Area Ratio",
        "volume": "Volume"
      },
      "details": "Details",
      "expressInterest": "Express Interest",
      "grossYield": "Gross Yield",
      "highlights": "Investment Highlights",
      "interestedHint": "Express your interest to gain access to the full dossier.",
      "interestedTitle": "Interested in this property?",
      "keyFacts": "Key Facts",
      "location": "Location",
      "macroLocation": "Macro Location",
      "microLocation": "Micro Location",
      "netYield": "Net Yield",
      "ownership": "Ownership",
      "openInGoogleMaps": "Open in Google Maps",
      "price": "Price",
      "privateListingNotice": "This property is a private listing and only accessible to selected investors.",
      "salesContact": "Your Contact Person",
      "title": "Property Overview",
      "type": "Type",
      "usableArea": "Usable Area",
      "viewDossier": "View Dossier",
      "viewOnMaps": "View on Google Maps",
      "yearBuilt": "Year Built",
      "gallery": {
        "openFullscreen": "Open gallery in fullscreen",
        "close": "Close fullscreen"
      },
      "preview": {
        "previewAs": "Preview as",
        "levels": {
          "buyer_no_nda": "Buyer without NDA",
          "buyer_nda": "Buyer with NDA",
          "internal": "Internal"
        },
        "internalBlockTitle": "Internal section",
        "internalBlockHint": "Visible to internal users only — not part of the buyer view.",
        "investorGroups": "Investor groups",
        "noInvestorGroups": "No investor groups assigned.",
        "memberCount": "{{count}} members",
        "noMembers": "No members",
        "memberType": {
          "user": "User",
          "company": "Company",
          "contact": "Contact"
        }
      }
    },
    "viewer": {
      "close": "Close preview",
      "exitFullscreen": "Exit full screen",
      "fullscreen": "Full screen",
      "loadError": "The preview could not be loaded.",
      "page": "Page {{current}} of {{total}}"
    },
    "dealStage": {
      "bo": "BO abgegeben",
      "nbo": "NBO abgegeben",
      "offer": "Angebot abgegeben",
      "nda": "NDA unterzeichnet",
      "teaser": "Teaser verfügbar"
    }
  },
  "investorContracts": {
    "active": "Active contracts",
    "expired": "Expired contracts",
    "subtitle": "Overview of your contracts",
    "title": "My Contracts"
  },
  "investorGroups": {
    "addGroupAccess": "Grant Group Access",
    "addMember": "Add Member",
    "addMemberSuccess": "Member added successfully",
    "createGroup": "Create Group",
    "createSuccess": "Group created successfully",
    "deleteConfirm": "Are you sure you want to delete the group \"{{name}}\"? All group access will be revoked.",
    "deleteGroup": "Delete Group",
    "deleteSuccess": "Group deleted successfully",
    "description": "Description",
    "editGroup": "Edit Group",
    "grantAccessSuccess": "Group access granted successfully",
    "groupAccess": "Group Access",
    "hideRecipients": "Hide recipients of {{name}}",
    "memberCompanyCount": "{{count}} companies",
    "memberCount": "{{count}} member(s)",
    "memberTypeCompany": "Company",
    "memberTypeContact": "Contact",
    "members": "Members",
    "name": "Name",
    "noGroups": "No investor groups created yet",
    "noMembers": "No members in this group yet",
    "noRecipients": "no recipient",
    "recipientCount": "{{count}} recipient(s)",
    "removeGroupAccess": "Revoke Group Access",
    "removeMember": "Remove Member",
    "removeMemberConfirm": "Are you sure you want to remove this investor from the group?",
    "removeMemberSuccess": "Member removed successfully",
    "revokeAccessSuccess": "Group access revoked successfully",
    "searchInvestor": "Search contact or company …",
    "searchNoResults": "No contacts or companies found",
    "selectGroup": "Select group",
    "showRecipients": "Show recipients of {{name}}",
    "skippedWithoutEmail": "{{count}} contacts without email",
    "subtitle": "Group investors and manage bulk access",
    "title": "Investor Groups",
    "updateSuccess": "Group updated successfully"
  },
  "investorSettings": {
    "activities": {
      "empty": "No activities in this period",
      "emptyAll": "No activities yet",
      "emptyHint": "Try a longer period or select 'All' to see more entries.",
      "entries": "Entries",
      "errorHint": "Please check your internet connection and try again.",
      "errorRetry": "Try again",
      "filter30d": "30 days",
      "filter7d": "7 days",
      "filter90d": "90 days",
      "filterAll": "All",
      "filterLabel": "Period",
      "loadError": "Failed to load activities",
      "title": "My Activities",
      "type": {
        "CONTRACT_SIGNED": "Contract signed",
        "DOCUMENTS_RECEIVED": "Documents received",
        "FAVORITE_ADDED": "Favorite added",
        "INQUIRY_RECEIVED": "New inquiry received",
        "INTEREST_EXPRESSED": "Interest expressed",
        "INVESTOR_INTEREST_RECEIVED": "New investor interest received",
        "LISTING_CREATED": "Listing created",
        "LISTING_PUBLISHED": "Listing published",
        "MESSAGE_RECEIVED": "Message received",
        "NDA_CONFIRMED": "NDA confirmed",
        "OFFER_SUBMITTED": "Offer submitted",
        "PROFILE_UPDATED": "Profile updated",
        "PROPERTY_CREATED": "Property created",
        "VIEWING_CONFIRMED": "Viewing confirmed"
      }
    },
    "contracts": {
      "contactUs": "Contact us",
      "downloadPdf": "Download contract as PDF",
      "empty": "No contracts found",
      "expiredNotice": "This contract has expired. Please contact us to renew.",
      "expiresAt": "Expires on",
      "signedAt": "Signed on",
      "status": {
        "CANCELLED": "Cancelled",
        "CUSTOMER_SIGNED": "Customer Signed",
        "DRAFT": "Draft",
        "EXPIRED": "Expired",
        "SENT": "Sent",
        "SIGNED": "Signed",
        "TERMINATED": "Terminated"
      },
      "type": {
        "BROKER_AGREEMENT": "Broker Agreement",
        "PLATFORM_AGREEMENT": "Platform Agreement",
        "SEARCH_MANDATE": "Search Mandate"
      }
    },
    "passkeys": {
      "addPasskey": "Add Passkey",
      "confirmDelete": "Really remove?",
      "confirmDeleteBtn": "Confirm removal",
      "deleteError": "Failed to remove passkey",
      "deleteSuccess": "Passkey removed successfully",
      "deviceName": "Device name",
      "deviceNamePlaceholder": "e.g. Max's iPhone",
      "editName": "Edit name",
      "empty": "No passkeys registered yet",
      "lastPasskeyWarning": "This is your only passkey. After removal, you can still sign in with your password.",
      "lastUsed": "Last login",
      "notSupported": "Your browser does not support passkeys. Please use a modern browser.",
      "registerError": "Failed to register passkey",
      "registerSuccess": "Passkey registered successfully",
      "registeredAt": "Registered",
      "registrationCancelled": "Passkey registration cancelled",
      "removePasskey": "Remove passkey",
      "renameError": "Failed to save device name",
      "renameSuccess": "Device name saved",
      "subtitle": "Manage passkeys for faster and more secure sign-in",
      "title": "Login Methods",
      "unnamedDevice": "Unnamed device"
    },
    "profile": {
      "changePassword": "Change Password",
      "changePasswordBtn": "Change Password",
      "companies": "Company Memberships",
      "confirmPassword": "Confirm Password",
      "currentPassword": "Current Password",
      "currentPasswordWrong": "The current password is incorrect",
      "email": "Email Address",
      "firstName": "First Name",
      "forgotCurrentPassword": "Don't know your current password? Set a new one by e-mail",
      "hidePassword": "Hide password",
      "lastName": "Last Name",
      "newPassword": "New Password",
      "noPasswordSet": "No password is set for this account. Set one via the e-mail link.",
      "passwordError": "Failed to change password. Please check your current password.",
      "passwordLinkError": "The link could not be sent. Please try again later.",
      "passwordLinkSent": "We have sent a link to {{email}}. Use it to set your password.",
      "passwordMismatch": "Passwords do not match",
      "passwordSuccess": "Password changed successfully",
      "personalInfo": "Personal Information",
      "readOnly": "Read only",
      "saveError": "Failed to save profile",
      "saveSuccess": "Profile saved successfully",
      "sendPasswordLink": "Send link by e-mail",
      "setPassword": "Set password",
      "setPasswordHint": "No password is set for this account yet — you sign in via link, passkey or mobile signature. We will send you an e-mail link to set a password.",
      "showPassword": "Show password",
      "weakPassword": "Password does not meet the requirements"
    },
    "subtitle": "Manage your account and contracts",
    "tabs": {
      "activities": "Activities",
      "contracts": "Contracts",
      "invoices": "Invoices",
      "notifications": "Notifications",
      "privacy": "Privacy",
      "profile": "Profile"
    },
    "title": "Settings"
  },
  "invoices": {
    "columns": {
      "actions": "Actions",
      "amount": "Amount",
      "date": "Date",
      "dueDate": "Due Date",
      "number": "Invoice No.",
      "property": "Property",
      "status": "Status"
    },
    "download": "Download PDF",
    "downloadFailed": "PDF download failed",
    "empty": "No invoices available",
    "emptyHint": "Your invoices will appear here once they are created",
    "filters": {
      "allStatuses": "All statuses",
      "fromDate": "From",
      "status": "Status",
      "toDate": "To"
    },
    "loadFailed": "Failed to load invoices",
    "openWarning": "You have {{count}} open or overdue invoice(s)",
    "statuses": {
      "CANCELLED": "Cancelled",
      "OPEN": "Open",
      "OVERDUE": "Overdue",
      "PAID": "Paid"
    },
    "title": "Invoices"
  },
  "kyc": {
    "badge": {
      "exempt": "No identification required",
      "exemptHint": "Your company is supervised (FINMA or similar) — a personal identification is not required.",
      "pending": "Identification pending",
      "verified": "Identified"
    },
    "capture": {
      "analysis": {
        "continueAnyway": "Continue anyway",
        "critiqueTitle": "Please take a new picture of the {{slot}}.",
        "prefilled": "We have read your ID document — please check it briefly.",
        "quality": {
          "blurry": "The picture is blurred.",
          "cut_off": "The ID document is not fully in the picture.",
          "glare": "There is a reflection on the picture — please take a new one away from direct light.",
          "not_document": "We could not recognise an ID document."
        },
        "retake": "Take a new picture",
        "skip": "Continue without the check and fill it in myself",
        "waitHint": "This may take a moment.",
        "waitTitle": "We are reading your ID document …"
      },
      "camera": {
        "backDefault": "Rear camera (default)",
        "denied": "We are not allowed to use your camera. Allow access in your browser or upload photos instead.",
        "deniedFallback": "We are not allowed to use your camera. Please upload the pictures as files instead.",
        "documentHint": "All four corners in the picture, no reflections.",
        "frameHint": "Place the ID document exactly inside the frame.",
        "frontDefault": "Front camera (default)",
        "lowResolution": "The capture is small ({{width}} × {{height}} px). Move closer to the document or choose a better camera.",
        "numbered": "Camera {{n}}",
        "previewAlt": "Preview of the capture",
        "retake": "Retake",
        "select": "Camera",
        "selfieGuideHint": "Face into the oval, hand into the outline.",
        "selfieHint": "Your face clearly visible, without headwear.",
        "shutter": "Take picture",
        "starting": "Starting the camera …",
        "unavailable": "We cannot find a camera on this device. Please upload photos or a PDF copy instead.",
        "unavailableFallback": "We cannot find a camera on this device. Please upload the pictures as files instead.",
        "use": "Use"
      },
      "details": {
        "country": "Country of issue",
        "countryHint": "Two letters, e.g. CH, DE or FR.",
        "expiry": "Valid until",
        "lead": "Just the country of issue — number and expiry date are optional.",
        "number": "Document number",
        "submit": "Submit for review",
        "title": "Document details"
      },
      "documentTypes": {
        "ID_CARD": "Identity card",
        "OTHER": "Other official ID",
        "PASSPORT": "Passport",
        "RESIDENCE_PERMIT": "Residence permit"
      },
      "errors": {
        "allSlotsFilled": "All pages have been captured already. Use «Replace» to exchange a picture.",
        "alreadySubmitted": "This identification has already been submitted and is under review.",
        "expired": "This document has expired. Please use a valid document.",
        "incomplete": "Some pictures are still missing:",
        "submitFailed": "Submitting did not work. Please try again.",
        "tooLarge": "The file is too large. Files up to 15 MB are allowed.",
        "uploadFailed": "The file could not be transmitted. Please try again.",
        "wrongType": "We cannot read this format. JPG, PNG, HEIC and PDF are allowed."
      },
      "face": {
        "loading": "Preparing face detection …",
        "multiple": "Only one person in the picture.",
        "none": "No face detected.",
        "offCenter": "Move your face into the oval.",
        "showFingersNow_one": "Show {{count}} finger now",
        "showFingersNow_other": "Show {{count}} fingers now",
        "steady": "Hold still …",
        "tooLarge": "A little further away.",
        "tooSmall": "A little closer."
      },
      "liveness": {
        "LOOK_UP": "Look up",
        "SHOW_FINGERS": "Show {{count}} fingers",
        "SHOW_TWO_FINGERS": "Show two fingers",
        "TURN_HEAD_LEFT": "Turn your head to the left",
        "TURN_HEAD_RIGHT": "Turn your head to the right",
        "instructions": {
          "LOOK_UP": "Look up briefly",
          "SHOW_FINGERS_one": "Hold up {{count}} finger next to your face",
          "SHOW_FINGERS_other": "Hold up {{count}} fingers next to your face",
          "SHOW_TWO_FINGERS": "Hold two fingers next to your face",
          "TURN_HEAD_LEFT": "Turn your head slightly to the left",
          "TURN_HEAD_RIGHT": "Turn your head slightly to the right"
        },
        "title": "Your task for the selfie"
      },
      "scanner": {
        "backgroundHint": "Tip: Place the ID document on a dark, plain surface — or take the picture yourself with «Take picture».",
        "closer": "Move closer.",
        "loading": "Loading the scanner …",
        "searching": "Hold the ID document inside the frame.",
        "steady": "Hold still …",
        "straightened": "ID document straightened automatically"
      },
      "setup": {
        "documentType": "Which document are you presenting?",
        "lead": "We need a picture of your ID and a selfie. You can take both right here or upload them as files.",
        "live": "Use the camera",
        "liveDesc": "Phone camera or webcam — ID and selfie in two minutes.",
        "title": "Capture your ID",
        "upload": "Upload files",
        "uploadDesc": "Photos (JPG, PNG, HEIC) or a PDF copy of your ID."
      },
      "slots": {
        "back": "Back of the ID",
        "front": "Front of the ID",
        "pdf": "PDF copy of the ID",
        "selfie": "Selfie"
      },
      "summary": {
        "lead": "This is how we stored your captures. If something is blurred or cut off, take it again.",
        "pdfNote": "PDF copy",
        "previewUnavailable": "Preview not available — the file is stored.",
        "retake": "Retake",
        "title": "Your captures"
      },
      "upload": {
        "choose": "Choose files",
        "dropHint": "Drag files here or choose them",
        "formats": "JPG, PNG, HEIC or PDF — up to 15 MB per file.",
        "lead": "Photos of the front and the back — or a PDF copy of the ID. A selfie helps us with the review but is optional here.",
        "nativeCamera": "Take a picture",
        "pdfHint": "Do you have a PDF copy of your ID? Simply upload the PDF — front and back are not needed then.",
        "replace": "Replace",
        "select": "Choose file",
        "title": "Upload files"
      }
    },
    "choice": {
      "autoIdent": "ID + selfie (2 min.)",
      "autoIdentDesc": "Hold your identity card or passport up to the camera, then take a selfie.",
      "regulated": "My company is supervised or listed",
      "regulatedDesc": "Bank, insurer, fund, pension fund or listed company — a confirmation is enough.",
      "swissId": "Sign in with SwissID",
      "swissIdDesc": "Already identified? With SwissID it is done straight away.",
      "title": "How would you like to identify yourself?"
    },
    "done": {
      "generic": "Your identification is on file and valid indefinitely.",
      "regulatedConfirmed": "{{company}} is recorded as a supervised counterparty.",
      "title": "Thank you — that's it",
      "verifiedAt": "Identified on {{date}}",
      "yourCompany": "Your company"
    },
    "errors": {
      "declareFailed": "The confirmation could not be saved. Please try again later.",
      "startFailed": "The identification could not be started. Please try again later."
    },
    "handoff": {
      "continueHere": "Continue here on the computer",
      "expired": "This code has expired. Please generate a new one.",
      "failed": "The code could not be generated. Generate a new one or continue here on the computer.",
      "lead": "Scan the code with your phone camera. The code is valid for {{minutes}} minutes.",
      "phoneStarted": "Opened on your phone — please finish there. This window updates by itself.",
      "qrAlt": "QR code for the identification on your phone",
      "regenerate": "Generate a new code",
      "regenerateHint": "A new code invalidates the previous one.",
      "remaining": "Code valid for another {{time}}",
      "title": "Would you like to do the identification on your phone?"
    },
    "intro": {
      "bodyAfter": "This is your first visit. Since 1 October 2026 the Swiss Anti-Money Laundering Act requires us to identify our contractual partners once — just like your bank. It takes two minutes and is valid permanently.",
      "bodyBefore": "This is your first visit. From 1 October 2026 the Swiss Anti-Money Laundering Act requires us to identify our contractual partners once — just like your bank. It takes two minutes and is valid permanently.",
      "pointDuration": "Two minutes, no form to fill in.",
      "pointOnce": "Done once — valid indefinitely.",
      "start": "Identify now",
      "title": "Welcome to Immotron — a one-time identification"
    },
    "later": "Later",
    "methods": {
      "AUTO_IDENT": "ID + selfie",
      "CHECK_RUN": "Review run",
      "MANUAL": "Recorded manually",
      "REGULATED_SELF_DECLARATION": "Self-declaration as a supervised counterparty",
      "SWISSID": "SwissID"
    },
    "mobile": {
      "done": {
        "body": "Thank you — we are reviewing your details. You can return to your computer.",
        "title": "Submitted, under review"
      },
      "errors": {
        "alreadySubmitted": "Your identification has already been submitted.",
        "expired": "This code has expired.",
        "generic": "The page could not be opened. Please try again.",
        "hint": "Open a new QR code on your computer.",
        "sessionExpired": "The session has expired.",
        "unknown": "Invalid code.",
        "used": "This code has already been used."
      },
      "greeting": "Hello {{name}}",
      "greetingAnonymous": "Hello",
      "lead": "After that you are done — your computer updates by itself.",
      "loading": "One moment, we are opening your identification …",
      "title": "Identification on your phone"
    },
    "pending": {
      "body": "Your identification has started but is not confirmed yet. As soon as the result arrives you will see it here and in the settings.",
      "refresh": "Refresh status",
      "resume": "Continue identification",
      "resumeBody": "Your identification has started but has not been submitted yet. You can pick up where you left off.",
      "resumeTitle": "Identification not completed",
      "title": "Identification in progress"
    },
    "progress": {
      "cards": {
        "seco": "0 hits on the federal sanctions list (SECO)",
        "signature": "Commercial register entry",
        "uid": "UID"
      },
      "continue": "Continue",
      "doneTitle": "Identified",
      "failed": "The check could not be started. We will verify your details manually and get back to you.",
      "followUpBody": "We are still checking your details manually and will get back to you within one working day.",
      "followUpTitle": "Almost there",
      "heading": "One moment — we are verifying your identity",
      "lead": "You can watch live what we compare your details with. This only takes a few seconds.",
      "starting": "One moment, we are verifying your identity …",
      "state": {
        "error": "Under review",
        "hit": "Under review",
        "ok": "Checked",
        "pending": "Under review",
        "running": "Running",
        "skipped": "Not needed",
        "waiting": "Waiting"
      },
      "title": "Check steps"
    },
    "regulated": {
      "authority": "Supervisory authority or source",
      "authorityPlaceholder": "e.g. FINMA, OAK BV, SIX",
      "categories": {
        "LISTED": "Listed company",
        "PUBLIC_LAW": "Public-law corporation",
        "REGULATED": "Supervised by FINMA or OAK BV (bank, insurer, fund, pension fund)"
      },
      "category": "Category",
      "company": "Company",
      "confirm": "I confirm that the company named above is supervised, listed or governed by public law.",
      "description": "If your company is supervised, listed or governed by public law, your confirmation is enough — no personal identification is needed.",
      "noCompany": "No company is linked to your account. Please identify yourself as a person or get in touch with us.",
      "reference": "Licence or register number",
      "submit": "Confirm",
      "title": "Supervised counterparty"
    },
    "review": {
      "title": "Review identifications",
      "subtitle": "Review submitted self-identifications and approve or reject them. An identification is never confirmed automatically.",
      "forbidden": "Admin / AMLA officers only.",
      "empty": "No open identifications.",
      "emptyAll": "No identifications available.",
      "selectHint": "Select a case on the left.",
      "submittedAt": "Submitted",
      "unknownPerson": "Unknown person",
      "captureModeLabel": "Capture mode",
      "checkRunLabel": "Automatic check run",
      "livenessLabel": "Liveness task",
      "fingerCountLabel": "Required number of fingers",
      "fingerCountCheck": "Does the number of fingers in the selfie match?",
      "openInNewTab": "Open in new tab",
      "zoom": "Enlarge {{slot}}",
      "uploadHint": "Uploaded images were not captured live — check them particularly carefully.",
      "correct": "Correct",
      "correctHint": "The corrections are saved together with your decision.",
      "nationalityHint": "Three-letter country code (ISO 3166), e.g. CHE for Switzerland.",
      "nationalityInvalid": "Please enter exactly three letters, e.g. CHE.",
      "approve": "Approve",
      "reject": "Reject",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Why is the identification rejected?",
      "reasonHint": "At least 5 characters.",
      "rejectSubmit": "Submit rejection",
      "approveSuccess": "Identification approved.",
      "rejectSuccess": "Identification rejected.",
      "filter": {
        "open": "Open",
        "all": "All"
      },
      "captureMode": {
        "live": "Captured live",
        "upload": "Uploaded"
      },
      "fieldsSource": {
        "ai": "from AI",
        "reviewer": "corrected by reviewer",
        "customer": "entered by customer"
      },
      "state": {
        "OPEN": "Open",
        "FIRST_APPROVED": "1st approval given — second person required",
        "APPROVED": "Approved",
        "REJECTED": "Rejected"
      },
      "checkRun": {
        "CLEAN": "Check run without findings",
        "HIT": "List hit — check carefully",
        "INCOMPLETE": "Check run incomplete"
      },
      "files": {
        "title": "ID document and selfie",
        "none": "No files available."
      },
      "slot": {
        "front": "ID document front",
        "back": "ID document back",
        "selfie": "Selfie",
        "pdf": "ID document (PDF)"
      },
      "document": {
        "title": "Document data",
        "type": "Document type",
        "country": "Issuing country",
        "number": "Document number",
        "expiry": "Valid until",
        "nationality": "Nationality",
        "expired": "expired"
      },
      "documentType": {
        "ID_CARD": "Identity card",
        "PASSPORT": "Passport",
        "RESIDENCE_PERMIT": "Residence permit",
        "OTHER": "Other document"
      },
      "contact": {
        "title": "Contact",
        "name": "Name",
        "email": "Email",
        "birthday": "Date of birth",
        "company": "Company",
        "open": "Open contact"
      },
      "decisions": {
        "title": "Previous decisions",
        "first": "First review",
        "second": "Second review",
        "reason": "Reason",
        "none": "No decision yet."
      },
      "decision": {
        "APPROVE": "Approved",
        "REJECT": "Rejected"
      },
      "errors": {
        "fourEyes": "The second approval must be given by a different person.",
        "ownIdentification": "You cannot approve your own identification.",
        "alreadyDecided": "This case has already been decided.",
        "reasonRequired": "A reason is required (at least 5 characters).",
        "decisionFailed": "The decision could not be saved."
      },
      "ai": {
        "title": "AI check",
        "hintOnly": "Proposal of the AI — the approval remains a human decision",
        "pending": "AI check running …",
        "approve": "Approve (AI recommends)",
        "recommendation": {
          "approve": "Approval recommended",
          "review": "Please check",
          "reject": "Rejection recommended"
        },
        "checks": {
          "face_match": "Face comparison",
          "finger_count": "Number of fingers in the selfie",
          "mrz_checksum": "Machine-readable zone (MRZ)",
          "not_expired": "Document validity",
          "identity_match": "Name and date of birth",
          "sanctions": "Sanctions lists"
        },
        "result": {
          "ok": "in order",
          "failed": "not in order",
          "unknown": "not checkable"
        }
      },
      "extraction": {
        "title": "Read from the document (AI, hint only)",
        "hintOnly": "Hint only — the approval remains a human decision",
        "pending": "Reading the document data …",
        "failed": "The document data could not be read.",
        "retry": "Read again",
        "match": "Matches the contact",
        "mismatchCount": "{{count}} differences from the contact",
        "mismatchCount_one": "One difference from the contact",
        "disabled": "Automatic reading is switched off.",
        "running": "Reading is already in progress — please wait.",
        "fields": {
          "lastName": "Last name",
          "firstNames": "First name(s)",
          "birthDate": "Date of birth",
          "nationality": "Nationality",
          "documentType": "Document type",
          "documentNumber": "Document number",
          "expiryDate": "Expiry date",
          "mrz": "Machine-readable zone (MRZ)"
        },
        "flags": {
          "LAST_NAME_MISMATCH": "Last name differs from the contact",
          "FIRST_NAME_MISMATCH": "First name differs from the contact",
          "BIRTH_DATE_MISMATCH": "Date of birth differs from the contact",
          "DOCUMENT_EXPIRED": "Document expired"
        }
      }
    },
    "settings": {
      "declareRegulated": "Report company as supervised",
      "lastRun": "Last check",
      "lastRunAt": "Carried out on {{date}}",
      "legalHintAfter": "Since 1 October 2026 the Swiss Anti-Money Laundering Act requires us to identify our contractual partners once. The identification is valid indefinitely.",
      "legalHintBefore": "From 1 October 2026 the Swiss Anti-Money Laundering Act requires us to identify our contractual partners once. The identification is valid indefinitely.",
      "method": "Method: {{method}}",
      "open": "Identification pending",
      "openHint": "You have not identified yourself yet. It takes about two minutes.",
      "pending": "Identification in progress",
      "pendingHint": "The result is not available yet.",
      "regulated": "Supervised counterparty",
      "regulatedHint": "{{company}} is reported as supervised — no personal identification is needed.",
      "restart": "Identify again",
      "runChecks": "Run check",
      "start": "Identify now",
      "title": "Identification",
      "verified": "Identified",
      "verifiedAt": "Identified on {{date}}",
      "verifiedHint": "Your identification is valid indefinitely."
    },
    "stepper": {
      "identification": "1 Identification",
      "label": "Progress of the compliance check",
      "lexKoller": "2 Right to acquire"
    },
    "steps": {
      "IDENT": {
        "error": "The identity check was not successful. Please start it again.",
        "ok": "ID document and selfie confirmed.",
        "pending": "The ident provider has not reported back yet.",
        "running": "We are verifying your identity.",
        "title": "Identity",
        "waiting": "ID document and selfie via the ident provider."
      },
      "REGULATED": {
        "ok": "{{COMPANY_NAME}} is registered as a supervised counterparty.",
        "running": "We are checking whether your company is supervised.",
        "skipped": "No supervision reported — the regular check applies.",
        "title": "Supervised counterparty",
        "waiting": "Checking whether your company is supervised or listed."
      },
      "SECO": {
        "error": "The comparison is currently not possible. We will check this manually.",
        "hit": "We are still checking your details manually and will get back to you.",
        "ok": "No entry on the federal sanctions list.",
        "running": "We are comparing with the federal sanctions list.",
        "title": "SECO sanctions list",
        "waiting": "Comparison with the federal sanctions list."
      },
      "SIGNATORY": {
        "error": "We will clarify the signature authority with you personally.",
        "ok": "You are authorised to sign for {{COMPANY_NAME}}.",
        "running": "We are checking the signature authority.",
        "skipped": "No signature authority needed — you are acting as a private individual.",
        "title": "Signature authority",
        "waiting": "Checking whether you may sign for your company."
      },
      "TRANSPARENCY_REGISTER": {
        "error": "The transparency register is currently unavailable. We will check this manually.",
        "ok": "Nothing to report in the transparency register.",
        "running": "We are checking the transparency register.",
        "skipped": "The comparison starts on 1 October 2026.",
        "title": "Transparency register",
        "waiting": "Comparison with the federal transparency register."
      },
      "ZEFIX": {
        "error": "The commercial register is currently unavailable. We will check this manually.",
        "ok": "{{COMPANY_NAME}} is listed in the Swiss commercial register.",
        "running": "We are checking the commercial register.",
        "skipped": "No check needed — you are acting as a private individual.",
        "title": "Commercial register (Zefix)",
        "waiting": "Matching your company against the Swiss commercial register."
      }
    },
    "stub": {
      "back": "Back to the app",
      "description": "This page replaces the identification provider on the test environment. One click completes the identification — this is not possible in production.",
      "failed": "The simulation could not be completed.",
      "reference": "Reference",
      "simulate": "Simulate identification",
      "success": "Identification completed. You are being redirected.",
      "title": "Simulate identification",
      "unavailable": "The simulation is not available in this environment."
    },
    "submitted": {
      "body": "We are reviewing your details and will get back to you. You can continue using the platform.",
      "title": "Submitted, under review"
    },
    "title": "One-time identification"
  },
  "layout": {
    "endImpersonation": "Back to admin",
    "footer": {
      "allRightsReserved": "All rights reserved.",
      "build": "Build"
    },
    "impersonating": "Logged in as {{name}}",
    "reloadNow": "Reload now",
    "updateAvailable": "A new version is available."
  },
  "compliance": {
    "hint": {
      "action": "Start now",
      "pendingText": "We will get in touch as soon as the review is complete. There is nothing more for you to do.",
      "pendingTitle": "Your identification is being reviewed",
      "retryAction": "Start again",
      "retryText": "The last review could not be completed. Please go through the identification once more.",
      "retryTitle": "Please repeat your identification",
      "statusLink": "View status",
      "textIdent": "One time only, in about two minutes: ID document and a short assessment on acquiring real estate (Lex Koller). After that you will see all documents.",
      "textLexKoller": "Only the short assessment on acquiring real estate (Lex Koller) is still missing.",
      "title": "Please complete your identification"
    }
  },
  "lexKoller": {
    "company": {
      "domicile": "Company domiciled in Switzerland?",
      "domicilePrefilled": "The Swiss domicile of the company is confirmed via Zefix.",
      "foreignOwnership": "Foreign ownership above 33%?",
      "foreignOwnershipDesc": "Share capital or voting rights held by persons abroad.",
      "title": "Company Details"
    },
    "details": {
      "canton": "Canton",
      "noPermit": "None",
      "permit": "Residence Permit",
      "permitB": "B — Residence",
      "permitC": "C — Settlement",
      "permitG": "G — Cross-border commuter",
      "permitL": "L — Short stay",
      "residence": "Resident in Switzerland?",
      "selectCanton": "Select canton...",
      "title": "Residence & Permit"
    },
    "disclaimer": "This is an informational assessment, not legal advice. For binding information, please consult a notary or lawyer.",
    "entityType": {
      "company": "Company / Legal Entity",
      "companyDesc": "AG, GmbH or other legal entity",
      "description": "Please select whether you are buying as an individual or as a company.",
      "person": "Individual",
      "personDesc": "Natural person",
      "title": "Who is acquiring?"
    },
    "errors": {
      "assessFailed": "The assessment could not be saved. Please try again later.",
      "declareFailed": "The confirmation could not be saved. Please try again later."
    },
    "institutional": {
      "confirm": "The company is not foreign-controlled by more than one third (Art. 5 BewG).",
      "description": "{{company}} is registered as a supervised/registered institution ({{source}}). Lex Koller therefore does not apply.",
      "doneBody": "Your confirmation is on file. No Lex Koller restrictions apply to {{company}}.",
      "submit": "Confirm",
      "title": "Lex Koller does not apply",
      "unknownSource": "public register",
      "yourCompany": "your company"
    },
    "later": "Do this later",
    "nationality": {
      "ch": "Switzerland",
      "chDesc": "Swiss citizen (incl. dual nationals)",
      "companyDesc": "Nationality of the beneficial owners.",
      "euEfta": "EU / EFTA",
      "euEftaDesc": "EU or EFTA national",
      "other": "Other Country",
      "otherDesc": "Third-country national",
      "personDesc": "Select your nationality.",
      "title": "Nationality"
    },
    "prefill": {
      "fromIdent": "We took your nationality from your identification — we only ask for what is still missing.",
      "fromDocument": "Taken from your identity document — please check and change it if needed."
    },
    "result": {
      "cantonalApproval": "Cantonal approval required",
      "commercial": "Commercial Property",
      "investmentProperty": "Investment Property",
      "primaryResidence": "Primary Residence"
    },
    "settings": {
      "assessedInfo": "Assessment completed",
      "editAssessment": "Edit assessment",
      "noAssessment": "No assessment available",
      "startAssessment": "Start assessment"
    },
    "status": {
      "conditional": "Conditionally permitted",
      "notApplicableInstitutional": "Not applicable (institutional)",
      "restricted": "Restricted",
      "unrestricted": "Unrestricted"
    },
    "title": "Lex Koller Assessment",
    "auto": {
      "title": "Determined automatically: Swiss citizen — no restriction",
      "description": "Your nationality comes from your identity document. Lex Koller therefore does not restrict you — there is nothing to fill in.",
      "edit": "Change details"
    }
  },
  "linkedinImport": {
    "confirm": {
      "create": "create",
      "execute": "Execute import",
      "merge": "merge",
      "skip": "skip",
      "summary": "{{total}} contacts will be processed:",
      "title": "Confirm import",
      "warningCreate": "New contacts and companies will be created",
      "warningMerge": "Existing entries will be enriched with new information",
      "warningSkip": "Skipped entries will not be modified",
      "warningTitle": "What happens during import?"
    },
    "detail": {
      "error": "Failed to load details",
      "loading": "Loading details...",
      "records": "records",
      "title": "Import details"
    },
    "history": {
      "clickHint": "Click for details",
      "colCreated": "Created",
      "colDate": "Date",
      "colMerged": "Merged",
      "colName": "Name",
      "colRecords": "Records",
      "colSkipped": "Skipped",
      "colStatus": "Status",
      "detailColAction": "Aktion",
      "detailColCompany": "Organization",
      "detailColMatch": "Abgleich",
      "detailColName": "Kontakt",
      "detailJobChanges": "Jobwechsel",
      "detailMerged": "Zusammengeführt",
      "detailNew": "Neu erstellt",
      "detailSkipped": "Übersprungen",
      "detailUpdated": "Aktualisiert",
      "loading": "Details werden geladen...",
      "noDetails": "Keine Details verfügbar",
      "statusCompleted": "Completed",
      "statusFailed": "Failed",
      "statusPending": "Pending",
      "title": "Import history",
      "viewDetail": "Details anzeigen"
    },
    "preview": {
      "aiParsed": "AI Parsed",
      "autoMerge": "Auto-merge",
      "colAction": "Action",
      "colCompany": "Company",
      "colCompanyJob": "Company / Job Title",
      "colEmail": "Email",
      "colMatch": "Match",
      "colName": "Name",
      "company": "Firma",
      "crmMatch": "CRM Match",
      "decideAll": "Please decide on all review entries",
      "executeImport": "Execute import",
      "importData": "Import Data",
      "jobChangeDetected": "Job change detected",
      "jobChanges": "Job changes",
      "matchMethod": "Method",
      "matchScore": "Score",
      "matchedCompany": "Company (CRM)",
      "matchedContact": "Contact",
      "needsReview": "Needs review",
      "newContacts": "New contacts",
      "noMatch": "New",
      "noMatchFound": "No existing contact found",
      "parsedFromHeadline": "Parsed from headline",
      "position": "Jobtitel"
    },
    "result": {
      "backToOverview": "Back to overview",
      "colAction": "Action",
      "colName": "Name",
      "colStatus": "Status",
      "created": "Created",
      "errors": "Errors",
      "merged": "Merged",
      "skipped": "Skipped",
      "title": "Import completed"
    },
    "scraper": {
      "batchSize": "Batch size: 5-100 contacts per run",
      "directSync": "Direct sync: Extension can also send contacts directly to Immotron",
      "step1Desc": "Load Chrome Extension from Immotron repo and activate in Chrome",
      "step1Title": "Install extension",
      "step2Desc": "Open LinkedIn, start extension and let it capture contacts automatically",
      "step2Title": "Scrape contacts",
      "step3Desc": "Download export as JSON file and upload below or sync directly to Immotron",
      "step3Title": "Export JSON & import here",
      "subtitle": "Export contacts directly from LinkedIn",
      "title": "LinkedIn Scraper Chrome Extension"
    },
    "steps": {
      "confirm": "Confirm",
      "preview": "Preview",
      "result": "Result",
      "upload": "Upload"
    },
    "subtitle": "Import LinkedIn contacts and match with existing addresses",
    "title": "LinkedIn Import",
    "toast": {
      "importFailed": "Import fehlgeschlagen"
    },
    "upload": {
      "contactsFound": "{{count}} contacts detected",
      "emptyArray": "Empty array — no contacts found",
      "fileButton": "Load JSON file",
      "fileHint": "Accepts .json files",
      "fileReadError": "Datei konnte nicht gelesen werden",
      "importName": "Import name (optional)",
      "invalidJson": "Invalid JSON format",
      "namePlaceholder": "z.B. LinkedIn Export März 2026",
      "pasteLabel": "Paste JSON",
      "placeholder": "[\n  {\n    \"linkedinUrl\": \"https://linkedin.com/in/...\",\n    \"firstName\": \"John\",\n    \"lastName\": \"Doe\",\n    \"email\": \"john@example.com\",\n    \"currentCompany\": \"Company Ltd\",\n    \"headline\": \"CEO at Company Ltd\"\n  }\n]",
      "previewFailed": "Vorschau fehlgeschlagen",
      "startPreview": "Start preview",
      "validationError": "Validierungsfehler",
      "wrongFormat": "Falsches JSON-Format. Erwartet: [{linkedinUrl, firstName, lastName, ...}]"
    }
  },
  "listings": {
    "addListing": "New Teaser",
    "addProperty": "Add Property",
    "assignedBuyers": {
      "activeBadge": "Access active",
      "companyGroup": "Company {{name}}",
      "conditionDeviates": "differs from the framework agreement",
      "conditionOwnForProperty": "own condition for this property",
      "conditionUnknown": "No conditions set",
      "emailLabelFor": "Email address of {{name}}",
      "emailMissing": "Email missing",
      "emailPlaceholder": "name@company.com",
      "emailSave": "Save",
      "emailSaveFailed": "The email address could not be saved.",
      "emailSaveFor": "Save email address for {{name}}",
      "emailSaved": "Email address saved.",
      "empty": "No buyers assigned yet",
      "inviteCount": "({{count}} invitations)",
      "inviteNever": "not contacted yet",
      "inviteSent": "invited on {{date}}",
      "inviteUsed": "link opened on {{date}}",
      "mixedBadge": "Mixed",
      "pendingBadge": "Onboarding pending",
      "pendingHint": "Skipped at approval: no active buyer contract. Access will be granted automatically once the contract is signed.",
      "personCount": "{{count}} person(s)",
      "plannedCondition": "planned: {{model}}",
      "remove": "Remove",
      "removeConfirm": "Remove assignment?",
      "removeConfirmGroup": "All {{count}} people from \"{{name}}\" will lose access to this property.",
      "removeConfirmPerson": "\"{{name}}\" will lose access to this property. The assignment can be recreated at any time.",
      "removeDone": "Assignment removed.",
      "removeFailed": "Removal failed.",
      "removeFor": "Remove assignment of {{name}}",
      "removeGroup": "Remove all assignments of {{name}}",
      "resend": "Resend e-mail",
      "resendConfirm": "Send invitation again?",
      "resendConfirmText": "{{count}} recipient(s) have already been invited. Sending again invalidates the links sent previously.",
      "resendDone": "Invitation sent again.",
      "resendFailed": "Sending failed.",
      "resendFor": "Resend e-mail to {{name}}",
      "resendGroupCount": "Contact all pending people from {{name}} ({{count}})",
      "resendNoPending": "Nobody in this group is waiting for onboarding",
      "resendSkipped": "No invitation sent: {{reason}}",
      "resendSkippedUnknown": "No reason given",
      "sendAfterApproval": "Sent after approval",
      "singlePersons": "Individuals",
      "skipReason": {
        "no_active_contract": "No active buyer agreement",
        "no_contact": "No contact person on file",
        "no_email": "No email address on file"
      },
      "statusOnApproval": "Access on approval",
      "title": "Assigned buyers",
      "viaGroup": "via group {{name}}"
    },
    "bundle": "Bundle",
    "bundleCreated": "Bundle has been created.",
    "confirmDelete": "Do you really want to delete this teaser? The contained properties will be preserved.",
    "confirmDeleteDescription": "Are you sure you want to delete this teaser?",
    "confirmRemoveProperty": "Do you want to remove this property from the teaser? It will be assigned to a new single teaser.",
    "confirmRemovePropertyDescription": "Are you sure you want to remove this property?",
    "createBundle": "Create Bundle",
    "deleteSuccess": "Teaser has been deleted.",
    "errors": {
      "addPropertyFailed": "Failed to add property",
      "deleteFailed": "Failed to delete teaser",
      "loadFailed": "Failed to load teasers",
      "notFound": "Teaser not found",
      "removePropertyFailed": "Failed to remove property",
      "saveFailed": "Failed to save teaser"
    },
    "fields": {
      "location": "Location",
      "price": "Price",
      "private": "Private",
      "properties": "Contained Properties",
      "public": "Public",
      "status": "Status",
      "title": "Title",
      "totalPrice": "Total Price",
      "type": "Type",
      "timeline": "Timeline",
      "interested": "Interessenten"
    },
    "list": {
      "empty": {
        "description": "Teasers are automatically created when you add a property.",
        "title": "No teasers found"
      }
    },
    "noAvailableProperties": "No more properties available",
    "propertyRemoved": "Property has been removed.",
    "removeProperty": "Remove Property",
    "resultsLabel": "Teasers",
    "selection": {
      "createBundle": "Market together",
      "selectMode": "Selection",
      "selected": "{{count}} selected"
    },
    "single": "Single",
    "statuses": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "DRAFT": "Draft",
      "SOLD": "Sold"
    },
    "subtitle": "Manage teasers and bundles",
    "title": "Teasers",
    "saleMode": {
      "offerCollection": "Bieterverfahren",
      "fixedPrice": "Fixpreis"
    },
    "preview": {
      "title": "Teaser preview",
      "hint": "This is how the investor sees the property",
      "propertyPickerLabel": "Select property for the preview",
      "loadFailed": "Preview could not be loaded."
    },
    "management": {
      "title": "Buyer management",
      "hint": "Add buyers retroactively — via investor groups, AI suggestions or the manual search.",
      "groupsTitle": "Investor groups",
      "groupsLoadFailed": "Investor groups could not be loaded.",
      "groupsEmpty": "No investor groups available.",
      "assignGroups": "Assign {{count}} group(s)",
      "groupsAssigned": "Investor groups assigned — members receive access.",
      "suggestionsTitle": "AI buyer suggestions",
      "load": "Load buyer suggestions",
      "reload": "Recompute",
      "loading": "Computing suggestions …",
      "loadFailed": "Buyer suggestions could not be loaded.",
      "retry": "Try again",
      "empty": "No matching buyers found.",
      "assignSelected": "Assign {{count}} buyer(s)",
      "buyersAssigned": "{{count}} buyer(s) assigned.",
      "manualTitle": "Person search",
      "manualHint": "Manually add CRM contacts or companies as buyers.",
      "assignFailed": "Assignment failed.",
      "conditionsPreview": "Conditions for this property: {{model}}"
    },
    "masterData": {
      "title": "Master data",
      "hint": "Title, status, visibility and total price of the teaser. Sale mode, price and NBO/BO dates are configured in the quality gate.",
      "saved": "Master data saved"
    },
    "stats": {
      "title": "Statistics",
      "hint": "Teaser opens and downloads per investor",
      "loadFailed": "Statistics could not be loaded.",
      "retry": "Try again",
      "empty": "No activity recorded yet.",
      "totalOpens": "Total opens",
      "uniqueVisitors": "Unique visitors",
      "documentViews": "File views",
      "downloads": "Downloads",
      "investor": "Investor",
      "opens": "Opens",
      "lastOpened": "Last opened",
      "viewedDocuments": "Viewed files",
      "downloadedDocuments": "Downloaded files",
      "never": "—"
    }
  },
  "mandanten": {
    "accentColor": "Accent Color",
    "active": "Active",
    "addUser": "Add User",
    "address": "Address",
    "allRoles": "All roles",
    "allUsers": "All Users",
    "brandColors": "Brand Colors",
    "brandColorsHint": "These colors are used in email signatures. Primary color for text and divider, accent color for links.",
    "canton": "Canton",
    "city": "City",
    "confirmDeleteMandant": "Do you really want to permanently delete '{{name}}'? All related data will be removed.",
    "confirmDeleteUser": "Are you sure you want to delete this user? This cannot be undone.",
    "confirmRemove": "Are you sure you want to remove this user?",
    "createAndAssign": "Create & Assign",
    "createMandant": "Create Mandant",
    "createMandantSuccess": "Mandant created",
    "createUser": "Create User",
    "createUserSuccess": "User created and assigned",
    "customTemplate": "Custom Template",
    "deleteConfirmBtn": "Permanently delete",
    "deleteConfirmInput": "Enter '{{name}}' to confirm:",
    "deleteKeys": {
      "campaign_recipients": "Campaign recipients",
      "campaigns": "Campaigns",
      "company_contacts": "Company contacts",
      "contract_bundles": "Contract bundles",
      "contracts": "Contracts",
      "email_templates": "Email templates",
      "offers": "Offers",
      "user_companies": "User assignments"
    },
    "deleteMandant": "Delete tenant",
    "deleteNoRelated": "No related data found",
    "deletePreviewTitle": "The following data will be deleted:",
    "deleteSuccess": "Tenant '{{name}}' and all related data deleted",
    "deleteUser": "Delete User",
    "deleteUserSuccess": "User deleted",
    "directPhone": "Direct Phone",
    "directPhonePlaceholder": "e.g. +41 44 123 45 67",
    "editMandant": "Edit Mandant",
    "editMandantSuccess": "Mandant updated",
    "editUser": "Edit User",
    "email": "Email",
    "empty": "No internal companies found",
    "errors": {
      "loadFailed": "Failed to load Mandanten",
      "loadUsersFailed": "Failed to load users"
    },
    "filterByRole": "Filter by role",
    "function": "Function",
    "functionPlaceholder": "e.g. COO, Board President",
    "houseNumber": "No.",
    "impersonate": "Log in as user",
    "impersonateAction": "Log in",
    "impersonateHint": "Opens a session as this user",
    "impersonateSuccess": "Logged in as {{name}}",
    "inactive": "Inactive",
    "legalForm": "Legal Form",
    "linkCompany": "Link Company",
    "linkCompanySuccess": "Company linked as mandant",
    "logo": "Logo",
    "logoDragOrClick": "Drag logo here or click to select",
    "logoFormatError": "Only PNG, JPG and WebP allowed",
    "logoRemove": "Remove logo",
    "logoSizeError": "File must be 5 MB or less",
    "logoUploadError": "Logo upload failed",
    "logoUploadSuccess": "Logo uploaded successfully",
    "logoUploading": "Uploading logo...",
    "mandantAssignment": "Mandant Assignment",
    "noCompaniesAvailable": "No companies available",
    "noMandant": "–",
    "noPreference": "No Preference",
    "noUsers": "No users assigned",
    "pageSubtitle": "Manage mandants, users and permissions",
    "pageTitle": "Mandant Management",
    "passwordReset": "Password Reset",
    "passwordResetHint": "Sends a reset link via email",
    "phone": "Phone",
    "preferredLanguage": "Preferred Language",
    "primaryColor": "Primary Color",
    "removeFromMandant": "Remove Assignment",
    "removeSuccess": "User removed from mandant",
    "resetLinkCopied": "Reset link copied to clipboard",
    "resetSent": "Reset link sent via email",
    "searchCompany": "Search company...",
    "searchUsers": "Search users...",
    "sectionAddress": "Address",
    "sectionCompany": "Company Details",
    "sectionContact": "Contact",
    "sectionSignature": "Email Signature",
    "selectUser": "Select User",
    "sendReset": "Send Link",
    "signatories": "Signatories",
    "signaturePreview": "Signature Preview",
    "signaturePreviewError": "Failed to load preview",
    "signaturePreviewHint": "Click 'Preview' to see the current email signature.",
    "signatureText": "Signature Text",
    "signatureType": "Signature Authority",
    "signatureTypes": {
      "COLLECTIVE_MORE": "Collective Signature (Multiple)",
      "COLLECTIVE_TWO": "Collective Signature (Two)",
      "NONE": "None",
      "SINGLE": "Single Signature"
    },
    "status": "Status",
    "street": "Street",
    "subtitle": "Manage internal companies and user assignments",
    "tabCreate": "Create New",
    "tabExisting": "Existing",
    "tabMandanten": "Mandanten",
    "tabManual": "Manual",
    "tabUsers": "Users",
    "tabZefix": "Zefix Search",
    "templateActive": "(active)",
    "templateDefault": "(default)",
    "templateHint": "Variables: {{ user_name }}, {{ user_function }}, {{ company_name }}, {{ company_logo_url }}, {{ disclaimer }}, {{ primary_color }}, {{ accent_color }} etc.",
    "templatePlaceholder": "Jinja2 HTML template (empty = default template)",
    "title": "Mandanten",
    "updateUserSuccess": "Changes saved",
    "userDetails": "User Details",
    "userEmail": "Email",
    "userIsActive": "User Active",
    "userMandanten": "Mandant(s)",
    "userName": "Name",
    "userRole": "Role",
    "users": "Users",
    "verbindlichkeitsklausel": "Non-binding clause",
    "verbindlichkeitsklauselHint": "Show clause in email signature",
    "website": "Website",
    "zipCode": "ZIP",
    "actions": "Aktionen"
  },
  "mapView": {
    "approximateLocation": "Approximate location",
    "cluster": "Cluster",
    "exactLocation": "Exact location",
    "gridView": "Grid",
    "kmRadius": "approx. {{km}} km radius",
    "mapView": "Map",
    "showOnMap": "View details"
  },
  "media": {
    "confirmDelete": "Are you sure you want to delete this image?",
    "copyUrl": "Copy URL",
    "delete": "Delete",
    "deleteFailed": "File could not be deleted.",
    "deleteSuccess": "Image deleted",
    "empty": "No media uploaded yet",
    "subtitle": "Manage images and media files",
    "title": "Media",
    "upload": "Upload image",
    "uploadFailed": "Upload failed.",
    "uploadSuccess": "Upload successful.",
    "uploadedAt": "Uploaded at",
    "uploading": "Uploading...",
    "urlCopied": "URL copied to clipboard"
  },
  "missingConditions": {
    "title": "No conditions agreed",
    "assignDescription": "No commission conditions are agreed for the following parties on this property. Without agreed conditions, nothing is assigned.",
    "approveDescription": "No seller conditions are agreed for the principal of this property. Without agreed conditions, the property is not approved.",
    "blockedDescription": "Approval is only possible once conditions are on file for every buyer. Quickest route: set one property condition that applies to all of them.",
    "roles": {
      "buyer": "Buyer",
      "seller": "Seller"
    },
    "entityCompany": "Company",
    "entityContact": "Person",
    "checkedSources": "Checked:",
    "sources": {
      "appendix_b": "Appendix B (property release)",
      "appendix_b_buyer": "Appendix B for this buyer",
      "property": "Property conditions",
      "framework": "Framework agreement rate",
      "default_model": "Tenant default model"
    },
    "setConditions": "Set conditions",
    "setBuyerConditions": "Set terms for this buyer",
    "buyerContractPending": "{{name}}'s buyer agreement has not been countersigned yet — terms can only be set afterwards.",
    "variableHint": "Framework agreement set to «variable»: terms are agreed per property — the default model does not apply here. Add property terms or set them for this buyer.",
    "reasonLabel": "Reason (required)",
    "reasonPlaceholder": "Why should this proceed without agreed conditions?",
    "reasonHint": "Without a reason the action cannot be confirmed. The deliberate confirmation is recorded in the activity log with user and timestamp.",
    "assignAnyway": "Assign anyway",
    "approveAnyway": "Approve anyway",
    "confirmed": "Action confirmed despite the missing conditions.",
    "retryFailed": "The action failed. Please try again.",
    "conditionsSetRetry": "Terms set — the action was carried out."
  },
  "myOffers": {
    "activeOffers": "Active offers",
    "columns": {
      "actions": "Actions",
      "amount": "Amount",
      "date": "Date",
      "proof": "Proof",
      "property": "Property",
      "status": "Status",
      "type": "Type"
    },
    "confirmWithdraw": "Do you really want to withdraw this NBO?",
    "confirmWithdrawDescription": "Are you sure you want to withdraw this offer?",
    "detail": {
      "amount": "Amount",
      "expired": "Expired",
      "financingProof": "Financing Proof",
      "loiSigned": "LOI Signed",
      "no": "No",
      "notUploaded": "Pending",
      "offerType": "Offer Type",
      "reservationExpires": "Reservation expires",
      "submittedAt": "Submitted on",
      "title": "Offer Details",
      "uploaded": "Uploaded",
      "yes": "Yes",
      "conditions": "Bedingungen"
    },
    "empty": "No offers yet",
    "emptyHint": "Your submitted offers will appear here",
    "filters": {
      "allStatuses": "All statuses",
      "allTypes": "All types",
      "status": "Status",
      "title": "Filters",
      "type": "Offer type"
    },
    "loadFailed": "Failed to load offers",
    "statuses": {
      "CANCELLED": "Cancelled",
      "COMPLETED": "Completed",
      "EXPIRED": "Expired",
      "LOST": "Not Selected",
      "PROOF_PENDING": "Proof Pending",
      "REJECTED": "Rejected",
      "RESERVED": "Reserved",
      "SUBMITTED": "Submitted",
      "UNDER_REVIEW": "Under Review",
      "WITHDRAWN": "Withdrawn",
      "WON": "Won"
    },
    "title": "My Offers",
    "types": {
      "BO": "BO",
      "FIXED_PRICE": "Fixed Price",
      "NBO": "NBO"
    },
    "withdraw": "Withdraw",
    "withdrawFailed": "Failed to withdraw NBO",
    "withdrawSuccess": "NBO successfully withdrawn"
  },
  "navigation": {
    "activities": "Activities",
    "addresses": "Addresses",
    "admin": "Administration",
    "aiJobs": "AI Jobs",
    "aiLearning": "Learning Mode",
    "aiUpload": "AI Upload",
    "analyses": "My analyses",
    "bids": "Bids",
    "campaigns": "Campaigns",
    "ceoAgent": "Task Assistant",
    "companies": "Organizations",
    "contactDedup": "Deduplication",
    "contacts": "Contacts",
    "contractExpiredTooltip": "Contract expired — contact us to renew",
    "contracts": "Contracts",
    "createProperty": "Create property",
    "dashboard": "Dashboard",
    "deals": "Deals",
    "emailTemplates": "Email Templates",
    "emails": "Emails",
    "favorites": "Watchlist",
    "fundRadar": "Fund radar",
    "investorSettings": "Settings",
    "investors": "Investors",
    "linkedinImport": "LinkedIn Import",
    "listings": "Teasers",
    "myContracts": "My Contracts",
    "myOffers": "My Offers",
    "myProperties": "My properties",
    "portfolio": "Portfolio",
    "properties": "Properties",
    "qualityGate": "Quality Gate",
    "researchLeads": "Research Leads",
    "schema": "DB Schema",
    "search": "Search",
    "searchProfile": "My search profile",
    "sectionAI": "Artificial Intelligence",
    "sectionAdmin": "Administration",
    "sectionBroker": "Broker",
    "sectionCRM": "CRM",
    "sectionImmobilien": "Properties",
    "sectionInvestor": "Investor",
    "sectionSales": "Sales",
    "sectionSeller": "Seller",
    "sectionSystem": "System",
    "sectionTransactions": "Transactions",
    "settings": "Settings",
    "users": "Users",
    "e2eReports": "E2E Reports",
    "menu": "Menü"
  },
  "nbobo": {
    "bo": {
      "amount": "Purchase Offer",
      "amountPlaceholder": "Amount in CHF",
      "bindingNotice": "This offer is legally binding. By submitting, you commit to the purchase.",
      "conditions": "Conditions (optional)",
      "conditionsPlaceholder": "e.g. Takeover date, special requests",
      "description": "Submit a binding purchase offer. This offer is legally binding.",
      "step1": "Offer",
      "step2": "LOI Signature",
      "step3": "Financing Proof",
      "step4": "Confirmation",
      "submit": "Submit Binding Offer",
      "submitted": "Your BO has been submitted.",
      "title": "Binding Offer (BO)",
      "waitingDecision": "Waiting for seller decision",
      "withdraw": "Withdraw BO",
      "withdrawn": "Your BO has been withdrawn.",
      "stepAmount": "Angebot",
      "stepLoi": "LOI",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Bestaetigung"
    },
    "boPhase": "Binding Offer Phase (BO)",
    "boStatus": {
      "lost": "Not selected",
      "rejected": "Rejected",
      "submitted": "Submitted",
      "withdrawn": "Withdrawn",
      "won": "Awarded"
    },
    "countdown": {
      "ended": "Phase ended",
      "endsIn": "Ends in {{time}}"
    },
    "guidePrice": "Guide Price",
    "minimumPrice": "Minimum Price",
    "nbo": {
      "amount": "Your Offer",
      "amountPlaceholder": "Amount in CHF",
      "conditions": "Conditions (optional)",
      "conditionsPlaceholder": "e.g. Subject to financing, due diligence",
      "description": "Submit a non-binding price offer. This serves as a market sounding.",
      "evaluation": "NBO Evaluation",
      "evaluationPending": "The evaluation of offers is in progress.",
      "median": "Median",
      "nonBindingNotice": "This offer is non-binding and does not constitute a purchase obligation.",
      "offers": "Offers",
      "range": "Range",
      "submit": "Submit NBO",
      "submitted": "Your NBO has been submitted.",
      "title": "Indicative Offer (NBO)",
      "withdraw": "Withdraw NBO",
      "withdrawConfirm": "Do you really want to withdraw your NBO?",
      "withdrawn": "Your NBO has been withdrawn.",
      "stepAmount": "Angebot",
      "stepConditions": "Bedingungen",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Unterschrift",
      "submittedDetail": "Ihr indikatives Angebot wurde erfolgreich eingereicht. Sie werden ueber den weiteren Verlauf informiert."
    },
    "nboPhase": "Indicative Offer Phase (NBO)",
    "nboStatus": {
      "lost": "Not qualified",
      "outbid": "Outbid",
      "rejected": "Rejected",
      "shortlisted": "Shortlisted",
      "submitted": "Submitted",
      "withdrawn": "Withdrawn",
      "won": "Qualified"
    },
    "phase": "Phase",
    "sales": {
      "amount": "Amount",
      "award": "Award",
      "awardConfirm": "Do you want to award this investor?",
      "awardSuccess": "Award has been granted.",
      "awarded": "Awarded",
      "boTab": "BO Phase",
      "date": "Date",
      "financingProof": "Fin. Proof",
      "investor": "Investor",
      "nboTab": "NBO Phase",
      "noOffers": "No offers yet",
      "status": "Status",
      "title": "Offers"
    },
    "status": {
      "closed": "Closed",
      "evaluating": "Evaluating",
      "open": "Open",
      "upcoming": "Upcoming"
    },
    "title": "Offer Process",
    "report": {
      "viewReport": "Auswertung anzeigen",
      "title": "NBO-Auswertung"
    },
    "myOffer": {
      "titleNbo": "Your submitted NBO",
      "titleBo": "Your submitted BO",
      "amount": "Offer amount",
      "status": "Status",
      "submittedAt": "Submitted on",
      "updatedAt": "Last changed",
      "deadline": "Round deadline",
      "loiSigned": "LOI signed",
      "financingProof": "Proof of financing",
      "notAvailable": "Not available",
      "conditions": "Conditions and reservations",
      "noConditions": "No details provided",
      "readOnlyHint": "This view shows your submitted offer. Changes are not possible here."
    }
  },
  "notifications": {
    "allRead": "All notifications read",
    "empty": "No notifications",
    "filterAll": "All",
    "filterUnread": "Unread",
    "markAllRead": "Mark all as read",
    "pushBlocked": "Push blocked",
    "pushDisable": "Disable push",
    "pushEnable": "Enable push",
    "pushEnabled": "Push active",
    "timeAgo": {
      "days": "{{count}}d ago",
      "hours": "{{count}}h ago",
      "justNow": "Just now",
      "minutes": "{{count}} min ago"
    },
    "title": "Notifications",
    "types": {
      "ACCESS_GRANTED": "Access granted",
      "AI_EXTRACTION": "AI extraction completed",
      "AI_EXTRACTION_COMPLETE": "AI extraction completed",
      "BIDDING_ROUND_CLOSED": "Bidding round closed",
      "BIDDING_ROUND_CLOSING_SOON": "Bidding round closing soon",
      "BIDDING_ROUND_OPENED": "Bidding round opened",
      "BID_LOST": "Bid not accepted",
      "BID_SUBMITTED": "Bid submitted",
      "BID_SUBMITTED_SALES": "New bid received",
      "BID_WON": "Bid accepted",
      "CONTRACT_SIGNED_SALES": "Contract signed",
      "CONTRACT_SIGNED_WELCOME": "Welcome – Contract signed",
      "COUNTERSIGN_READY": "Countersign ready",
      "COUNTERSIGN_REMINDER": "Countersign reminder",
      "DOSSIER_UPDATE": "Dossier updated",
      "INTEREST_EXPRESSED": "Interest expressed",
      "INTEREST_SALES_NOTIFY": "New investor interest",
      "NDA_CONFIRMED": "NDA confirmed",
      "SIGNATURE_REQUIRED": "Signature required"
    },
    "unreadCount": "unread",
    "viewAll": "View all"
  },
  "offer": {
    "confirm": {
      "bindingWarning": "By submitting, you make a binding purchase offer at the fixed price. The reservation is valid for 14 days.",
      "financingProof": "Proof of financing",
      "loiSigned": "LOI signed",
      "nonBindingInfo": "By submitting, you are making a non-binding purchase offer. This is not yet a purchase agreement.",
      "price": "Purchase price",
      "property": "Property",
      "submit": "Submit binding offer",
      "title": "Summary",
      "uploadLater": "To be submitted later"
    },
    "dialog": {
      "title": "Submit offer",
      "yourPrice": "Ihr Angebot (CHF)",
      "stepsLabel": "Offer submission steps",
      "steps": {
        "amount": "Your offer",
        "document": "Your document",
        "review": "Review & send"
      },
      "amount": {
        "wholeFrancs": "Whole francs, no centimes.",
        "fixedPrice": "Fixed price: {{price}}",
        "guidePrice": "Guide price: {{price}}",
        "minimumPrice": "Minimum price: {{price}}"
      },
      "document": {
        "title": "Offer document",
        "description": "Use the standard template or upload your own offer document.",
        "standardOption": "Use standard template",
        "customOption": "Upload own document",
        "customDescription": "Upload your own offer document as a PDF. It replaces the standard template.",
        "customHint": "PDF only, max. 50 MB",
        "dropHint": "Drag the offer document here or select it",
        "removeFile": "Remove file",
        "chooseHint": "Please first choose how you would like to submit your offer."
      },
      "reservations": {
        "title": "Reservations",
        "description": "Tick the reservations that apply to your offer. Only the ticked items appear in the document.",
        "templateTitle": "Your offer is subject to the following reservations:",
        "none": "No reservations ticked",
        "loadFailed": "The reservations could not be loaded. You can also submit your offer without reservations."
      },
      "remarks": {
        "title": "Remarks",
        "description": "Note anything about your offer that goes beyond the reservations here — for example a takeover no earlier than a given date. The text is submitted unchanged.",
        "placeholder": "e.g. Takeover no earlier than 1 Jan 2028"
      },
      "summary": {
        "document": "Offer document",
        "standardSigned": "Standard template, signed digitally",
        "noRemarks": "No remarks"
      },
      "template": {
        "heading": "Letter of Intent",
        "subtitleBinding": "Binding declaration of intent to purchase",
        "subtitleNonBinding": "Non-binding declaration of intent to purchase",
        "date": "Date",
        "object": "Property",
        "price": "Purchase price",
        "bodyBinding": "I hereby declare my binding interest in purchasing the property named above at the stated purchase price. This declaration forms the basis for further negotiations and for concluding a notarised purchase agreement.",
        "bodyNonBinding": "I hereby declare my interest in purchasing the property named above at the stated purchase price. This declaration is non-binding and creates no obligation to purchase.",
        "note": "The declaration serves as the basis for the draft purchase agreement prepared by the notary.",
        "signatureLine": "Place, date / signature of the buyer"
      },
      "notice": {
        "binding": "This is a binding offer. By submitting it you commit to the purchase on the stated terms.",
        "nonBinding": "This is a non-binding offer. No purchase agreement is created yet."
      },
      "uploadFailed": "Your offer has been submitted. The following could not be transferred: {{files}}. Please transfer again.",
      "retryUploads": "Transfer files again",
      "success": {
        "title": "Offer submitted",
        "message": "Your offer has been submitted successfully. You will receive a confirmation by email."
      }
    },
    "errors": {
      "alreadySubmitted": "You have already submitted an offer for this property.",
      "noLongerAvailable": "This property is no longer available.",
      "submitFailed": "Offer could not be submitted. Please try again."
    },
    "financing": {
      "browse": "Choose file",
      "description": "Upload a proof of financing (e.g. bank confirmation, financing commitment). You can also submit this later.",
      "dropHint": "Drag file here or click",
      "fileTooLarge": "File is too large (max. 50 MB).",
      "hint": "PDF, PNG or JPG, max. 50 MB",
      "required": "Please upload a proof of financing.",
      "skipForNow": "Submit later",
      "title": "Proof of financing",
      "upload": "Upload proof",
      "uploadFailed": "Upload failed. Please try again.",
      "uploadSuccess": "Proof of financing uploaded successfully.",
      "uploaded": "Uploaded on {{date}}",
      "descriptionOptional": "Laden Sie einen Finanzierungsnachweis hoch (z.B. Bankbestaetigung). Sie koennen diesen auch spaeter nachreichen."
    },
    "loi": {
      "bindingNotice": "By signing, you confirm your binding purchase interest at the stated fixed price. This is not yet a purchase agreement.",
      "description": "Please sign the Letter of Intent (LOI) to confirm your binding interest in the purchase.",
      "nonBindingNotice": "By signing, you confirm your interest in purchasing at the stated price. This is not yet a purchase agreement and is non-binding.",
      "signatoryHint": "Please sign here",
      "signatureLabel": "Your signature",
      "title": "Sign Letter of Intent"
    },
    "status": {
      "awarded": "Awarded",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "expired": "Expired",
      "outbid": "Outbid",
      "proofPending": "Proof pending",
      "rejected": "Rejected",
      "reserved": "Reserved",
      "submitted": "Submitted",
      "withdrawn": "Withdrawn"
    },
    "statusCard": {
      "expired": "Reservation expired",
      "expiresIn": "Expires in {{time}}",
      "submittedAt": "Submitted on {{date}}",
      "title": "Your offer"
    },
    "submitButton": "Submit offer",
    "success": {
      "message": "Your offer has been submitted successfully. You will receive a confirmation by email.",
      "proofReminder": "Please upload the proof of financing within the deadline.",
      "reservationInfo": "Your reservation is valid until {{date}}. Please submit the proof of financing in time.",
      "title": "Offer submitted successfully"
    }
  },
  "organizations": {
    "accentColor": "Accent color",
    "addAddress": "Add address",
    "addContactToOrg": "Add Contact",
    "addEmail": "Add email address",
    "addInfoOwner": "+ Add info owner",
    "addOrganization": "Add Organization",
    "addPhone": "Add phone number",
    "addressAdded": "Address added",
    "addressDeleted": "Address deleted",
    "addressUpdated": "Address updated",
    "addresses": "Addresses",
    "allTypes": "All Types",
    "bindingClauseEnabled": "Binding clause enabled",
    "cancelResearch": "Cancel",
    "cannotDelete": "Cannot delete",
    "cannotDeleteSigned": "Cannot delete: contract signatures exist",
    "canton": "Canton",
    "city": "City",
    "companyTab": "Company",
    "confirmDelete": "Are you sure you want to delete this organization? All associations will also be removed.",
    "contactCreateFailed": "The contact could not be created",
    "contacts": "Contacts",
    "contactsTab": "Contacts",
    "createSuccess": "Organization created successfully",
    "createUser": "Create User",
    "dataQuality": {
      "title": "Data quality",
      "scoreOutOf": "{{score}} of 100 points",
      "openTitle": "Open items ({{count}})",
      "fulfilledSummary": "{{count}} fulfilled",
      "passedOfTotal": "{{passed}} of {{total}} fulfilled",
      "filterIncomplete": "incomplete (< {{min}})",
      "assignedToMe": "Organisation assigned to you",
      "duplicateRow": "Duplicate: {{name}} ({{reason}})",
      "status": {
        "ok": "Complete",
        "warn": "Review",
        "missing": "Missing",
        "alert": "Conflict"
      },
      "actions": {
        "upload_logo": "Upload logo",
        "apply_research": "Apply proposal",
        "run_research": "Start research",
        "sync_zefix": "Update from Zefix",
        "merge_contacts": "Merge contacts",
        "merge_companies": "Merge organisations",
        "assign_owner": "Assign to me",
        "choose_owner": "Choose",
        "add_email": "Add email",
        "add_address": "Add address",
        "edit_search_profile": "Add search profile"
      },
      "checks": {
        "logo": "Logo",
        "generic_email": "Company e-mail",
        "address": "Address",
        "phone": "Phone",
        "zefix_age": "Commercial register",
        "research": "Research",
        "research_pending": "Research proposal",
        "contact_duplicates": "Contact duplicates",
        "company_duplicates": "Duplicate",
        "owner": "Ownership",
        "search_profile": "Search profile",
        "holdings": "Own portfolio"
      }
    },
    "dedupBannerTitle": "Possible duplicates detected:",
    "dedupReasonName": "similar name",
    "dedupReasonUid": "same UID",
    "dedupWarning": "Duplicate?",
    "deleteOrganization": "Delete Organization",
    "deleteSuccess": "Organization deleted successfully",
    "description": "Description",
    "discardResearch": "Discard",
    "discardResearchConfirm": "The research results will be removed from the view. They will be reloaded on the next refresh.",
    "discardResearchTitle": "Discard research?",
    "duplicateUid": "An organization with this UID already exists",
    "editOrganization": "Edit Organization",
    "editRole": "Edit role",
    "email": "Email",
    "emailAdded": "Email address added",
    "emailAddresses": "Email addresses",
    "emailDeleted": "Email address deleted",
    "emailSignatureTemplate": "Email signature template (HTML)",
    "emailUpdated": "Email address updated",
    "filterContacts": "Filter contacts...",
    "hasBlockers": "cannot be deleted because dependencies still exist:",
    "hasProfile": "Company profile available",
    "hideContacts": "Hide Contacts",
    "houseNumber": "House Number",
    "infoOwner": "Info owner (multiple possible)",
    "infoOwnerRole": "Info",
    "isTenant": "Tenant (internal)",
    "keyPersonsFromResearch": "Key Persons (from Research)",
    "legalForm": "Legal Form",
    "logoAlt": "Logo of {{name}}",
    "logoDragOrClick": "Drag a logo here or click",
    "logoFormatError": "Only PNG, JPG or WebP allowed",
    "logoSizeError": "File too large (max. 5 MB)",
    "logoUploadFailed": "Logo upload failed",
    "logoUploaded": "Logo uploaded",
    "logoUploading": "Uploading...",
    "logoUrlPlaceholder": "Or enter a URL directly: https://...",
    "mergeFailed": "Merge failed",
    "mergeLinkMissing": "Link to this organisation not found",
    "mergeSuccess": "Organisations merged successfully",
    "name": "Name",
    "noContactsForOrg": "No contacts assigned",
    "noFilterResults": "No contacts found",
    "noOrganizations": "No organizations found",
    "noOwner": "-- No one assigned --",
    "noUidDescription": "This organisation has no UID. You can link it to a Zefix entry.",
    "notesAutoSaveHint": "Changes are saved automatically.",
    "notesPlaceholder": "Notes on the organisation...",
    "openZefix": "Open in Zefix",
    "owner": "Responsible",
    "ownerRole": "Responsible",
    "phone": "Phone",
    "phoneAdded": "Phone number added",
    "phoneDeleted": "Phone number deleted",
    "phoneNumbers": "Phone numbers",
    "phoneUpdated": "Phone number updated",
    "pin": "Pin contact",
    "pinToggled": "Pin status changed",
    "pinned": "Pinned",
    "possibleDuplicate": "Possible duplicate",
    "possibleMatches": "Possible matches:",
    "primaryAddress": "Main address",
    "primaryColor": "Primary color",
    "primaryContact": "Primary contact",
    "primaryEmail": "Main email address",
    "primaryPhone": "Main number",
    "profile": "Profile",
    "removeBlockersHint": "Please remove or reassign the dependencies listed above before deleting this organization.",
    "removeInfoOwner": "Remove info owner",
    "removeInvestorGroup": "Remove investor group",
    "removePrimaryContact": "Remove primary contact",
    "researchCancelled": "Research cancelled",
    "researchDiscarded": "Research results discarded",
    "resultsLabel": "Organisations",
    "revenue": "Revenue",
    "sameUid": "same UID",
    "searchNameOrUid": "Search name or UID...",
    "searchPlaceholder": "Search by name, UID or city...",
    "selectMergeTarget": "Select an organisation to merge",
    "setPrimaryContact": "Set as primary contact",
    "showContacts": "Show Contacts",
    "signatureAuth": "Signing authority",
    "similarName": "similar name",
    "sourceManual": "Manual",
    "street": "Street",
    "subtitle": "All registered companies from the commercial register",
    "syncAdded": "{{count}} added",
    "syncDeactivated": "{{count}} deactivated",
    "syncNoPersons": "No authorized signatories found in the commercial register",
    "syncNotFound": "Company not found in commercial register — UID does not exist in Zefix",
    "syncReactivated": "{{count}} reactivated",
    "syncSkippedPinned": "{{count}} pinned (skipped)",
    "syncSuccess": "Contacts updated from Zefix",
    "syncUnchanged": "{{count}} unchanged",
    "syncUpdated": "{{count}} updated",
    "syncingContacts": "Loading contacts from Zefix...",
    "tabAddressContact": "Address & contact",
    "tabCommercialRegister": "Commercial register",
    "tabMasterData": "Master data",
    "tabNotes": "Notes",
    "tabResearch": "Research",
    "tabResponsibility": "Responsibility",
    "tabSignature": "Signature",
    "title": "Organizations",
    "type": "Type",
    "typeNameOrUid": "Type a name or a UID...",
    "types": {
      "broker": "Broker",
      "buyer": "Buyer",
      "other": "Other",
      "partner": "Partner",
      "seller": "Seller"
    },
    "uid": "UID",
    "unpin": "Unpin",
    "updateSuccess": "Organization updated successfully",
    "viaZefixCreate": "Create via Zefix",
    "website": "Website",
    "zefixAssign": "Assign Zefix",
    "zefixAssigned": "Zefix assigned",
    "zefixAssignFailed": "Zefix link failed",
    "zefixAutoMerged": "{{count}} contacts updated automatically (function/signature)",
    "zefixContactCreated": "{{name}} created",
    "zefixContactMerged": "{{name}} merged",
    "zefixCreated": "Organization created via Zefix",
    "zefixRefresh": "Refresh from Zefix",
    "zefixReviewDescription": "The following contacts from the commercial register could not be matched unambiguously. Please check the assignment manually.",
    "zefixReviewTitle": "Review Zefix contacts",
    "zefixSearchPlaceholder": "Search company in the commercial register...",
    "zefixSync": "Update from Zefix",
    "zefixSyncFailed": "Zefix sync failed",
    "zefixSynced": "Zefix data updated",
    "zipCode": "Zip Code",
    "capital": "Capital",
    "quickProfile": "Short profile",
    "industry": "Industry",
    "employees": "Employees",
    "parentCompany": "Parent company",
    "revenueEstimate": "Revenue",
    "keyPersons": "Key persons",
    "contactImportFailed": "Import failed",
    "contactAcknowledged": "Contact confirmed",
    "acknowledgeFailed": "Confirmation failed",
    "extractedContacts": "Contacts found",
    "alreadyExists": "Already exists",
    "acknowledge": "Confirm",
    "imported": "Imported",
    "importContact": "Import",
    "researchComplete": "Research completed",
    "researchFailed": "Research failed",
    "researchStarting": "Starting research...",
    "discardFailed": "Discarding failed",
    "purpose": "Purpose",
    "research": "AI research",
    "discard": "Discard",
    "researching": "Researching...",
    "updateResearch": "Update",
    "startResearch": "Start research",
    "discardConfirmTitle": "Discard research results?",
    "discardConfirmText": "All stored research data (profile, key persons, industry, etc.) will be permanently deleted.",
    "confirmDiscard": "Yes, discard",
    "researchBackground": "Runs in the background — you can leave the page.",
    "noResearch": "No research available yet",
    "editSection": "Edit {{section}}",
    "editMore": "Edit further details",
    "addressLabel": "Label",
    "phoneLabel": "Label",
    "emailLabel": "Label",
    "removeAddress": "Remove address",
    "removePhone": "Remove phone number",
    "removeEmail": "Remove email address",
    "contactData": {
      "title": "Organisation contact details",
      "webLinks": "Web",
      "badgePrimary": "Main",
      "badgeCentral": "Switchboard",
      "badgeRank": "Rank {{rank}}",
      "genericHint": "Generic addresses (investments@, info@) belong to the organisation, personal addresses to the respective contact.",
      "updated": "Contact details updated"
    },
    "contactImported": "Contact imported: {{name}}",
    "dedupInfo": "{{count}} of the persons found are already recorded as contacts of this organisation.",
    "revenuePlaceholder": "CHF 1-5 million",
    "keyFigures": {
      "title": "Key figures",
      "empty": "—",
      "add": "Add",
      "rows": {
        "capital": "Capital",
        "founded": "Founded",
        "employees": "Employees",
        "revenue": "Revenue",
        "dealSize": "Deal size",
        "relevance": "Relevance score"
      },
      "relevanceValue": "{{score}} out of 100",
      "dealSizeFrom": "from {{min}}",
      "dealSizeUpTo": "up to {{max}}",
      "sources": {
        "zefix": {
          "badge": "Z",
          "label": "Source: commercial register (Zefix)"
        },
        "research": {
          "badge": "AI",
          "label": "Source: AI research"
        },
        "searchProfile": {
          "badge": "SP",
          "label": "Source: search profile"
        }
      },
      "pendingHint": "AUM, portfolio and transactions follow with Investor Research."
    },
    "searchProfile": {
      "title": "Search profile",
      "empty": "—",
      "add": "Add",
      "today": "today",
      "hardMin": "below minimum excluded",
      "dealSizeRange": "{{min}} – {{max}} CHF million",
      "dealSizeFrom": "from {{min}} CHF million",
      "dealSizeUpTo": "up to {{max}} CHF million",
      "yieldGross": "gross from {{value}}%",
      "columns": {
        "criterion": "Criterion",
        "sought": "Sought",
        "excluded": "Excluded",
        "source": "Source",
        "action": "Action"
      },
      "rows": {
        "usage": "Use",
        "region": "Region / cantons",
        "dealSize": "Deal size",
        "yield": "Yield",
        "investmentForm": "Investment form",
        "conditionYear": "Condition / year built",
        "ownershipForm": "Ownership form",
        "minSize": "Minimum size",
        "noGos": "No-gos"
      },
      "sources": {
        "pitchdeck": {
          "badge": "PD",
          "label": "Source: pitch deck import"
        },
        "ai": {
          "badge": "AI",
          "label": "Source: AI research"
        },
        "manual": {
          "badge": "✎",
          "label": "Source: entered manually"
        },
        "archive": {
          "badge": "Archive",
          "label": "Source: legacy data import"
        },
        "contract": {
          "badge": "SM",
          "label": "Source: search mandate"
        },
        "portal": {
          "badge": "Portal",
          "label": "Source: entered in the buyer portal"
        },
        "company_copy": {
          "badge": "Company",
          "label": "Source: copy of the company profile"
        }
      }
    },
    "registerChecks": {
      "title": "Registers & checks",
      "empty": "—",
      "asOf": "As of {{date}}",
      "checkedAt": "checked {{date}}",
      "checks": {
        "zefix": "Commercial register",
        "seco": "SECO sanctions list",
        "finma": "FINMA",
        "oak_bv": "OAK BV",
        "six": "SIX Swiss Exchange",
        "sro": "SRO (AMLA)",
        "ubo": "Beneficial owners",
        "kyc": "Identification (AMLA)",
        "memberships": "Associations / memberships"
      },
      "status": {
        "ok": "Checked and confirmed",
        "unknown": "Not listed / unknown",
        "warn": "Open or older than 180 days",
        "alert": "Match that requires action"
      },
      "actions": {
        "zefix_sync": "Update from Zefix",
        "zefix_search": "Link to Zefix"
      }
    },
    "researchPortrait": {
      "portfolioTitle": "Portfolio",
      "transactionsTitle": "Transactions",
      "portfolioObjects_one": "{{count}} property",
      "portfolioObjects_other": "{{count}} properties",
      "portfolioFocus": "Focus",
      "amountMillions": "CHF {{value}}m",
      "amountBillions": "CHF {{value}}bn",
      "source": "Source",
      "empty": "No usable details"
    },
    "researchApply": {
      "openCta": "Review & apply research ({{count}})",
      "title": "Apply research result",
      "fieldsTitle": "Fields",
      "personsTitle": "People",
      "colMark": "Marked",
      "colField": "Field",
      "colCurrent": "Current",
      "colProposal": "Proposal",
      "colConfidence": "Confidence",
      "colAction": "Action",
      "markRow": "Mark {{field}}",
      "actionFor": "Action for {{field}}",
      "actions": {
        "keep": "keep",
        "accept": "apply",
        "both": "both"
      },
      "personActions": {
        "link": "link",
        "create": "create new",
        "link_auditor": "link as auditor",
        "discard": "discard"
      },
      "personMatch": "Match: {{name}}",
      "empty": "—",
      "lowConfidence": "Uncertain value — please check before applying",
      "applyAll": "Apply all",
      "applyMarked": "Marked only",
      "applied": "Applied {{fields}} fields and {{persons}} people",
      "failed": "Could not apply the research result",
      "nothingMarked": "No row marked",
      "noProposals": "No open proposals",
      "pendingTitle": "{{count}} research proposals pending",
      "pendingHint": "Decide in the «Apply research result» dialog — the button is at the top of this page.",
      "personsHint": "Link, create or discard people in the «Apply research result» dialog at the top of this page.",
      "nothingToApply": "Every row is set to «keep» — nothing to apply."
    },
    "sourceBadge": {
      "ai": {
        "badge": "AI",
        "label": "Source: AI research"
      },
      "zefix": {
        "badge": "Z",
        "label": "Source: commercial register (Zefix)"
      },
      "manual": {
        "badge": "✎",
        "label": "Source: entered manually"
      },
      "public_data": {
        "badge": "PD",
        "label": "Source: public data"
      },
      "import": {
        "badge": "IMP",
        "label": "Source: data import"
      },
      "research": {
        "badge": "AI",
        "label": "Source: AI research"
      },
      "amtsblatt": {
        "badge": "SOGC",
        "label": "Source: official gazette (SOGC)"
      },
      "dateLabel": "As of {{date}}"
    },
    "hero": {
      "aiBadge": "AI",
      "aiSourceHint": "Taken from the AI research",
      "applyResearch": "Review & apply research",
      "applyResearchCount": "Review & apply research ({{count}})",
      "cantons": "Cantons",
      "dataQuality": "Data quality {{value}}",
      "dataQualityComplete": "Data complete",
      "dataQualityHint": "Jump to the open items",
      "dataQualityOpen": "Data: {{open}} open",
      "dealFrom": "Deal from CHF {{min}}m",
      "dealRange": "Deal CHF {{min}}–{{max}}m",
      "dealTo": "Deal up to CHF {{max}}m",
      "holdings": "Portfolio: {{objects}} · CHF {{value}}",
      "holdingsObjects": "Portfolio: {{objects}}",
      "holdingsHint": "Go to the properties tab",
      "more": "+{{n}}",
      "owner": "Owner: {{name}}",
      "ownerMissing": "Owner: —",
      "relevance": "Relevance {{score}}",
      "relevanceMissing": "Relevance — not profiled",
      "usages": "Usages"
    },
    "holdings": {
      "title": "Own portfolio",
      "objects": "{{count}} properties",
      "objectsOne": "1 property",
      "objectFallback": "Property #{{id}}",
      "value": "CHF {{value}}",
      "valueMillions": "{{value}}m",
      "valueBillions": "{{value}}bn",
      "asOf": "As of {{date}}",
      "groupBy": "View",
      "byFund": "By vehicle/cluster",
      "byUsage": "Use",
      "byCanton": "Canton",
      "unassignedFund": "Without vehicle",
      "fundFilter": "Only vehicle “{{name}}”",
      "fundFilterClear": "Clear filter",
      "focusReason": "Candidates: {{reason}} ({{count}})",
      "focusReasonAny": "Candidates ({{count}})",
      "focusUsage": "Use: {{usage}} ({{count}})",
      "focusCanton": "Canton: {{canton}} ({{count}})",
      "focusClear": "Clear filter",
      "candidate": "Trading candidate",
      "area": "{{value}} m²",
      "units": "{{count}} units",
      "unitsOne": "1 unit",
      "since": "since {{year}}",
      "transactions": "Transactions",
      "columnDate": "Date",
      "columnObject": "Property",
      "columnPrice": "Price",
      "columns": {
        "object": "Property",
        "place": "Location/address",
        "usage": "Use",
        "size": "Units/area",
        "value": "Value",
        "acquired": "Acquired",
        "fund": "Vehicle",
        "flag": "Candidate",
        "source": "Source",
        "select": "Selection"
      },
      "source": "Source",
      "sourceRef": "Source: {{ref}}",
      "empty": "No portfolio known",
      "fundKpis": {
        "value": "Market value",
        "objects": "Properties",
        "objectsSource": "{{count}} per source",
        "objectsRecorded": "{{count}} recorded",
        "vacancy": "Vacancy",
        "yield": "Yield",
        "status": "Current status",
        "asOf": "As of",
        "empty": "{{name}} · no properties recorded"
      },
      "transactionKinds": {
        "buy": "Purchase",
        "sell": "Sale",
        "stake": "Stake"
      },
      "edit": {
        "start": "Edit own portfolio",
        "saved": "Own portfolio updated",
        "addFund": "Vehicle",
        "addCluster": "Cluster",
        "addObject": "Add property",
        "fundName": "Vehicle name",
        "clusterName": "Cluster name",
        "clusterKind": "Grouping type",
        "clusterKinds": {
          "region": "Region",
          "usage": "Usage",
          "strategy": "Strategy",
          "size": "Size",
          "custom": "Custom"
        },
        "renameFund": "Rename vehicle",
        "renameCluster": "Rename cluster",
        "deleteFund": "Delete vehicle",
        "deleteCluster": "Delete cluster",
        "deleteFundTitle": "Delete vehicle?",
        "deleteClusterTitle": "Delete cluster?",
        "deleteGroupHint": "«{{name}}» will be deleted. The properties remain but lose their assignment.",
        "deleteObject": "Delete property",
        "deleteObjectTitle": "Delete property?",
        "deleteObjectHint": "«{{name}}» will be removed from the portfolio.",
        "editObject": "Edit property",
        "selectObject": "Select {{name}}",
        "selectedCount": "{{count}} selected",
        "clearSelection": "Clear selection",
        "moveTo": "Move to",
        "moveToFund": "Move to vehicle",
        "moveToCluster": "Move to cluster",
        "objectTitleNew": "Add property",
        "objectTitleEdit": "Edit property",
        "objectCreated": "Property added",
        "objectUpdated": "Property saved",
        "sourceManual": "Source: entered manually",
        "usage": "Usage",
        "usageDetail": "Usage, in detail",
        "usageOther": "Other usage",
        "usageNone": "Not specified",
        "area": "Area (m²)",
        "units": "Units",
        "buildYear": "Year built",
        "acquiredYear": "Year acquired",
        "value": "Value (CHF)",
        "fund": "Vehicle",
        "cluster": "Cluster",
        "noCluster": "No cluster",
        "notes": "Note",
        "cantonInvalid": "Canton as a 2-letter code, e.g. ZH",
        "yearInvalid": "Year with 4 digits, e.g. 1998",
        "numberInvalid": "Please enter a number"
      }
    },
    "portfolioReview": {
      "title": "Portfolio review",
      "headerCount": "{{candidates}} of {{objects}} properties",
      "reasonCount": "{{label}} {{count}}",
      "reasons": {
        "non_core": "Non-core",
        "small": "small-scale",
        "old": "old",
        "manual": "manual"
      },
      "reasonHints": {
        "non_core": "does not match the search profile (use or canton)",
        "small": "value below 10 % of the average object with the same use",
        "old": "built more than 25 years before the rest of the portfolio",
        "manual": "marked by hand"
      },
      "noProfileHint": "No search profile — only size/age assessed",
      "shareOfObjects": "{{label}}: {{count}} of {{objects}} properties",
      "openProperties": "View {{candidates}} candidates in the Properties tab",
      "empty": "No candidates found",
      "pdf": "PDF",
      "pdfAria": "Download portfolio clean-up as PDF",
      "pdfFailed": "PDF could not be loaded",
      "flagSet": "Mark as trading candidate",
      "flagRemove": "Remove mark",
      "flagSaved": "Mark saved",
      "noteTitle": "Mark as trading candidate",
      "noteHint": "\u00ab{{name}}\u00bb will be marked as a trading candidate.",
      "noteLabel": "Note (optional)",
      "notePlaceholder": "Why can this property be sold?",
      "taskCreated": "Task created",
      "taskCreatedFor": "Task created for {{name}}"
    },
    "fundMonitor": {
      "title": "Investment vehicles",
      "kpiAum": "Total AUM",
      "kpiProperties": "Properties",
      "kpiLtv": "Avg. LTV / limit",
      "kpiVacancy": "Avg. vacancy",
      "kpiSell": "Sell signals",
      "kpiBuy": "Buy signals",
      "colAum": "Assets",
      "colProperties": "Objects",
      "colLtv": "LTV / limit",
      "colVacancy": "Vacancy",
      "colTerm": "Term",
      "expand": "Expand “{{name}}”",
      "collapse": "Collapse “{{name}}”",
      "sellSignal": "Sell signal",
      "buySignal": "Buy signal",
      "moreSignals": "+{{count}} more",
      "structureOpenEnd": "open-ended",
      "structureClosedEnd": "closed-ended",
      "termEnd": "until {{date}}",
      "inception": "since {{year}}",
      "subscription": "Subscription",
      "subscriptionOpen": "open",
      "subscriptionClosed": "closed",
      "redemption": "Redemption",
      "redemptionAnnounced": "announced {{value}}",
      "capitalIncrease": "Capital increase",
      "performance": "Total return",
      "perfYtd": "Year to date",
      "perf1y": "1 yr",
      "perf3y": "3 yr",
      "perf5y": "5 yr",
      "valuation": "Valuation",
      "nav": "Net asset value",
      "gav": "Gross asset value",
      "propertyValue": "Property value",
      "agio": "Premium",
      "fiscalYearEnd": "Fiscal year",
      "source": "Source",
      "sourceLink": "Report",
      "openObjects": "Properties",
      "openObjectsAria": "Properties of “{{name}}” in the properties tab",
      "noObjectList": "No property list – source: report"
    },
    "qualification": {
      "action": "Qualify",
      "blockedHint": "Industry and contact person are required",
      "chipHint": "Imported from the address funnel — not qualified yet",
      "contactExisting": "Select an existing person",
      "contactNew": "Add a new person",
      "dialogTitle": "Qualify organisation",
      "failed": "Qualification failed",
      "filterAll": "Qualification: all",
      "filterLabel": "Qualification",
      "finish": "Finish",
      "industryHint": "At least one industry is required.",
      "nameMismatch": "The commercial register name is «{{register}}», the record says «{{stored}}». Please sync first.",
      "noUid": "Assign a UID first",
      "noUidHint": "Without a UID the commercial register cannot be matched. Link the organisation to a Zefix entry.",
      "position": "Job title",
      "qualified": "Qualified",
      "stepContact": "Add contact person",
      "stepIndustry": "Choose industry",
      "stepRegister": "Confirm commercial register",
      "success": "Organisation qualified",
      "unqualified": "Unqualified"
    },
    "glossary": {
      "objects": {
        "title": "Properties",
        "what": "Recorded properties of this company (own portfolio), across all vehicles.",
        "how": "Count of the objects in the Properties tab."
      },
      "units": {
        "title": "Units",
        "what": "Apartments and commercial units of all recorded properties.",
        "how": "Sum of units; “—” if none recorded."
      },
      "value": {
        "title": "Value",
        "what": "Sum of the market values of the recorded properties — not the assets under management (AUM).",
        "how": "Adds up the estimated value per property."
      },
      "candidates": {
        "title": "Candidates",
        "what": "Properties that could be up for sale in a portfolio clean-up.",
        "how": "Non-core, small and old are computed; ⚑ manual is stored."
      },
      "funds": {
        "title": "Vehicles",
        "what": "Funds, investment groups and investment foundations of this company.",
        "how": "All recorded vehicles, even without assigned properties."
      },
      "non_core": {
        "title": "Non-core",
        "what": "Does not fit the company's strategy.",
        "how": "Use or canton not in the search profile, or property in the “Non-core” cluster. Without a search profile this reason is skipped."
      },
      "small": {
        "title": "small",
        "what": "Too small for the portfolio.",
        "how": "Value below 10 % of the average property of the same use."
      },
      "old": {
        "title": "old",
        "what": "Much older than the rest of the portfolio.",
        "how": "Year built more than 25 years older than the portfolio, no renovation in the notes."
      },
      "manual": {
        "title": "manual",
        "what": "Marked as candidate by hand (⚑).",
        "how": "Flag in the Properties tab, with a note."
      },
      "sourceReport": "Report/portrait",
      "aum_chf": {
        "title": "AUM",
        "what": "Assets under management of the vehicle.",
        "how": "As per source: properties, cash and other assets."
      },
      "properties_count": {
        "title": "Properties",
        "what": "Properties of this vehicle, as per source.",
        "how": "Figure from the report or portrait; if missing, the row counts the properties recorded with us."
      },
      "ltv_pct": {
        "title": "LTV",
        "what": "Share of mortgages in the property value. High = little room for acquisitions.",
        "how": "Loan-to-value = mortgages ÷ market value of the properties, as per source."
      },
      "ltv_limit_pct": {
        "title": "Limit",
        "what": "Upper limit of borrowing for this vehicle.",
        "how": "As per regulations or prospectus. The closer the LTV, the fewer acquisitions possible."
      },
      "vacancy_pct": {
        "title": "Vacancy",
        "what": "Rental loss in percent. Low = healthy portfolio.",
        "how": "As per source (source's definition: income or area)."
      },
      "agio_pct": {
        "title": "Premium / Discount",
        "what": "Market price compared with net asset value (NAV), only for traded vehicles.",
        "how": "Discount (negative) = price below NAV → capital increase unattractive → buys little, rather sells."
      },
      "nav": {
        "title": "NAV",
        "what": "Assets of the vehicle after deducting debt.",
        "how": "Net asset value as per report."
      },
      "gav": {
        "title": "GAV",
        "what": "Assets of the vehicle before deducting debt.",
        "how": "Gross asset value as per report."
      },
      "signals_sell": {
        "title": "Sell signal",
        "what": "Statement in the source pointing to sales.",
        "how": "Quoted from the report or press release."
      },
      "signals_buy": {
        "title": "Buy signal",
        "what": "Statement in the source pointing to acquisitions.",
        "how": "E.g. subscription open, capital increase planned."
      },
      "subscription": {
        "title": "Subscription",
        "what": "Whether new units can be subscribed.",
        "how": "open = money flows in, acquisitions likely; closed = no new capital."
      },
      "redemption": {
        "title": "Redemption",
        "what": "Notice period for investors to return units.",
        "how": "Announced redemptions in CHF = money leaving → selling pressure."
      },
      "structure": {
        "title": "Term",
        "what": "Whether the vehicle is time-limited.",
        "how": "open-end = unlimited; closed = term until date, then the portfolio is sold."
      },
      "capital_increase": {
        "title": "Capital increase",
        "what": "Whether the vehicle raises new capital.",
        "how": "Last and planned increase as per source; planned = acquisitions likely."
      },
      "sourceLine": "Source: {{source}} · as of {{date}}"
    },
    "holdingsCard": {
      "title": "Properties · Own portfolio",
      "kpiObjects": "Objects",
      "kpiUnits": "Units",
      "kpiUnitsKnown": "{{known}} of {{total}} with data",
      "kpiValue": "Value",
      "kpiCandidates": "Candidates",
      "kpiFunds": "Vehicles",
      "byUsage": "By use",
      "byReason": "Portfolio review",
      "byCanton": "By canton",
      "segment": "{{usage}}: {{count}} objects",
      "noCandidates": "Portfolio review: 0 candidates — every object matches the search profile",
      "noValue": "No data",
      "openProperties": "Properties tab",
      "barLink": "{{label}}: show {{count}} properties in the Properties tab"
    },
    "uidSource": {
      "zefix": "UID: commercial register",
      "uid_register": "UID: UID register",
      "manual": "UID: manual",
      "fetchedAt": "{{label}} — retrieved on {{date}}"
    }
  },
  "pagination": {
    "next": "Next",
    "page": "Page {{current}} of {{total}}",
    "previous": "Previous",
    "rowsPerPage": "Rows per page",
    "showing": "Showing {{from}}-{{to}} of {{total}}"
  },
  "preferences": {
    "notifications": {
      "categories": {
        "contract_updates": "Contract Updates",
        "favorites_updates": "Favorites Updates",
        "new_matches": "New Matches",
        "offer_updates": "Offer Updates",
        "platform_news": "Platform News"
      },
      "descriptions": {
        "contract_updates": "Status changes on your contracts, e.g. signature or expiry.",
        "favorites_updates": "Changes on properties you saved as favorites.",
        "new_matches": "New properties matching your search profile.",
        "offer_updates": "Important updates on your offers.",
        "platform_news": "News and new features on Immotron."
      },
      "devices": {
        "empty": "No device is registered for push notifications yet. Register this device to receive push messages.",
        "namePlaceholder": "Device name (e.g. iPhone Personal)",
        "permissionBlocked": "You have blocked push notifications for this site. Please enable them in your browser settings.",
        "permissionDenied": "Permission denied. Enable notifications in your browser settings.",
        "registerAnother": "Register another device",
        "registerError": "Could not register device",
        "registerSuccess": "Device registered",
        "registerThis": "Register this device",
        "registeredOn": "Registered on {{date}}",
        "removeAria": "Remove device",
        "removeError": "Could not remove device",
        "removeSuccess": "Device removed",
        "renameAria": "Rename device",
        "renameError": "Could not save name",
        "renameSuccess": "Name updated",
        "serverNotConfigured": "Push notifications are not configured on the server yet. Your preferences are saved and messages will be delivered as soon as push is available.",
        "subtitle": "Manage the devices you want to receive push notifications on.",
        "testButton": "Send test push",
        "testError": "Could not send test",
        "testNone": "No devices reachable",
        "testSending": "Sending …",
        "testSent": "Test push sent to {{count}} device(s)",
        "title": "Devices for push notifications",
        "unnamedDevice": "Unnamed device",
        "unregisterError": "Could not unregister device",
        "unregisterSuccess": "This device has been unregistered",
        "unregisterThis": "Unregister this device",
        "unsupported": "This browser does not support push notifications."
      },
      "emailColumn": "Email",
      "loadFailed": "Failed to load notification settings",
      "locked": "Cannot be disabled",
      "pushColumn": "Push",
      "pushRequiresDevice": "Please register a device first to enable push notifications.",
      "saveFailed": "Failed to save setting",
      "subtitle": "Choose how you want to be notified for each event.",
      "title": "Notifications"
    },
    "privacy": {
      "activityTracking": {
        "description": "Allow us to analyse your use of the platform anonymously to improve usability.",
        "title": "Activity tracking"
      },
      "anonymizeActivity": "Anonymize Activity",
      "anonymizeDescription": "Your activities will be shown anonymously to other users",
      "anonymous": "Anonymous",
      "anonymousDescription": "Your profile is not visible to other users",
      "dataManagement": "Data management",
      "deleteAccount": {
        "button": "Delete account",
        "description": "Your account and all associated data will be permanently deleted.",
        "title": "Delete account"
      },
      "exportData": {
        "button": "Export",
        "description": "Download a copy of your personal data.",
        "error": "Data export failed",
        "success": "Data export downloaded successfully",
        "title": "Export data"
      },
      "legal": "Legal information",
      "loadFailed": "Failed to load privacy settings",
      "marketingEmails": {
        "description": "Occasionally receive news, tips and offers by email.",
        "title": "Marketing emails"
      },
      "privacyPolicyLink": "Privacy policy",
      "profileVisibility": "Profile Visibility",
      "profileVisible": {
        "description": "Your profile is visible to other users of the platform.",
        "title": "Profile visible"
      },
      "public": "Public",
      "publicDescription": "Your profile is visible to other users",
      "saveFailed": "Failed to save setting",
      "settings": "Privacy settings",
      "termsLink": "Terms of use",
      "title": "Privacy"
    }
  },
  "profile": {
    "active": "Aktiv",
    "admin": {
      "backToUsers": "Zurück zur Benutzerliste",
      "impersonate": "Als Benutzer einloggen",
      "impersonateDescription": "Öffnet eine Session als dieser Benutzer",
      "loginAs": "Einloggen",
      "resetEmailSent": "Reset-E-Mail gesendet",
      "resetLinkCopied": "Reset-Link in Zwischenablage kopiert",
      "resetPassword": "Passwort zurücksetzen",
      "sendResetLink": "Reset-Link senden"
    },
    "companyAssignments": "Firmenzugehörigkeiten",
    "directPhone": "Direktnummer",
    "functionPlaceholder": "z.B. Geschäftsführer, Sales Manager",
    "functionTitle": "Funktion",
    "languageAuto": "Automatisch (Systemsprache)",
    "preferredLanguage": "Hauptsprache",
    "role": "Role",
    "sections": {
      "compliance": "Compliance",
      "emailAccounts": "E-Mail-Konten",
      "passkeys": "Passkeys",
      "password": "Password",
      "profile": "Profile",
      "security": "Security"
    },
    "subtitle": "Manage personal settings and security",
    "title": "My Profile"
  },
  "properties": {
    "activate": "Activate",
    "activated": "Property has been activated.",
    "activeHighlights": "Aktive Highlights",
    "addProperty": "Add Property",
    "addRow": "Add row",
    "address": "Address",
    "agentAnalysis": {
      "alreadyRunning": "An analysis is already running for this property.",
      "openPoints": "Open points",
      "report": "Open report",
      "start": "Start full analysis",
      "started": "Analysis requested — the property agent is working.",
      "status": {
        "completed": "Completed",
        "failed": "Aborted",
        "pending": "Waiting for the agent",
        "processing": "In progress"
      },
      "title": "Property analysis"
    },
    "aiBanner": {
      "confidence": "Confidence",
      "hideHints": "Hide hints",
      "hintsCount": "{{count}} hints",
      "showHints": "Show hints",
      "title": "AI Extraction"
    },
    "aiConfidence": "AI data quality",
    "approve": "Approve",
    "approved": "Property has been approved.",
    "area": "Area",
    "availableData": "Verfügbare Daten",
    "backToList": "Back to overview",
    "bulk": {
      "affectedCount": "{{count}} properties affected",
      "confirmDelete": "Delete properties?",
      "confirmStatus": "Change status?",
      "error": "Bulk operation failed",
      "newStatus": "New status",
      "success": "Bulk operation successful."
    },
    "city": "City",
    "compactMode": "Compact",
    "condition": {
      "EXCELLENT": "Excellent",
      "FAIR": "Fair",
      "GOOD": "Good",
      "GUTTED": "Gutted",
      "NEW": "New build",
      "RENOVATION_NEEDED": "Renovation needed"
    },
    "conditions": {
      "EXCELLENT": "Excellent",
      "FAIR": "Fair",
      "GOOD": "Good",
      "GUTTED": "Gutted",
      "NEW": "New Build",
      "RENOVATION_NEEDED": "Renovation needed"
    },
    "confirmDelete": "Are you sure you want to delete this property? This action cannot be undone.",
    "country": "Country",
    "createSuccess": "Property created successfully",
    "deleteFinal": "Delete permanently",
    "deleteProperty": "Delete Property",
    "deleteSuccess": "Property deleted successfully",
    "description": "Description",
    "detail": {
      "activate": "Activate",
      "archive": "Archive",
      "changeStatus": "Change Status",
      "gallery": "Image Gallery",
      "investorAccess": "Investor Access",
      "keyFacts": "Key Facts",
      "noAccess": "No investors with access yet"
    },
    "diff": {
      "city": "Ort",
      "condition": "Zustand",
      "constructionYear": "Baujahr",
      "empty": "(leer)",
      "grossYield": "Bruttorendite",
      "heating": "Heizung",
      "lotSize": "Grundstücksflaeche",
      "marketValue": "Marktwert",
      "price": "Preis",
      "propertyType": "Immobilientyp",
      "rentalIncome": "Mieteinnahmen",
      "residentialUnits": "Wohneinheiten",
      "status": "Status",
      "street": "Strasse",
      "usableArea": "Nutzfläche",
      "zipCode": "PLZ"
    },
    "documents": "Documents",
    "draft": {
      "discard": "Discard",
      "found": "An unsaved draft was found",
      "restore": "Restore",
      "restored": "Draft restored"
    },
    "duplicate": "Duplicate",
    "duplicateSuccess": "Property prepared as copy",
    "editProperty": "Edit Property",
    "errors": {
      "deleteFailed": "Failed to delete property",
      "imageDeleteFailed": "Failed to delete image",
      "imageRotateFailed": "Failed to rotate image",
      "imageTooLarge": "Image \"{{name}}\" is too large (max 10 MB)",
      "imageUnsupportedType": "Image format of \"{{name}}\" not supported",
      "imageUploadFailed": "Failed to upload image",
      "loadFailed": "Failed to load properties",
      "saveFailed": "Failed to save property",
      "submitFailed": "Fehler beim Einreichen",
      "unrealisticYield": "Unrealistischer Wert — bitte Eingabedaten prüfen",
      "updateFailed": "Update failed."
    },
    "externalLinks": "Externe Links",
    "favorites": {
      "empty": "No favorites yet",
      "impersonate": "Log in as investor",
      "loginAs": "Log in",
      "showDetails": "Show details",
      "title": "Investor Favorites"
    },
    "fields": {
      "canton": "Canton",
      "createdBy": "Created by",
      "favorites": "Favorites",
      "location": "Location",
      "name": "Name",
      "price": "Min. Price",
      "status": "Status",
      "type": "Type"
    },
    "filters": {
      "clearAll": "Clear all filters",
      "max": "Max",
      "min": "Min",
      "priceRange": "Price range (CHF)",
      "results": "results",
      "sortBy": "Sort by",
      "sortNewest": "Newest first",
      "sortOldest": "Oldest first",
      "sortPriceAsc": "Price ascending",
      "sortPriceDesc": "Price descending",
      "title": "Filters"
    },
    "floor": "Floor",
    "form": {
      "addressPlaceholder": "Enter address (e.g. Bahnhofstrasse 1, Zurich)",
      "annualRentalIncome": "Annual Rental Income (CHF)",
      "anzahl_etagen": "Etagen",
      "assignedTo": "Assigned to",
      "bruttorendite_pct": "Bruttorendite",
      "buildingCount": "Number of Buildings",
      "cadastralNumber": "Cadastral No.",
      "cadastreNumber": "Cadastre no.",
      "cadastre_number": "Kataster-Nr.",
      "calcAutoHint": "Calculated automatically",
      "canton": "Canton",
      "city": "City",
      "commercialArea": "Commercial area",
      "commercialAreaSqm": "Commercial Area (m²)",
      "commercialUnits": "Commercial Units",
      "commercial_area_sqm": "Commercial area",
      "commissionRate": "Fee (%)",
      "condition": "Condition",
      "conditionField": "Condition",
      "constructionYear": "Year of Construction",
      "country": "Country",
      "description": "Description",
      "desiredPrice": "Desired Price (CHF)",
      "desiredPricePlaceholder": "e.g. 1800000",
      "desiredTimeline": "Desired Timeline",
      "desiredTimelinePlaceholder": "e.g. Sale by Q3 2026",
      "detailedDescription": "Description",
      "dragToReorder": "Drag to reorder",
      "egridNumber": "E-GRID No.",
      "energieklasse": "Energy class",
      "energyClassEnvelope": "Energy class (envelope)",
      "energyClassTotal": "Energy class (overall)",
      "equityYield": "Return on equity",
      "floorAreaRatio": "Floor Area Ratio",
      "floorCount": "Number of floors",
      "garageParking": "Garage spaces",
      "garageParkingCount": "Garage Parking Spaces",
      "grossYield": "Gross Yield",
      "groundLeaseExpiration": "Ground lease expiration",
      "hasBuildingPermit": "Building Permit Available",
      "hasBuildingRight": "Building Right",
      "hasGroundLease": "Ground lease",
      "hasLift": "Lift vorhanden",
      "has_building_permit": "Baubewilligung",
      "has_ground_lease": "Baurecht",
      "has_lift": "Lift",
      "heatingSystem": "Heating System",
      "heating_system": "Heizung",
      "highlightOrder": "Order",
      "highlights": "Investment Highlights",
      "houseNumber": "House Number",
      "imageDragDrop": "Drag images here or click to upload",
      "imageHint": "JPG, PNG, WEBP. Max 10 MB.",
      "imageUploading": "Uploading image...",
      "investmentHighlights": "Investment highlights",
      "isPrivateListing": "Private Listing",
      "isPrivateListingHint": "Only visible to selected investors",
      "latitude": "Latitude",
      "leerstand_pct": "Vacancy",
      "listingExpirationDate": "Expiration date",
      "longitude": "Longitude",
      "lotSizeSqm": "Lot Size (m²)",
      "macroLocation": "Macro Location",
      "marketValueChf": "Market value (CHF)",
      "marketValueDate": "Market value date",
      "marketValueSource": "Market value source",
      "marketValueSourcePlaceholder": "IAZI, Wüest Partner",
      "marktwert_chf": "Market value",
      "max_building_height": "Max. building height",
      "microLocation": "Micro Location",
      "minimumPrice": "Minimum Price (CHF)",
      "multipleSelectionAllowed": "Multiple selection allowed",
      "name": "Name",
      "netYield": "Net Yield",
      "noImages": "No images uploaded yet",
      "orderLost": "Mandate lost",
      "outdoorParking": "Outdoor parking spaces",
      "outdoorParkingCount": "Outdoor Parking Spaces",
      "ownershipType": "Ownership Type",
      "ownership_type": "Eigentum",
      "parking": "Parking spaces",
      "postalCode": "Postal Code",
      "price": "Price",
      "pricePerSqm": "Price per m²",
      "price_per_sqm": "Preis/m²",
      "primaryImage": "Primary Image",
      "propertySubtype": "Subtype",
      "propertyType": "Property Type",
      "renovation": "Renovation",
      "renovationPlaceholder": "e.g. Last renovation 2018, roof 2020",
      "residentialArea": "Residential area",
      "residentialAreaSqm": "Residential Area (m²)",
      "residentialUnits": "Residential Units",
      "residential_area_sqm": "Residential area",
      "rotateImage": "Rotate 90°",
      "saleEndDate": "Sale End",
      "saleStartDate": "Sale Start",
      "salesUserId": "Sales contact",
      "salesUserIdPlaceholder": "Unassigned",
      "sellerNotes": "Seller notes",
      "sendExpirationReminder": "Send reminder before expiration",
      "setPrimary": "Set as Primary",
      "status": "Status",
      "street": "Street",
      "subheader": "Subheader",
      "teaserHighlights": "Teaser highlights",
      "teaserHighlightsHint": "Select the highlights shown on the investor teaser page. Set order with numbers.",
      "uploadImages": "Upload Images",
      "usableAreaSqm": "Usable Area (m²)",
      "utilization_factor": "Floor area ratio",
      "vacancyRate": "Vacancy (%)",
      "volume": "Volumen",
      "volumeM3": "Volume (m³)",
      "volume_m3": "Volumen",
      "vrTourUrl": "VR Tour URL",
      "yearBuilt": "Year Built"
    },
    "heating": {
      "DISTRICT": "District heating",
      "ELECTRIC": "Electric heating",
      "GAS": "Gas heating",
      "HEAT_PUMP": "Heat pump",
      "OIL": "Oil heating",
      "OTHER": "Other",
      "PELLETS": "Pellet heating",
      "SOLAR": "Solar heating"
    },
    "highlights": {
      "annual_income": "Annual rental income",
      "building_count": "Buildings",
      "building_permit": "Building Permit",
      "commercial_area": "Commercial area",
      "commercial_units": "Commercial units",
      "condition": "Condition",
      "construction_year": "Year built",
      "energieklasse": "Energy class",
      "etagen": "Floors",
      "gross_yield": "Gross Yield",
      "heating_system": "Heating",
      "location": "Location",
      "lot_size": "Lot Size",
      "marktwert": "Market value",
      "net_yield": "Net yield",
      "ownership": "Ownership Type",
      "parking": "Parking spaces",
      "price": "Asking Price",
      "property_type": "Property Type",
      "residential_area": "Residential area",
      "residential_units": "Residential units",
      "usable_area": "Usable Area",
      "vacancy": "Vacancy",
      "volume": "Volume"
    },
    "highlightsAddHint": "Highlights aus der Liste unten hinzufügen...",
    "images": "Images",
    "list": {
      "companyLabel": "Tenant",
      "empty": {
        "description": "Add your first property to get started.",
        "title": "No properties found"
      },
      "emptyFiltered": "No properties match the active filters: {{filters}}",
      "emptyFilteredTitle": "No matches",
      "resetFilters": "Reset filters",
      "switchCompany": "Switch tenant"
    },
    "listingPreview": "Teaser Preview",
    "listingPreviewBanner": "Preview — How investors see this teaser",
    "teaserViewToggle": {
      "ariaLabel": "Choose preview view",
      "web": "Web view",
      "newsletter": "E-mail newsletter",
      "delivery": "Delivery & tracking"
    },
    "teaserDelivery": {
      "title": "Delivery & tracking",
      "summary": {
        "sent": "Sent",
        "delivered": "Delivered",
        "opened": "Opened",
        "clicked": "Clicked"
      },
      "columns": {
        "recipient": "Recipient",
        "mail": "Mail",
        "sent": "Sent",
        "delivered": "Delivered",
        "opened": "Opened",
        "clicked": "Clicked"
      },
      "types": {
        "ACCESS_GRANTED": "Access e-mail",
        "BUYER_ONBOARDING_INVITE": "Invitation",
        "ONBOARDING_CORRECTION": "Correction invitation"
      },
      "bounced": "Undeliverable",
      "empty": "No e-mail has been sent for this offer yet.",
      "loadError": "Tracking data could not be loaded."
    },
    "sendAsCampaign": {
      "button": "Send as campaign",
      "gateLocked": "Available only after the quality gate",
      "title": "Send teaser as campaign",
      "intro": "The teaser becomes an e-mail campaign — with the same content an investor sees without an NDA. You can then review content and recipients, send a test, and dispatch it.",
      "gateChecking": "Checking NDA gate …",
      "gateOk": "NDA gate clear — {{count}} teaser image(s) released",
      "gateBlocked": "NDA gate blocks sending",
      "gateLoadFailed": "Teaser preview could not be loaded.",
      "locationConfirm": "Deliberately release location-critical images",
      "includeRecipients": "Add {{count}} recipient(s) from investor groups",
      "includeRecipientsHint": "Members of the investor groups assigned to this property.",
      "noRecipients": "No recipients from investor groups found — you can upload recipients via CSV in the next step.",
      "create": "Create campaign",
      "created": "Campaign created — please review the content and run a test send.",
      "createFailed": "Campaign could not be created.",
      "recipientsFailed": "Recipients could not be added — please add them in the campaign flow."
    },
    "loading": "Loading...",
    "map": {
      "noCoordinates": "{{count}} properties without coordinates (not visible on map)"
    },
    "media": {
      "showArchive": "Also show deleted images",
      "archiveTitle": "Archive ({{count}})",
      "archiveEmpty": "No deleted images.",
      "deletedOn": "Deleted on {{date}}",
      "restore": "Restore",
      "restored": "Image restored",
      "restoreError": "Restore failed",
      "teaserText": {
        "label": "Teaser short text",
        "placeholder": "e.g. Fully let property with stable income and development potential ...",
        "hint": "Visible before the NDA — no locations, no property number."
      }
    },
    "ownershipTypes": {
      "CORPORATE": "Corporate",
      "MULTIPLE": "Multiple Owners",
      "SINGLE": "Single Owner",
      "TRUST": "Trust"
    },
    "price": "Price",
    "propertyDetails": "Property Details",
    "quarantine": {
      "badge": "Location missing",
      "banner": {
        "action": "Please review and complete the address fields manually, then save.",
        "description": "The location could not be determined automatically. Address data (postal code, coordinates, EGRID/EGID) is missing.",
        "title": "AI extraction incomplete"
      }
    },
    "reject": "Reject",
    "rejectReason": "Reason for rejection",
    "rejected": "Property has been rejected.",
    "removeRow": "Zeile entfernen",
    "rentRoll": {
      "ancillaryCostsChf": "Service charges CHF",
      "areaSqm": "Area m²",
      "floor": "Floor",
      "netRentChf": "Net rent CHF",
      "nutzungsart": "Usage type",
      "nutzungsartUnset": "Not set",
      "nutzungsartOptions": {
        "wohnung": "Residential",
        "gewerbe": "Commercial",
        "parkplatz": "Parking",
        "werbeflaeche": "Advertising space",
        "antenne": "Antenna",
        "sonstige": "Other"
      },
      "rooms": "Rooms",
      "status": "Status"
    },
    "rentalYield": "Rental yield",
    "rooms": "Rooms",
    "saveSuccess": "Property saved successfully",
    "search": {
      "placeholder": "Search by name, city, address..."
    },
    "sections": {
      "address": "Address",
      "calculations": "Key Figures",
      "buildingRight": "Building Right",
      "classification": "Classification",
      "dealState": "Status & Deal State",
      "dossierDocuments": "Dossier Documents",
      "images": "Images",
      "land": "Land",
      "objectDetails": "Property Details",
      "ownershipAndCadastre": "Ownership & Cadastre",
      "pricingTerms": "Pricing & Terms",
      "salesTimeline": "Sales & Timeline",
      "sellerDesiredTerms": "Seller Preferences",
      "statusLegal": "Status & Legal",
      "teaserHighlights": "Teaser Highlights"
    },
    "states": {
      "CLOSED": "Closed",
      "CLOSING": "Closing",
      "DUE_DILIGENCE": "Due Diligence",
      "IDENTIFIED": "Identified",
      "NEGOTIATION": "Negotiation",
      "UNDER_CONTRACT": "Under Contract"
    },
    "status": "Status",
    "statusChanged": "Status has been changed.",
    "statusDescriptions": {
      "ACTIVE": "Active: The property is published and visible to investors. Offers can be submitted.",
      "ARCHIVED": "Archived: The property has been deactivated and is no longer visible to investors.",
      "DRAFT": "Draft: The property has been created but not yet published. It is only visible to internal staff and can still be edited.",
      "PENDING": "Pending: The property is awaiting approval through Quality Gate. All required fields and documents must be complete.",
      "SOLD": "Sold: The property has been successfully brokered. No further offers possible."
    },
    "statuses": {
      "ACTIVE": "Active",
      "ANALYSIS_DONE": "Analysis done — review",
      "ANALYSIS_REQUESTED": "Analysis running",
      "ARCHIVED": "Archived",
      "DRAFT": "Draft",
      "PENDING": "Pending",
      "SOLD": "Sold",
      "active": "Active",
      "archived": "Archived",
      "draft": "Draft",
      "reserved": "Reserved",
      "sold": "Sold",
      "IN_REVIEW": "In review"
    },
    "submitForReview": "Submit for review",
    "submittedForReview": "Submitted for review.",
    "subtitle": "Manage your properties",
    "subtypes": {
      "AGRICULTURAL": "Agricultural Land",
      "APARTMENT": "Apartment / Condominium Unit",
      "AUTO_REPAIR": "Auto Repair Shop",
      "CONDOMINIUM": "Condominium",
      "DATA_CENTER": "Data Center",
      "DEVELOPMENT": "Development Site",
      "FACTORY": "Factory / Production Facility",
      "FITNESS_CENTER": "Fitness Center / Wellness",
      "GAS_STATION": "Gas Station",
      "HOTEL": "Hotel",
      "LOGISTICS": "Logistics Property",
      "MEDICAL_PRACTICE": "Medical Practice / Health Center",
      "MIXED_COMMERCIAL": "Mixed Commercial Space",
      "MULTI_FAMILY": "Multi-Family House",
      "OFFICE": "Office",
      "PARKING": "Parking Garage / Lot",
      "PRODUCTION": "Production Space",
      "RESTAURANT": "Restaurant / Gastronomy",
      "RETAIL": "Retail Space",
      "SHOWROOM": "Showroom",
      "SINGLE_FAMILY": "Single Family House",
      "VILLA": "Villa",
      "WAREHOUSE": "Warehouse",
      "WORKSHOP": "Workshop / Trade Business"
    },
    "tabs": {
      "basicData": "Basic Data",
      "details": "Property Features",
      "legal": "Legal",
      "media": "Media & Marketing",
      "pricing": "Price & Financials",
      "translations": "Translations"
    },
    "templates": {
      "deleted": "Template deleted",
      "empty": "No templates saved",
      "loaded": "Template loaded",
      "namePrompt": "Template name:",
      "saveAs": "Save as template...",
      "saved": "Template saved",
      "title": "Templates"
    },
    "regenerateTexts": {
      "button": "Regenerate texts",
      "error": "Text generation failed",
      "field": {
        "ariaLabel": "Regenerate {{field}}",
        "button": "Regenerate",
        "description": "Optionally add a note — only this field will be regenerated (German).",
        "instructionLabel": "Note / instruction (optional)",
        "instructionPlaceholder": "e.g. keep it shorter, focus more on yield",
        "loading": "Generating...",
        "submit": "Regenerate",
        "success": "Field was regenerated",
        "title": "Regenerate {{field}}"
      },
      "hint": "Regenerates subheader, highlights, description and macro/micro location via AI (German). Existing texts will be overwritten.",
      "loading": "Generating texts...",
      "success": "Texts were regenerated"
    },
    "title": "Properties",
    "translations": {
      "autoTranslate": "Auto-Translate",
      "autoTranslateFailed": "Automatic translation failed",
      "autoTranslateSuccess": "Translations generated automatically",
      "autoTranslating": "Creating translations...",
      "compareTo": "Compare to",
      "contentSection": "Content",
      "hint": "Texts are saved separately per language. Fill in one language and use auto-translate for the others.",
      "locationSection": "Location Description",
      "namePlaceholder": "e.g. Office Building Zurich City",
      "noSourceContent": "Please fill in at least the title or description first",
      "notFilled": "Not filled",
      "outOfSync": "The master language ({{lang}}) has been modified. Translations may be outdated.",
      "sideBySide": "Compare languages side by side",
      "sideBySideShort": "Compare",
      "subheaderPlaceholder": "e.g. Prime location in the business district"
    },
    "type": "Type",
    "types": {
      "COMMERCIAL": "Commercial",
      "INDUSTRIAL": "Industrial",
      "LAND": "Land",
      "MIXED_USE": "Residential / Commercial",
      "RESIDENTIAL": "Residential",
      "apartment": "Apartment",
      "commercial": "Commercial",
      "house": "House",
      "land": "Land",
      "office": "Office",
      "retail": "Retail"
    },
    "unitMix": {
      "addRange": "Range",
      "area": "Area m²",
      "areaFrom": "Area m² from",
      "areaTo": "Area m² to",
      "removeRange": "Remove range",
      "rentedCount": "Rented",
      "rooms": "Rooms",
      "totalCount": "Total"
    },
    "validation": {
      "fixErrors": "Please fill in all required fields",
      "required": "Required field"
    },
    "unifiedWizard": {
      "advancedFields": "Advanced details",
      "annualRentalIncome": "Annual rental income (CHF)",
      "anzahlEtagen": "Number of floors",
      "areas": "Areas",
      "buildingCount": "Number of buildings",
      "cadastreNumber": "Cadastre number",
      "commercialAreaSqm": "Commercial area (m²)",
      "commercialUnits": "Commercial units",
      "create": "Create property",
      "createFailed": "Creation failed",
      "createSuccess": "Property created successfully",
      "detailedDescription": "Detailed description",
      "energyEnvelope": "Energy class envelope",
      "energyTotal": "Energy class overall",
      "garageParking": "Garage parking spaces",
      "groundLeaseExpiration": "Ground lease expiration",
      "hasBuildingPermit": "Building permit available",
      "hasGroundLease": "Ground lease",
      "hasLift": "Elevator available",
      "imageUploadFailed": "{{count}} of {{total}} images could not be uploaded",
      "internalFields": "Internal details",
      "investmentHighlights": "Investment highlights",
      "offerPrice": "Offer price",
      "offerPriceHint": "The offer price is shown to investors.",
      "outdoorParking": "Outdoor parking spaces",
      "ownershipType": "Ownership type",
      "principal": {
        "blockedHint": "Principal and mandate type are required before continuing with the next steps.",
        "contactCreateFailed": "Contact could not be created.",
        "contactCreated": "Contact created successfully",
        "contactHint": "Select an existing CRM contact or create a new principal.",
        "contactLabel": "Principal (CRM contact)",
        "createNew": "Create new contact",
        "email": "Email",
        "firstName": "First name",
        "lastName": "Last name",
        "lastNameRequired": "Please enter the last name",
        "optionalHint": "Principal is optional. You can fill it in anytime via the sticky header on the edit page.",
        "ready": "Principal captured — you can continue.",
        "saveContact": "Create contact",
        "searchPlaceholder": "Search contact...",
        "subtitle": "Who is the principal commissioning this property's marketing?"
      },
      "principalRequired": "Please capture the principal and the mandate type first.",
      "renovation": "Renovation",
      "residentialAreaSqm": "Residential area (m²)",
      "residentialUnits": "Residential units",
      "status": {
        "complete": "Complete",
        "incomplete": "Incomplete",
        "neutral": "Optional"
      },
      "steps": {
        "aiUpload": "AI upload",
        "basicData": "Basic data",
        "details": "Property features",
        "legal": "Legal",
        "media": "Media & marketing",
        "pricing": "Price & marketing",
        "principal": "Principal",
        "summary": "Summary"
      },
      "subtitle": "Capture your property in 8 steps",
      "summaryHint": "Please review the details and create the property.",
      "title": "Capture property",
      "virtualTourUrl": "Virtual tour URL (optional)",
      "volumeM3": "Volume (m³)"
    },
    "wizard": {
      "button": "Assistant",
      "create": "Create Property",
      "descriptionPlaceholder": "Detailed property description...",
      "imagesCount": "images",
      "investmentHighlightsPlaceholder": "e.g. Stable yield of 4.5%, long-term leases...",
      "photosFormats": "JPG, PNG, WEBP — max. 20 MB per image",
      "photosHint": "Good photos are the best selling point. Upload meaningful property photos.",
      "photosUpload": "Drag photos here or click to upload",
      "primaryImage": "Primary image",
      "steps": {
        "address": "Address",
        "classification": "Classification",
        "details": "Property details",
        "land": "Land",
        "photos": "Photos",
        "pricing": "Pricing",
        "summary": "Summary",
        "teaser": "Teaser",
        "titleAddress": "Title & Address",
        "type": "Type"
      },
      "subtitle": "Step-by-step assistant",
      "summaryHint": "After creation you can edit the property in detail, upload documents and add translations.",
      "teaserHighlightsPlaceholder": "e.g. Top location in Zurich, freshly renovated, fully let...",
      "teaserHint": "Describe the property for potential investors. These texts appear on the teaser.",
      "title": "New Property",
      "virtualTourUrl": "VR tour URL (optional)"
    },
    "yearBuilt": "Year Built",
    "yield": "Yield",
    "activateProperty": "Immobilie aktivieren",
    "activateDescription": "Die Immobilie wird für Investoren sichtbar und kann in Angebotslisten (Listings) aufgenommen werden.",
    "activateChecklist": "Bitte stelle sicher, dass folgende Punkte erfüllt sind:",
    "activateCheck1": "Übersetzungen (Name, Beschreibung) vorhanden",
    "activateCheck2": "Mindestens ein Bild hochgeladen",
    "activateCheck3": "Mindestpreis gesetzt",
    "activateCheck4": "Adresse und Standort korrekt",
    "reviewSubmitted": "Immobilie zur Prüfung eingereicht",
    "ownerDraftHint": "Diese Immobilie ist noch nicht sichtbar für Investoren.",
    "ownerReviewHint": "Wird gerade vom Immotron-Team geprüft.",
    "ownerActiveHint": "Sichtbar für Investoren.",
    "saleMode": {
      "fixedPrice": "Fixpreis",
      "offerCollection": "Bieterverfahren"
    },
    "commissionConditions": {
      "title": "Terms",
      "hint": "Applies to all buyers of this property unless an individual Appendix B exists.",
      "currentModel": "Applicable fee model",
      "noModel": "No fee model set",
      "noModelOption": "No fee model — no property terms",
      "specialConditions": "Special terms",
      "specialConditionsPlaceholder": "Deviating arrangements for this property, e.g. commission split or minimum fee",
      "save": "Save terms",
      "saved": "Terms saved",
      "saveFailed": "Terms could not be saved",
      "loading": "Loading terms …",
      "loadFailed": "Terms could not be loaded",
      "noneHint": "No property terms. Per buyer the rate from their framework agreement applies, otherwise the standard “{{model}}” — with a buyer agreement set to “variable” nothing is agreed without property terms.",
      "noneHintNoDefault": "No property terms. Per buyer the rate from their framework agreement applies — with a buyer agreement set to “variable” nothing is agreed without property terms.",
      "blocked": {
        "no_contract": {
          "title": "No framework agreement linked",
          "hint": "Property conditions are tied to the client’s framework contract. Create or link the contract first, then the conditions can be set.",
          "cta": "Create framework contract"
        },
        "unsupported_contract": {
          "title": "Property terms not available on this contract",
          "hint": "Appendix B (property release) is only supported on a seller framework agreement. Until then the terms shown above apply."
        }
      }
    }
  },
  "propertyChat": {
    "askButton": "Ask a question",
    "disclaimer": "AI-generated — not legal advice",
    "error": "Sorry, I could not answer your question. Please try again.",
    "placeholder": "Type your question...",
    "suggestion1": "What is the yield?",
    "suggestion2": "Describe the location",
    "suggestion3": "When was it built?",
    "title": "Property Questions",
    "welcome": "Ask a question about this property — e.g. about location, yield, or features."
  },
  "propertyDetail": {
    "approvalError": "Fehler bei der Genehmigung",
    "available": "Vorhanden",
    "buildingArea": "Building Area",
    "buyNow": "Buy Now",
    "description": "Description",
    "documents": "Documents",
    "documentsLocked": "Documents available after NDA approval",
    "download": "Download",
    "downloadFailed": "Download fehlgeschlagen",
    "energyEnvelope": "Hülle",
    "energyTotal": "Gesamt",
    "financialMetrics": "Finanzielle Kennzahlen",
    "floors": "Floors",
    "grossIncome": "Gross Rental Income",
    "imageCounter": "{{current}} / {{total}}",
    "investmentHighlights": "Investment Highlights",
    "investorActivity": {
      "interested": "{{count}} investors interested",
      "ndaConfirmed": "{{count}} NDA confirmed"
    },
    "keyFigures": "Key Figures",
    "location": "Location",
    "lotSize": "Lot Size",
    "ndaRequired": "NDA confirmation required for document access",
    "noDocuments": "No documents available",
    "noImages": "No images available",
    "overview": "Overview",
    "parkingGarage": "Garage",
    "parkingOutdoor": "Aussen",
    "placeBid": "Place Bid",
    "preview": "Vorschau",
    "priceLocked": "Price after NDA",
    "pricePerSqm": "Price/sqm",
    "rejectionError": "Fehler bei der Ablehnung",
    "rentalYield": "Rental Yield",
    "sections": {
      "details": "Details",
      "documents": "Documents",
      "financials": "Financials",
      "overview": "Overview",
      "timeline": "Timeline",
      "offers": "Angebot"
    },
    "submitError": "Fehler beim Einreichen",
    "submitOffer": "Submit Offer",
    "technicalDetails": "Technische Details",
    "title": "Property Details",
    "totalPrice": "Total Price",
    "units": "Units",
    "uploadFailed": "Upload fehlgeschlagen",
    "yearBuilt": "Year Built",
    "building": {
      "floors": "Stockwerke",
      "lift": "Aufzug",
      "heating": "Heizung",
      "energyTotal": "Energieklasse",
      "energyEnvelope": "Gebäudehülle",
      "condition": "Zustand",
      "renovation": "Renovierung",
      "residentialArea": "Wohnfläche",
      "commercialArea": "Gewerbefläche",
      "parking": "Parkplätze",
      "groundLease": "Baurecht",
      "title": "Gebäudedetails"
    },
    "investmentMetrics": "Investitionskennzahlen",
    "metrics": {
      "grossYield": "Bruttorendite",
      "vacancyRate": "Leerstand",
      "marketValue": "Marktwert"
    },
    "auftraggeber": {
      "title": "Client",
      "subtitle": "Who am I allowed to talk to?",
      "openDrawer": "Show client details",
      "statusActive": "Active marketing mandate",
      "statusExpired": "Marketing mandate expired",
      "statusNone": "No marketing mandate",
      "ownMandate": "Own mandate (outside Immotron)",
      "ownMandateShort": "Own mandate",
      "ownMandateHint": "The sales mandate exists outside the platform.",
      "company": "Company",
      "companyMissing": "Company not yet captured",
      "uid": "UID",
      "primaryContact": "Primary contact",
      "contact": "Contact details",
      "noContact": "No contact details available. Please add via \"Edit\".",
      "phoneMissing": "Phone not yet captured",
      "emailMissing": "E-mail not yet captured",
      "mandate": "Marketing mandate",
      "startDate": "Start",
      "endDate": "End",
      "minimumPrice": "Minimum price",
      "noMandate": "No mandate details available yet.",
      "contract": "Contract details",
      "contractNumber": "Contract number",
      "contractType": "Type",
      "signedAt": "Signed",
      "expiresAt": "Expires",
      "duration": "Duration",
      "durationMonths": "{{count}} months",
      "openContract": "Open contract",
      "commission": "Fee",
      "commissionModel": "Model",
      "commissionFlatRate": "Flat rate",
      "commissionBrackets": "Brackets",
      "commissionBracketsCount": "{{count}} tiers",
      "wishes": "Seller wishes & notes",
      "desiredPrice": "Desired price",
      "desiredTimeline": "Desired timeframe",
      "notes": "Notes",
      "noWishes": "No wishes or notes recorded.",
      "quickActions": "Quick actions",
      "actionCall": "Call",
      "actionEmail": "E-mail",
      "actionMeeting": "Meeting",
      "actionEdit": "Edit",
      "comingSoon": "Coming soon",
      "search": {
        "title": "Search principal",
        "subtitle": "Only companies and contacts with an active platform contract are shown.",
        "placeholder": "Company, UID, name or e-mail...",
        "hint": "Enter at least 2 characters to search.",
        "empty": "No matches with an active platform contract. Please sign a marketing mandate first.",
        "error": "Search failed. Please try again.",
        "saveSuccess": "Principal saved",
        "saveFailed": "Save failed. Please try again.",
        "clearSuccess": "Link removed",
        "current": "Current link",
        "currentCompany": "Company linked",
        "currentContact": "Contact linked",
        "unlink": "Remove",
        "typeCompany": "Company",
        "typeContact": "Contact",
        "linked": "Active",
        "noDetails": "No further details",
        "contractActive": "Contract active",
        "contractActiveHint": "Platform contract (SELLER_FRAMEWORK) is signed."
      }
    }
  },
  "publicHelp": {
    "badge": "Help & Guide",
    "cta": {
      "button": "Sign up now",
      "subtitle": "Create your account and discover exclusive real estate opportunities.",
      "title": "Ready to Get Started?"
    },
    "faq": {
      "items": [
        {
          "a": "The platform is free for investors. Sellers and brokers pay a success-based fee upon closing.",
          "q": "Is Immotron free to use?"
        },
        {
          "a": "All sensitive data is protected by NDA agreements and role-based access controls. Documents are stored in encrypted form.",
          "q": "How is my data protected?"
        },
        {
          "a": "After the NDA you immediately gain access to the full dossier with all details, the exact address and all financial metrics.",
          "q": "What happens after confirming the NDA?"
        },
        {
          "a": "Yes, Immotron is fully responsive and works on all devices — desktop, tablet and smartphone.",
          "q": "Can I use Immotron on my phone?"
        },
        {
          "a": "Upload a PDF and our AI automatically recognises floor areas, rental income, year of construction and other key metrics. You review and confirm the results.",
          "q": "How does the AI data extraction work?"
        },
        {
          "a": "In a bidding round, multiple investors can submit offers within a set timeframe. The seller then decides on the winning bid.",
          "q": "What is a bidding round?"
        }
      ],
      "title": "Frequently Asked Questions"
    },
    "features": {
      "automated": {
        "desc": "AI-powered data extraction, automated emails and intelligent clause suggestions.",
        "title": "Automated Workflows"
      },
      "digital": {
        "desc": "From first contact to signature — everything online, paperless and fully traceable.",
        "title": "100% Digital"
      },
      "realtime": {
        "desc": "Push notifications and email updates at every important step in the process.",
        "title": "Real-Time Notifications"
      },
      "roles": {
        "desc": "Tailored views for investors, sellers, sales teams and administrators.",
        "title": "Roles for Every Need"
      },
      "secure": {
        "desc": "NDA-protected dossiers, encrypted documents and role-based access controls.",
        "title": "Secure & Confidential"
      },
      "title": "Why Immotron?",
      "transparent": {
        "desc": "Exposé and rent roll with all relevant financial data at a glance.",
        "title": "Transparent Metrics"
      }
    },
    "footer": "All rights reserved",
    "hero": {
      "subtitle": "Immotron connects real estate investors and sellers on a secure, digital platform. Here's how the process works, step by step.",
      "title": "How Immotron Works"
    },
    "investor": {
      "steps": {
        "deal": {
          "desc": "Once awarded, you receive the draft contract for digital signature. The entire process is transparently documented on the timeline.",
          "title": "Close the Deal"
        },
        "dossier": {
          "desc": "The dossier includes the rent roll, exposé, floor plans, photos and all relevant financial metrics — available for download or inline preview.",
          "title": "Review Full Dossier"
        },
        "nda": {
          "desc": "Interested? Confirm the NDA digitally to gain access to the full dossier with all details and the exact address.",
          "title": "Non-Disclosure Agreement (NDA)"
        },
        "offer": {
          "desc": "Submit a non-binding offer (NBO) or a binding offer (BO). During bidding rounds you can see the timeframe and adjust your offer accordingly.",
          "title": "Submit an Offer"
        },
        "search": {
          "desc": "Explore available investment properties with filters for location, yield, property type and price range. The map view shows you the approximate location.",
          "title": "Browse Properties"
        },
        "teaser": {
          "desc": "Each property comes with an anonymised teaser dossier featuring key data, photos and metrics — without revealing the exact address.",
          "title": "View Teaser Dossier"
        }
      },
      "title": "The Investor Process"
    },
    "login": "Sign in",
    "seller": {
      "steps": {
        "contract": {
          "desc": "Create purchase contracts directly on the platform using our contract wizard. Clauses are suggested with AI support.",
          "title": "Contract Creation"
        },
        "matching": {
          "desc": "Immotron targets your property to qualified investors. You can see in real time who has shown interest and signed the NDA.",
          "title": "Investor Matching"
        },
        "review": {
          "desc": "Review the AI-extracted data and fill in any missing information. A quality gate ensures all required fields are complete.",
          "title": "Review & Complete Data"
        },
        "updates": {
          "desc": "Follow the entire deal progress on the timeline. Push notifications keep you informed about every step.",
          "title": "Real-Time Updates"
        },
        "upload": {
          "desc": "Upload photos and documents — our AI automatically extracts key data such as floor areas, rental income and year of construction.",
          "title": "Register Your Property"
        }
      },
      "title": "The Seller Process"
    },
    "tabs": {
      "investor": "For Investors",
      "seller": "For Sellers"
    }
  },
  "onboarding": {
    "title": "Open your account",
    "intro": "Please review the details we have on file. If they are correct, confirm them and proceed directly to signing the contract.",
    "footer": "All rights reserved.",
    "loading": "Loading details...",
    "validUntil": "Link valid until",
    "confirmHint": "If all details are correct, confirm them to proceed with signing the contract.",
    "confirm": "Open account →",
    "confirming": "Opening your account …",
    "reportCorrection": "Report a correction",
    "legalNotice": "By confirming, you declare that the details shown are correct.",
    "coSigner": {
      "title": "Second signature",
      "description": "Your company signs jointly. The contract therefore requires a second authorised signatory in addition to your signature.",
      "selectLabel": "Second authorised signatory",
      "otherPerson": "Enter another person",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email of the second person",
      "emailPlaceholder": "name@company.com",
      "emailHint": "We send the personal signing link to this address.",
      "bothSignHint": "Both people receive a link to sign.",
      "required": "Please provide the second authorised signatory including a valid email address.",
      "confirmedTitle": "Details confirmed",
      "confirmedDescription": "Both people receive a link to sign. You can sign right now.",
      "signatories": "Signatories",
      "signNow": "Sign now"
    },
    "company": {
      "title": "Company details",
      "name": "Company",
      "uid": "UID",
      "address": "Address"
    },
    "person": {
      "title": "Contact person",
      "name": "Name",
      "function": "Function"
    },
    "conditions": {
      "title": "Your conditions",
      "propertyHint": "This concerns {{hint}}.",
      "contractGroup": "Contract",
      "feeGroup": "Fees",
      "costLabel": "Costs",
      "buyerCommission": "Buyer's commission (payable by you)",
      "sellerCommission": "Seller's commission (paid by the seller)",
      "transparencyHint": "Immotron discloses both commissions — no hidden fees.",
      "matchHint": "These conditions appear verbatim in the contract you will receive for signature after confirming.",
      "CONTRACT_TYPE_TEXT": "Contract",
      "COMMISSION_TEXT": "Commission"
    },
    "correction": {
      "title": "Report a correction",
      "description": "Please describe which details are incorrect. Our team will review your message and get back to you.",
      "label": "Your correction",
      "placeholder": "What needs to be corrected?",
      "submit": "Send correction",
      "submitting": "Sending...",
      "cancel": "Cancel"
    },
    "correctionSent": {
      "title": "Message received",
      "description": "Thank you — we will review the details and send you a new link.",
      "descriptionWithAdvisor": "Thank you — your advisor {{advisor}} will review the details and send you a new link.",
      "yourMessage": "Your message",
      "quotedMessage": "“{{message}}”",
      "advisorContact": "Your contact person"
    },
    "actions": {
      "home": "Go to home page",
      "close": "Close window",
      "closeHint": "Your browser does not allow closing this window automatically. Please close the tab manually."
    },
    "alreadyActive": {
      "title": "Already active",
      "description": "You already have an active contract. You can view your contracts at any time in the settings."
    },
    "alreadyUsed": {
      "title": "Link already used",
      "description": "This confirmation link has already been used. If you have any questions, please contact your representative."
    },
    "verificationFailed": {
      "title": "Confirmation not possible",
      "description": "Your signing authority could not be confirmed automatically. Our team has been notified and will get back to you."
    },
    "expired": {
      "title": "Link expired",
      "description": "Unfortunately, this confirmation link has expired. Please contact your representative for a new link."
    },
    "error": {
      "title": "Error",
      "generic": "An unexpected error occurred. Please try again.",
      "invalidToken": "Invalid or unknown confirmation link.",
      "loadFailed": "The details could not be loaded.",
      "confirmFailed": "The confirmation could not be processed. Please try again.",
      "correctionFailed": "The correction could not be sent. Please try again."
    },
    "welcome": "Welcome, {{name}}",
    "invitedBy": "{{mandant}} invites you to view properties on Immotron.",
    "invitedGeneric": "You are invited to view properties on Immotron.",
    "nextStep": "then: a quick signature",
    "fullContract": "Show the full contract",
    "termsLink": "Read the terms of use",
    "benefits": {
      "title": "This is what you get:",
      "account": "a free account",
      "view": "view properties and their documents",
      "offer": "submit offers"
    },
    "cost": {
      "title": "What does it cost?",
      "text": "Nothing. You only pay a commission if you buy a property. You see the amount on every property before you open any documents."
    },
    "details": {
      "title": "Are your details correct?",
      "change": "change"
    }
  },
  "publicProvider": {
    "offeredBy": "Offered by",
    "contact": "Your contact"
  },
  "publicTeaser": {
    "title": "Exclusive investment opportunity",
    "subtitle": "A first overview. You will see the address, the dossier and all documents as soon as you have opened your free account.",
    "footer": "All rights reserved.",
    "loading": "Loading teaser...",
    "cta": {
      "loginTitle": "You already have access",
      "loginHint": "Sign in to view the full dossier with address, location and all documents.",
      "loginButton": "Sign in",
      "startTitle": "Open your account",
      "startHint": "Enter your email address — we take you straight to opening your account and then unlock the address, location and the complete property dossier.",
      "createAccountTitle": "Create account",
      "createAccountHint": "To see the address, the location and the complete dossier, open your free account now. Afterwards you review your details and sign briefly online.",
      "createAccountButton": "Create account",
      "emailLabel": "Email address",
      "emailHint": "Please enter the email address this teaser was sent to.",
      "emailInvalid": "Please enter a valid email address.",
      "newHereToggle": "I am new here",
      "firstName": "First name",
      "lastName": "Last name",
      "companyName": "Company",
      "companyUid": "UID number",
      "continueButton": "Continue to open your account",
      "submitError": "Opening your account could not be started. Please try again later.",
      "rateLimitError": "Too many attempts. Please wait a moment and try again.",
      "sentTitle": "We have sent you the link",
      "sentHint": "We have emailed you the link to open your account. Please check your inbox.",
      "hasContractTitle": "You already have an account",
      "hasContractHint": "An account already exists for this email address. Sign in to view the full dossier."
    },
    "expired": {
      "title": "Link expired",
      "description": "Unfortunately this teaser link has expired. Please contact your representative for a new link."
    },
    "error": {
      "title": "Teaser not found",
      "description": "This link is invalid or no longer available. Please check the link from your email or contact your representative."
    }
  },
  "publicSigning": {
    "accountLead": "You receive an account to view properties and submit offers. Costs only apply when you buy.",
    "accountTitle": "Open your account: signature",
    "agb": {
      "accept": "I have read and accept the platform terms of {{owner}}.",
      "acceptWithMandant": "I have read and accept the platform terms of {{owner}} and the supplementary terms of {{mandant}}.",
      "description": "The «Immotron» platform is operated by {{owner}}. Its terms of use apply in addition to this contract with {{counterparty}}. For fees and conditions, the contract prevails.",
      "descriptionNoCounterparty": "The «Immotron» platform is operated by {{owner}}. Its terms of use apply in addition to this contract. For fees and conditions, the contract prevails.",
      "mandantTerms": "View the supplementary terms of {{mandant}}",
      "modalTitle": "Platform Terms of Use",
      "requiredHint": "Please accept the Terms & Conditions to sign the contract.",
      "title": "Platform Terms of Use",
      "viewAgb": "View the platform terms of {{owner}}"
    },
    "authority": {
      "manual": "manually verified",
      "register": "verified via commercial register",
      "signatureType": {
        "COLLECTIVE_MORE": "Joint signature by several",
        "COLLECTIVE_TWO": "Joint signature by two",
        "NONE": "no signing authority",
        "SINGLE": "Sole signature"
      },
      "unverified": "not verified",
      "unverifiedHint": "The signing authority has not yet been verified against the commercial register. By signing, you confirm that you are authorised to sign on behalf of {{company}}.",
      "unverifiedHintGeneric": "The signing authority has not yet been verified against the commercial register. By signing, you confirm that you are authorised to sign this contract."
    },
    "alreadySigned": {
      "countersignHint": "Your signature has been recorded. The contract is currently being countersigned by Immotron. You will be notified by email once complete, and your account will be activated.",
      "countersignPending": "Countersignature pending",
      "description": "This contract has already been signed by you.",
      "downloadPdf": "Download contract as PDF",
      "fullySigned": "Contract fully signed",
      "fullySignedHint": "All parties have signed. You will receive your account credentials and can view your contracts under Settings at any time.",
      "noActionNeeded": "Your signature has been saved. No further action is required.",
      "othersPending": "Other signatures pending",
      "othersPendingHint": "Your signature has been recorded. You will be notified by email about next steps once all parties have signed.",
      "signedAt": "Signed on",
      "signedAtValue": "{{date}} at {{time}}",
      "title": "You have already signed"
    },
    "backToSigning": "Back to signing",
    "cancelled": {
      "description": "It can no longer be signed. If you have any questions, please contact your contact person.",
      "title": "This contract has been cancelled"
    },
    "contractDetails": "Contract Details",
    "contractNumber": "Contract Number",
    "contractType": "Contract Type",
    "downloadPdf": "Download PDF",
    "error": {
      "generic": "An unexpected error occurred. Please try again.",
      "invalidToken": "Invalid or unknown signing link.",
      "kycRequired": "Please complete your identification first.",
      "loadFailed": "The contract could not be loaded.",
      "submitFailed": "The signature could not be submitted. Please try again.",
      "title": "Error"
    },
    "expired": {
      "description": "This signing link has expired. Please contact your representative for a new link.",
      "title": "Link Expired"
    },
    "footer": "All rights reserved.",
    "geo": {
      "allow": "Share Location",
      "description": "For legal documentation, your location can be recorded. This is optional.",
      "title": "Location Sharing"
    },
    "legalNotice": "By signing, you confirm that you have read and understood the contract.",
    "loading": "Loading contract...",
    "newTabHint": "Opens in a new tab",
    "otp": {
      "description": "This signature additionally requires a confirmation code (advanced electronic signature).",
      "error": {
        "channelUnavailable": "The code could not be delivered. Please contact your representative.",
        "cooldown": "Please wait a moment before requesting a new code.",
        "expired": "The code has expired — please request a new code.",
        "invalid": "The code is incorrect.",
        "locked": "Too many failed attempts — please request a new code.",
        "notRequired": "No confirmation code is required for this signature.",
        "required": "Please request and enter the code first.",
        "sendFailed": "The code could not be sent. Please try again."
      },
      "label": "6-digit code",
      "requiredHint": "Please enter the 6-digit confirmation code.",
      "resend": "Send code again",
      "resendIn": "Send code again ({{seconds}} s)",
      "send": "Send code",
      "sending": "Sending code ...",
      "sentHint": "We sent a 6-digit code to {{hint}} (valid for 5 minutes).",
      "sentHintGeneric": "We sent you a 6-digit code (valid for 5 minutes).",
      "title": "Confirmation code"
    },
    "parties": "Contract Parties",
    "partiesCompact": "Who signs",
    "partyStatus": {
      "pending": "Pending",
      "signed": "Signed"
    },
    "pdfTitle": "Contract Preview",
    "role": {
      "agent": "Authorized Agent",
      "broker": "Broker",
      "buyer": "Buyer",
      "companyRep": "Company Representative",
      "label": "Role",
      "operator": "Operator",
      "partner": "Partner",
      "seller": "Seller",
      "user": "User"
    },
    "signatory": "Signatory",
    "signatureLabel": "Signature",
    "signatureTitle": "Your Signature",
    "signedFor": "Signed on behalf of",
    "signingFor": "You are signing on behalf of",
    "steps": {
      "agb": "Accept terms of use",
      "contract": "View contract",
      "otp": "Enter code",
      "sign": "Sign"
    },
    "submit": "Sign Now",
    "submitting": "Signing...",
    "success": {
      "contractNumber": "Contract Number",
      "description": "Your signature has been submitted successfully. You will receive a confirmation by email.",
      "title": "Successfully Signed!"
    },
    "title": "Contract Signing",
    "validUntil": "Valid Until",
    "viewPdf": "View Contract",
    "youPrefix": "You:"
  },
  "qualityGate": {
    "buyerSuggestions": {
      "title": "AI buyer suggestions",
      "hint": "Buyers suggested by the AI, ranked by fit. Selected ones get teaser access on approval.",
      "load": "Load buyer suggestions",
      "reload": "Recalculate",
      "loading": "Calculating suggestions …",
      "loadFailed": "Buyer suggestions could not be loaded",
      "retry": "Try again",
      "empty": "No matching buyers found",
      "fitScore": "Fit: {{score}}%",
      "showReasoning": "Show reasoning",
      "hideReasoning": "Hide reasoning",
      "summary": "{{count}} buyers get access on approval",
      "assign": "Assign {{count}} buyer(s)"
    },
    "address": "Address",
    "approve": "Approve",
    "approveConfirm": "Are you sure you want to approve this property?",
    "approveSuccess": "Property approved successfully",
    "approvedAt": "Approved on",
    "approvedTitle": "Quality gate passed",
    "releaseInvitations": {
      "title": "E-mails are being sent",
      "description": "On approval, {{count}} buyers now receive an e-mail with the teaser and onboarding link:",
      "noEmail": "No e-mail on file — this recipient will be skipped.",
      "hint": "Careful: a sent e-mail cannot be recalled.",
      "inviteTitle": "Invitation to new buyers",
      "accessTitle": "Access e-mail to buyers with an active contract",
      "groupTitle": "Access e-mail to group members",
      "accessHint": "These recipients receive the access e-mail on every approval.",
      "approveAndSend": "Approve and send",
      "approveOnly": "Approve only",
      "approveWithoutInvitations": "Approve without invitations",
      "sentToast": "{{count}} invitations sent",
      "notSentToast": "Not sent to {{count}} recipient(s): {{names}}",
      "groupNotifiedToast_one": "Access e-mail sent to {{names}}",
      "groupNotifiedToast_other": "Access e-mail sent to {{count}} group members: {{names}}",
      "groupAlreadyToast_one": "1 group member already had access — no new e-mail",
      "groupAlreadyToast_other": "{{count}} group members already had access — no new e-mail",
      "groupInvitedToast_one": "Invitation sent to {{names}}",
      "groupInvitedToast_other": "Invitation sent to {{count}} group members: {{names}}",
      "groupInviteFailedToast": "Invitation not sent to {{names}}"
    },
    "checkpoints": {
      "canton": "Canton provided",
      "city": "City provided",
      "contractSigned": "Contract signed",
      "description": "Description reviewed",
      "documents": "Documents complete",
      "images": "At least 1 image uploaded",
      "minimumPrice": "Minimum price set",
      "minimumPricePositive": "Minimum price greater than 0",
      "pricing": "Price set",
      "propertyType": "Property type set",
      "requiredFields": "Required fields completed",
      "translations": "At least 1 translation available"
    },
    "autoCheckTitle": "Automatic review checklist",
    "autoCheckHint": "These items are checked automatically from the property data.",
    "autoChecks": {
      "required_fields": "Required fields completed",
      "images": "At least 3 images uploaded",
      "description": "Description provided",
      "pricing": "Price set",
      "documents": "Documents uploaded",
      "highlights": "Investment highlights provided",
      "location": "Location description provided",
      "contract_signed": "Marketing contract signed"
    },
    "cannotApproveYet": "Approval requires all mandatory items to be green.",
    "approveBlocked": {
      "title": "Approval not possible yet — these mandatory items are open:"
    },
    "optional": "Optional",
    "pendingReviews": "{{count}} to review",
    "morePropertiesPending": "{{count}} properties pending review — select one to switch.",
    "selectAnother": "Select another property",
    "selectProperty": "Select a property",
    "selectPropertyHint": "Choose a property on the left to display preview and review checklist.",
    "teaserPreview": "Investor preview",
    "teaserPreviewHint": "Preview as the investor sees it",
    "discretion": {
      "title": "Discretion before NDA",
      "none": "No identifying details in the teaser",
      "edit": "Edit teaser texts"
    },
    "newsletterPreview": {
      "description": "How this teaser is sent as an e-mail/newsletter — the preview matches the sent e-mail exactly.",
      "teaserImages": "{{count}} teaser images",
      "hiddenImages": "{{count}} only visible after NDA",
      "locationConfirm": "Deliberately release location-critical images for the teaser",
      "blocked": "Sending blocked — please resolve the following first:",
      "refresh": "Refresh",
      "loadFailed": "Newsletter preview could not be loaded.",
      "retry": "Try again",
      "iframeTitle": "Newsletter preview as e-mail",
      "empty": "No newsletter preview available."
    },
    "contractNotSigned": "No signed contract found",
    "decideFailed": "Failed to save decision",
    "empty": "No properties pending review",
    "emptyHint": "New submissions will appear here automatically",
    "images": "{{count}} images",
    "imagesNone": "No images",
    "investorGroups": {
      "createNew": "Create new group",
      "empty": "No investor groups yet",
      "hint": "These groups automatically receive teaser access on approval.",
      "loadFailed": "Could not load investor groups",
      "summary": "{{investors}} investors from {{groups}} groups will receive access",
      "summaryPersons": "{{persons}} people from {{groups}} groups will receive access",
      "title": "Investor groups",
      "showMembers": "Show members of {{name}}",
      "hideMembers": "Hide members of {{name}}",
      "noMembers": "No members yet",
      "unknownMember": "Unknown member",
      "assign": "Assign {{count}} group(s)",
      "coversGroups": "Also applies to the members of the selected investor groups.",
      "missingHint": "Members of selected investor groups: one property condition set via «Set for all» covers every member without a condition of their own."
    },
    "loadFailed": "Failed to load review queue",
    "owner": "Owner",
    "previewFailed": "Could not load preview",
    "previewListing": "Buyer preview",
    "price": "Price",
    "progress": "{{checked}}/{{total}} checkpoints",
    "propertyDetails": "Property details",
    "readOnlyAfterApproval": "This property has been approved and can no longer be edited.",
    "readOnlyHint": "This property has been approved and can only be edited by an administrator.",
    "reject": "Reject",
    "rejectReason": "Reason (required)",
    "rejectReasonPlaceholder": "Please provide the reason for rejection...",
    "rejectSuccess": "Property rejected",
    "required": "Required",
    "reviewChecklist": "Review checklist",
    "sellerContract": {
      "active": "Contract active",
      "activeSince": "Contract active since {{date}}",
      "changeContract": "Change contract",
      "commission": "Commission",
      "contractNumber": "Contract number",
      "expiresAt": "Expires on {{date}}",
      "hideDetails": "Hide details",
      "noActive": "No active platform contract",
      "noActiveHint": "This property cannot be approved until the seller has a signed platform contract.",
      "openContract": "Open contract",
      "ownMandate": "Own mandate (outside Immotron)",
      "principal": "Principal",
      "searchContract": "Search contract",
      "showDetails": "Show details",
      "signatoryTypes": {
        "BUYER": "Buyer",
        "PLATFORM": "Platform",
        "SELLER": "Seller",
        "WITNESS": "Witness"
      },
      "signedBy": "Signed by",
      "title": "Seller contract"
    },
    "statuses": {
      "ACTIVE": "Active",
      "APPROVED": "Approved",
      "DRAFT": "Draft",
      "IN_REVIEW": "In Review",
      "REJECTED": "Rejected"
    },
    "submittedAt": "Submitted on {{date}}",
    "subtitle": "Property Approval",
    "timeline": {
      "boDays": "BO Phase (Days)",
      "boPhase": "BO Phase",
      "boReviewDays": "BO Review (Days)",
      "boReviewPhase": "BO Review",
      "days": "days",
      "excludeLowestNbo": "Exclude lowest NBO from BO",
      "excludeLowestNboHint": "When enabled, the lowest NBO offer is excluded from the BO candidate selection.",
      "durationPresetDays_one": "{{count}} day",
      "durationPresetDays_other": "{{count}} days",
      "durationPresets": "Quick duration",
      "endDate": "End Date",
      "fixedPrice": "Fixed Price",
      "fixedPriceInfo": "Listed Price",
      "fixedPriceLabel": "Sale Price",
      "guidePrice": "Guide Price",
      "nboDays": "NBO Phase (Days)",
      "nboPhase": "NBO Phase",
      "nboReviewDays": "NBO Review (Days)",
      "nboReviewPhase": "NBO Review",
      "offerCollection": "Offer Collection",
      "preview": "Timeline Preview",
      "reservePrice": "Reserve Price",
      "reservePriceHint": "Internal. Not shown to investors.",
      "saleMode": "Sale Mode",
      "startDate": "Start Date",
      "submissionDays": "Submission Period (Days)",
      "submissionPhase": "Submission Period",
      "title": "Sale Configuration",
      "totalDuration": "Total Duration"
    },
    "title": "Quality Gate",
    "translations": "{{count}} languages",
    "translationsNone": "No translations",
    "viewProperty": "Edit property",
    "zefix": {
      "autoLookup": "Loading seller data...",
      "contractActive": "Contract active",
      "contractActiveSince": "Contract active since {{date}}",
      "contractNumber": "Contract number",
      "expiresAt": "Expires on {{date}}",
      "importContacts": "Import {{count}} persons to CRM",
      "importDone": "{{count}} contacts have been imported to CRM",
      "importFailed": "Could not import contacts",
      "importSuccess": "{{count}} contacts successfully imported to CRM",
      "imported": "Imported",
      "importing": "Importing...",
      "legalForm": "Legal Form",
      "lookupFailed": "Seller data could not be loaded",
      "noActiveContract": "No active seller contract",
      "noActiveContractHint": "The Quality Gate only shows sellers with an active platform contract here. Please create and sign a contract first.",
      "noPersons": "No authorized signatories found",
      "noPersonsHint": "SHAB data is not available for this company. Please add signatories manually in the CRM.",
      "noUidActive": "The assigned company \"{{company}}\" has no UID. Authorized signatories cannot be loaded from the commercial register.",
      "openContract": "Open contract",
      "registeredPersons": "Authorized Signatories (ZEFIX)",
      "signedBy": "Signed by",
      "title": "Seller Commercial Register",
      "unknownSeller": "Unknown seller"
    },
    "personSearch": {
      "title": "Person search",
      "hint": "Manually assign CRM contacts or companies as buyers. The classification appears immediately: active or onboarding required."
    },
    "buyerConditions": {
      "setForAll": "Set for all",
      "setForBuyer": "Set for this buyer",
      "setForBuyerAria": "Set terms for {{name}}",
      "savedForBuyer": "Terms set for {{name}}",
      "modelRequired": "A fee model is required for buyer-specific terms.",
      "dialogTitle": "Set terms for all",
      "dialogHint": "The terms are stored as Appendix B on the property and apply to all assigned buyers without their own terms.",
      "dialogTitleBuyer": "Set terms for {{name}}",
      "dialogHintBuyer": "This buyer has a framework agreement (variable). The terms apply to this property only and are recorded as Appendix B on the buyer's framework agreement.",
      "buyerObjectCondition": "Property terms of this property: {{model}}.",
      "buyerNoObjectCondition": "No property terms are on file for this property.",
      "setPlannedForBuyer": "Set planned terms",
      "setPlannedForBuyerAria": "Set planned terms for {{name}}",
      "plannedSpecialCondition": "special terms",
      "plannedNoModel": "No selection — the property terms apply ({{model}})",
      "plannedNoModelMissing": "No selection — CAUTION: this property has no property terms",
      "plannedNoObjectCondition": "No property terms are set for this property: without their own commission model, no terms at all apply to this buyer once they sign.",
      "plannedSetObjectCondition": "Set property terms",
      "dialogTitlePlanned": "Set planned terms for {{name}}",
      "dialogHintPlanned": "This buyer does not have a framework agreement yet. Without their own commission model, the property terms of this property apply to them. With a commission model the buyer gets individual terms for this property — they are noted on the assignment and applied automatically as Appendix B once the buyer signs.",
      "emailLabel": "Buyer's email address",
      "emailRequired": "No email address is on file for this buyer — no invitation can be sent without one. Please add it now."
    },
    "conditionObjections": {
      "title": "Open objections to terms",
      "hint": "Buyers who rejected the property terms and proposed a different rate.",
      "property": "Property",
      "unknownProperty": "Property #{{id}}",
      "unknownPerson": "Unknown person",
      "proposedRate": "Proposed rate",
      "noRate": "No rate stated",
      "reason": "Reason",
      "date": "Received",
      "accept": "Accept",
      "acceptHint": "The agreed rate is recorded as Appendix B on the property.",
      "agreedRateLabel": "Agreed rate (%)",
      "acceptConfirm": "Accept",
      "accepted": "Objection accepted — Appendix B created with the agreed rate.",
      "acceptFailed": "The objection could not be accepted.",
      "reject": "Reject",
      "rejectHint": "The reason is sent to the buyer.",
      "rejectReasonLabel": "Reason",
      "rejectReasonPlaceholder": "Why is the counter-proposal rejected?",
      "rejectConfirm": "Reject",
      "rejected": "Objection rejected — the buyer has been informed.",
      "rejectFailed": "The objection could not be rejected."
    }
  },
  "researchLeads": {
    "actions": {
      "approve": "Freigeben",
      "autoMatch": "Auto-Match",
      "import": "Importieren",
      "reject": "Ablehnen",
      "website": "Website"
    },
    "allProjects": "Alle Projekte",
    "batchMatch": "Auto-Match alle",
    "deleteTitle": "Lead löschen",
    "detail": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "companyMatch": "Firma-Match",
      "contact": "Kontakt",
      "contactMatch": "Kontakt-Match",
      "created": "Erstellt",
      "email": "E-Mail",
      "employees": "Mitarbeiter",
      "industry": "Branche",
      "linkedin": "LinkedIn",
      "location": "Standort",
      "matching": "Matching",
      "nextSteps": "Nächste Schritte",
      "phone": "Telefon",
      "position": "Position",
      "profile": "Profil",
      "revenue": "Umsatz",
      "source": "Quelle"
    },
    "empty": "No leads found",
    "reject": "Ablehnen",
    "rejectPlaceholder": "Grund für die Ablehnung...",
    "rejectTitle": "Lead ablehnen",
    "searchPlaceholder": "Search company or contact...",
    "stats": {
      "approved": "Freigegeben",
      "imported": "Importiert",
      "matched": "Gematcht",
      "new": "Neu",
      "rejected": "Abgelehnt",
      "review": "Review",
      "total": "Gesamt"
    },
    "subtitle": "Staging area for researched leads",
    "table": {
      "companyContact": "Firma / Kontakt",
      "match": "Match",
      "project": "Projekt",
      "score": "Score",
      "status": "Status",
      "type": "Typ"
    },
    "title": "Research Leads",
    "toast": {
      "approveError": "Fehler bei Freigabe",
      "approved": "Lead freigegeben",
      "batchError": "Batch-Matching fehlgeschlagen",
      "deleteError": "Fehler beim Löschen",
      "deleted": "Lead gelöscht",
      "importError": "Import fehlgeschlagen",
      "matchError": "Matching fehlgeschlagen",
      "noMatch": "Kein Match gefunden",
      "rejectError": "Fehler beim Ablehnen",
      "rejected": "Lead abgelehnt"
    }
  },
  "researchPanel": {
    "adoptContacts": "Adopt contacts",
    "cardAddContact": "Create as contact",
    "cardAddContactHint": "Create as contact (coming soon)",
    "cardAddOrg": "Create as organisation",
    "cardAddOrgHint": "Create as organisation (coming soon)",
    "cardPin": "Pin",
    "cardPinHint": "Pin as relevant (coming soon)",
    "cardShowLess": "Show less",
    "cardShowMore": "Show more",
    "connections": "Network & connections",
    "existingCrmCompanies": "Bestehende CRM-Firmen",
    "existingCrmContacts": "Bestehende CRM-Kontakte",
    "foundContacts": "Found contacts",
    "merge": "Zusammenführen",
    "mergeButtonEnrich": "Zusammenführen & Ergänzen",
    "mergeButtonLink": "Bestehenden verwenden",
    "mergeCompanyTitle": "Firma zusammenführen",
    "mergeContactTitle": "Kontakt zusammenführen",
    "mergeDraft": "Recherche",
    "mergeError": "Fehler beim Zusammenführen",
    "mergeExisting": "Bestand (CRM)",
    "mergeField": "Feld",
    "mergeLoadError": "Fehler beim Laden des Datensatzes",
    "mergeLoading": "Lade Vergleichsdaten...",
    "mergeSubtitle": "Recherche-Daten mit bestehendem Eintrag abgleichen",
    "mergeWhatHappens": "Was passiert?",
    "internEmpty": "No internal CRM matches. The research did not find any existing contacts or organizations.",
    "noContacts": "No contacts found in research.",
    "overview": "Overview",
    "personProfile": "Profile",
    "pinnedSection": "Pinned ({{count}})",
    "resultsCount": "{{count}} result(s)",
    "searchingCrm": "Searching existing CRM entries...",
    "tabExtern": "External",
    "tabIntern": "Internal",
    "tabsLabel": "Research areas",
    "unnamed": "Unnamed",
    "unnamedQuery": "Research",
    "unpin": "Remove pin"
  },
  "roles": {
    "admin": "Administrator",
    "developer": "Developer",
    "investor": "Investor",
    "sales": "Sales"
  },
  "schema": {
    "columns": "Columns",
    "primaryKeys": "Primary Keys",
    "relationships": "Relationships",
    "subtitle": "Entity Relationship Diagram (ERD)",
    "tableList": "Table Overview",
    "tables": "Tables",
    "title": "Database Schema"
  },
  "searchProfile": {
    "companyFallback": "Company profile (applies to you)",
    "companyNone": "No search profile has been stored for your company yet.",
    "companyReadOnly": "Changes to the company profile go through your Immotron contact.",
    "createEmpty": "Create search profile",
    "createOwn": "Create my own profile (copy of the company profile)",
    "deleteConfirm": "The company profile will apply again afterwards. Delete your own profile?",
    "deleteOwn": "Delete my own profile",
    "emptyText": "Define what you are looking for — use, regions, deal size, no-gos.",
    "emptyTitle": "No search profile yet",
    "noCompany": "No company is linked to this login.",
    "noContact": "No contact person is linked to your login — please get in touch with your Immotron contact.",
    "noOwnHint": "You have no profile of your own — Immotron uses the company profile for property suggestions and for the comparison in your analyses.",
    "ownActive": "Your own profile is active · as of {{date}}",
    "tabCompany": "Company profile",
    "tabOwn": "My profile",
    "title": "My search profile"
  },
  "seller": {
    "counts": {
      "bo": "BO",
      "interested": "Interested",
      "nbo": "NBO",
      "nda": "NDA"
    },
    "detail": {
      "address": "Adresse",
      "aiHints": "KI-Hinweise",
      "allDetails": "Alle Objektdaten",
      "confidence": "KI-Konfidenz",
      "description": "Beschreibung",
      "downloadFailed": "Download fehlgeschlagen",
      "engagement": "Investor engagement",
      "engagementHint": "Detailed statistics are updated continuously.",
      "grossYield": "Bruttorendite",
      "investmentMetrics": "Investment-Kennzahlen",
      "loadFailed": "Immobilie konnte nicht geladen werden",
      "location": "Standort",
      "noDocuments": "Noch keine Dokumente. Laden Sie relevante Unterlagen hoch (Grundbuchauszug, Mieterspiegel, etc.).",
      "pricePerSqm": "Preis/m²",
      "pricePerSqmLand": "Price/m² land",
      "reviewHint": "Once all details are complete, submit your property for review. Our team checks the data and publishes the listing.",
      "submitFailed": "Submission failed. Please try again.",
      "submitReview": "Submit for review",
      "submitTitle": "Ready for review?",
      "submitting": "Submitting…",
      "uploadFailed": "Upload fehlgeschlagen"
    },
    "myProperties": {
      "addProperty": "Submit Property",
      "clearFilter": "Clear filter",
      "empty": "No properties yet",
      "emptyHint": "You haven't submitted any properties for marketing yet.",
      "filterActive": "Filtered by: {{status}}",
      "loadFailed": "Failed to load properties",
      "noResultsForFilter": "No properties match this filter",
      "noResultsForFilterHint": "There are no properties with this status.",
      "subtitle": "Overview of your properties",
      "title": "My Properties"
    },
    "wizard": {
      "aiAnalyze": "Start AI analysis",
      "aiComplete": "Analysis complete",
      "aiCompleteHint": "The detected data has been imported into the wizard. Please review and complete the details.",
      "aiPrefillSuccess": "Data imported from AI — please review and complete.",
      "aiPrefilled": "Pre-filled by AI — please review",
      "aiProcessing": "AI is analyzing your documents...",
      "aiProcessingFailed": "AI processing failed",
      "aiProcessingWait": "This may take 1-2 minutes.",
      "aiSkip": "Continue without AI analysis",
      "aiUploadDrop": "Drag and drop PDF documents or images here",
      "aiUploadFailed": "AI upload failed",
      "aiUploadFormats": "PDF, JPG, PNG, WebP — max. 50 MB per file",
      "aiUploadHint": "Upload the relevant documents: current rent index, building description, land register extract, building insurance certificate, market value appraisals (Wüest Partner, Fahrländer etc.) — AI will automatically fill in the wizard.",
      "classificationHint": "Select the type and optionally the subtype of your property.",
      "contractDeadlineHint": "Please note: The contract has an expiration date. Plan enough time for the transaction.",
      "create": "Submit Property",
      "createFailed": "Submission failed",
      "createSuccess": "Property submitted successfully",
      "desiredPrice": "Desired Price / Guide Price",
      "desiredPriceHint": "Your desired price — non-binding, not published",
      "desiredPricePlaceholder": "e.g. 1,800,000",
      "desiredTimeline": "Desired Timeline",
      "desiredTimelineHint": "When would you ideally like to sell?",
      "desiredTimelinePlaceholder": "e.g. Sale by Q3 2026, flexible immediately",
      "expectedPrice": "Expected Price (CHF)",
      "highlights": "Highlights",
      "highlightsHint": "These points appear prominently on the teaser for investors.",
      "highlightsPlaceholder": "e.g. Top location in Zurich, freshly renovated, fully let, stable yield...",
      "imagesCount": "images",
      "namePlaceholder": "e.g. Multi-family house Zurich-Seefeld",
      "photosFormats": "JPG, PNG, WEBP — max. 20 MB per image",
      "photosHint": "Good photos sell! Upload meaningful photos of your property.",
      "photosUpload": "Drag photos here or click",
      "primaryImage": "Primary image",
      "saleEndDate": "Desired sale end",
      "saleStartDate": "Desired sale start",
      "sellerNotes": "Notes",
      "sellerNotesPlaceholder": "e.g. Special circumstances, contract duration, desired conditions...",
      "steps": {
        "aiUpload": "AI Analysis",
        "classification": "Property type",
        "details": "Property data",
        "photos": "Photos",
        "pricing": "Key figures",
        "summary": "Summary",
        "titleAddress": "Title & Address"
      },
      "subtitle": "Submit your property in a few steps",
      "summaryHint": "After submission, our sales team will review your property and contact you.",
      "timeline": "Period",
      "title": "Submit Property"
    }
  },
  "settings": {
    "ai": "AI Assistant",
    "aiConfig": {
      "configured": "Configured",
      "currentKey": "Current Key",
      "enterKey": "Please enter API Key",
      "notConfigured": "Not configured",
      "replaceKey": "Replace API Key",
      "saveFailed": "Failed to save",
      "saved": "API Key saved",
      "setKey": "Set API Key",
      "status": "Status",
      "testConnection": "Test Connection",
      "testFailed": "Connection failed",
      "testSuccess": "Connection successful ({{model}}, {{duration}}s)",
      "testing": "Testing...",
      "title": "Claude AI"
    },
    "aiDescription": "Claude AI test environment",
    "analyses": "Property analyses",
    "apiTokens": {
      "confirmRevoke": "Really revoke?",
      "create": "New token",
      "createError": "Token could not be created.",
      "createdTitle": "Token successfully created",
      "createdWarning": "Copy the token now — it will not be shown again.",
      "description": "Create persistent API tokens for machine-to-machine authentication and E2E tests.",
      "dismiss": "Understood, close",
      "empty": "No API tokens created yet.",
      "expiresAt": "Expires on",
      "generate": "Generate",
      "nameLabel": "Token name",
      "namePlaceholder": "e.g. CI/CD pipeline, E2E tests",
      "revoke": "Revoke",
      "revokeError": "Token could not be revoked.",
      "revoked": "Token revoked",
      "tabLabel": "API tokens",
      "title": "API tokens"
    },
    "commissions": "Fee Models",
    "commissionsDescription": "Create and manage fee models",
    "displayMode": "Mode",
    "e2e": {
      "autoGenerated": "Der Report wird automatisch nach jedem E2E-Testlauf generiert.",
      "duration": "Dauer",
      "environment": "Umgebung",
      "failed": "Fehlgeschlagen",
      "generated": "Generiert",
      "loadError": "E2E-Report konnte nicht geladen werden.",
      "noReport": "Kein E2E-Report verfügbar. Starte die Tests mit: npx playwright test",
      "passed": "Bestanden",
      "refresh": "Aktualisieren",
      "subtitle": "Ergebnisse der automatisierten Browser-Tests",
      "title": "E2E Test Reports"
    },
    "investorGroups": "Investor Groups",
    "investorGroupsDescription": "Group investors and manage access",
    "kycReview": "Review identifications",
    "mandanten": "Mandant Management",
    "mandantenDescription": "Manage users and company assignments",
    "media": "Media",
    "mediaDescription": "Manage images and media files",
    "processVis": {
      "finale": {
        "duration": "Gesamtdauer: 6–12 Monate",
        "subtitle": "Transparenz, Effizienz und Professionalität — für Verkäufer und Investoren gleichermassen.",
        "title": "Deal abgeschlossen."
      },
      "hero": {
        "platform": "Immotron Plattform",
        "scrollHint": "Scroll für den Prozess",
        "subtitle": "Vom ersten Kontakt bis zum Closing — 14 Schritte, 3 Akteure, 1 Plattform.",
        "titleLine1": "Der Weg zum",
        "titleLine2": "erfolgreichen Deal"
      },
      "personas": {
        "employee": "Mitarbeiter",
        "investor": "Investor",
        "vendor": "Verkäufer"
      },
      "scrollMore": "Scroll weiter"
    },
    "processes": "Process Overview",
    "processesDescription": "Interactive visualization of the 3 core processes",
    "schema": "Database Schema",
    "schemaDescription": "View Entity Relationship Diagram",
    "signatories": "Signatories",
    "signatoriesDescription": "Manage internal authorized signatories",
    "subtitle": "System configuration and management",
    "system": "System",
    "systemDescription": "Customize appearance and color scheme",
    "theme": {
      "preset": "Color Scheme",
      "presets": {
        "default-blue": "Default Blue",
        "immotron-red": "Immotron Red"
      },
      "preview": "Preview",
      "saved": "Color scheme saved",
      "title": "Appearance"
    },
    "title": "Settings",
    "users": "User Management",
    "usersDescription": "Create, edit and manage users",
    "regulatedWhitelist": "Supervisory lists",
    "regulatedWhitelistDescription": "Import lists of supervised counterparties and review matches",
    "zefixSync": "Zefix Sync",
    "zefixSyncDescription": "Manage commercial register synchronization",
    "e2eReports": "E2E Tests",
    "e2eReportsDescription": "Automatisierte Browser-Tests und Ergebnisse",
    "vouchers": "Voucher codes",
    "vouchersDescription": "Create and manage codes for property analyses",
    "aiBalances": {
      "title": "API-Kontostände",
      "monthCost": "Monat",
      "calls": "Aufrufe"
    },
    "profile": "Profil"
  },
  "signatories": {
    "addSignatory": "Add Signatory",
    "addSuccess": "Signatory added successfully",
    "confirmRemove": "Are you sure you want to remove this association?",
    "editSignatory": "Edit Signatory",
    "function": "Function",
    "noInternalCompanies": "No internal companies available",
    "noSignatories": "No signatories assigned",
    "removeSignatory": "Remove Signatory",
    "removeSuccess": "Signatory removed successfully",
    "selectContact": "Select Contact",
    "signatureText": "Signature Text",
    "signatureType": "Signature Authority",
    "subtitle": "Manage authorized signatories for internal companies",
    "title": "Internal Signatories",
    "updateSuccess": "Signatory updated successfully"
  },
  "signature": {
    "collectiveMore": "Collective (multiple)",
    "collectiveTwo": "Collective (two)",
    "none": "None",
    "single": "Individual signature"
  },
  "signaturePad": {
    "handoff": {
      "close": "Close",
      "done": "Signature captured ✓",
      "doneHint": "The signature is now in the field. Submit here on the computer.",
      "expired": "The code has expired.",
      "failed": "The code could not be created.",
      "lead": "Scan the code with your phone camera and sign there. The code is valid for {{minutes}} minutes.",
      "open": "Sign on phone or tablet",
      "qrAlt": "QR code for signing on the phone",
      "regenerate": "Create new code",
      "remaining": "Code valid for another {{time}}",
      "retry": "Try again",
      "title": "Sign on your phone",
      "waiting": "Waiting for the signature from the phone …"
    },
    "mobile": {
      "doneText": "You can return to the computer.",
      "doneTitle": "Signature captured ✓",
      "error": "The signature could not be captured. Please try again.",
      "expired": "The code has expired. Please create a new one on the computer.",
      "invalid": "The code is invalid.",
      "lead": "Sign here with your finger. You can then continue on the computer.",
      "loading": "One moment, we are opening the signature field …",
      "padLabel": "Your signature",
      "submit": "Apply",
      "title": "Sign",
      "used": "A signature has already been captured here."
    }
  },
  "subTaskTabs": {
    "ariaLabel": "Sub-task tabs",
    "create": "New sub-task",
    "createAriaLabel": "Create new sub-task",
    "defaultTitle": "New sub-task",
    "discardAriaLabel": "Discard sub-task",
    "discardConfirm": "Discard sub-task with content? This action cannot be undone.",
    "discardError": "Sub-task could not be discarded",
    "discarded": "Sub-task discarded",
    "loading": "Loading sub-tasks...",
    "mainFallback": "Main task",
    "untitled": "Untitled"
  },
  "tasks": {
    "actions": {
      "action": "Aktion",
      "apply": "Übernehmen",
      "backToOverview": "Zurück zur Übersicht...",
      "callNote": "Anruf-Notiz",
      "dashMeansEmpty": "— = bisher leer",
      "dataWillBeAdded": "Folgende Daten werden ergänzt:",
      "description": "Beschreibung",
      "dismiss": "Verwerfen",
      "executed": "Aktion ausgeführt!",
      "meetingNote": "Meeting-Notiz",
      "noteLabel": "Notiz",
      "noteWillBeCreated": "Folgende Notiz wird erstellt:",
      "phone": "Telefon",
      "subject": "Betreff",
      "subtaskWillBeCreated": "Folgende Sub-Pendenz wird erstellt:",
      "title": "Titel"
    },
    "addAttachment": "Add",
    "addDescription": "Note",
    "aiApply": "Apply",
    "aiSuggestion": "AI Suggestion",
    "attachments": "Attachments",
    "clickToEdit": "Klick zum Bearbeiten",
    "completed": "erledigt",
    "context": "Kontext",
    "createSuccess": "Task created",
    "delete": "Delete",
    "deleteConfirm": "Delete this task?",
    "deleteSuccess": "Task deleted",
    "descriptionPlaceholder": "Add a note...",
    "done": "Erledigt",
    "editTask": "Edit Task",
    "errors": {
      "deleteFailed": "Task could not be deleted",
      "downloadFailed": "Download failed",
      "loadFailed": "Tasks could not be loaded",
      "titleSaveFailed": "Titel konnte nicht gespeichert werden",
      "updateFailed": "Status could not be changed",
      "uploadFailed": "Upload failed"
    },
    "fields": {
      "assignedTo": "Assigned To",
      "attachments": "Anhänge",
      "company": "Company",
      "completedAt": "Erledigt",
      "contact": "Contact",
      "createdAt": "Created At",
      "createdBy": "Created By",
      "description": "Description",
      "dueDate": "Due Date",
      "listing": "Listing",
      "priority": "Priority",
      "property": "Property",
      "status": "Status",
      "title": "Title",
      "unassigned": "Nicht zugewiesen",
      "visibility": "Sichtbarkeit",
      "descriptionPlaceholder": "Beschreibung hinzufügen..."
    },
    "goal": {
      "label": "Goal",
      "prompt": "What is your goal for this task?",
      "hint": "The goal guides the agent across all actions.",
      "placeholder": "e.g. Contact the client and schedule a viewing",
      "edit": "Edit goal",
      "remove": "Remove goal",
      "removed": "Goal removed",
      "saved": "Goal saved",
      "saveFailed": "Goal could not be saved",
      "shortcut": "Cmd/Ctrl + Enter to save",
      "setAriaLabel": "Set goal for this task",
      "chips": {
        "contact": "Contact",
        "company": "Company",
        "property": "Property",
        "listing": "Listing",
        "campaign": "Campaign",
        "teaser": "Teaser",
        "removeAriaLabel": "Remove {{label}}"
      },
      "contextEmpty": "No context linked",
      "createTask": "Create task from goal",
      "createTaskSuccess": "Task created from goal",
      "createTaskFailed": "Task could not be created",
      "editClick": "Click to edit",
      "stats": {
        "chunks_one": "{{count}} note",
        "chunks_other": "{{count}} notes",
        "chunksTooltip": "Notes attached to this task",
        "pins_one": "{{count}} note",
        "pins_other": "{{count}} notes",
        "pinsTooltip": "Pinned chat replies saved as notes"
      }
    },
    "groups": {
      "completed": "Completed",
      "later": "Later",
      "overdue": "Overdue",
      "thisWeek": "This Week",
      "today": "Today"
    },
    "linkedCompany": "Company",
    "linkedContact": "Contact",
    "lock": {
      "inProgress": "In Progress",
      "inputDisabled": "Input locked — task is being worked on by someone else",
      "readOnlyBanner": "Being worked on by {{name}} — read-only view",
      "unknownUser": "another user"
    },
    "markDone": "Mark as Done",
    "newTask": "New Task",
    "noAttachments": "No attachments",
    "noTasks": "No tasks found",
    "noTasksHint": "Create a new task using the button above.",
    "open": "Offen",
    "overview": {
      "email": "Email",
      "emails": "Emails",
      "emailNoSubject": "No subject",
      "emailStatusDraft": "Draft",
      "emailStatusSent": "Sent",
      "enrich": "Enrich",
      "note": "Note",
      "quickActions": "Quick Actions",
      "removePin": "Remove pin",
      "searchCommercialRegister": "Search commercial register",
      "propertyResidential": "Resid.",
      "propertyCommercial": "Comm.",
      "propertyLot": "Lot",
      "propertyFloors": "Floors",
      "propertyYear": "Built",
      "propertyOpen": "Open property",
      "propertyLoading": "Loading property...",
      "propertyDocuments": "Documents",
      "propertyDocsLoading": "Loading documents...",
      "propertyImages": "Images",
      "propertyImagesShowAll": "Show all ({{count}})",
      "propertyImagesShowLess": "Show less",
      "attachToEmail": "Attach to email",
      "attachToEmailShort": "To email",
      "docAttached": "{{name}} attached to email",
      "docAttachedShort": "Attached",
      "emailDiscard": "Discard draft",
      "emailArchive": "Archive email",
      "emailUnarchive": "Restore",
      "emailDiscarded": "Draft discarded",
      "emailUndo": "Undo",
      "emailArchivedToast": "Email archived",
      "emailUnarchivedToast": "Email restored",
      "emailArchivedSection": "Archived ({{count}})",
      "emailSentOn": "Sent on {{date}}",
      "emailsAllArchived": "All emails archived"
    },
    "compactHeader": {
      "addContact": "+ Contact",
      "addCompany": "+ Company",
      "addProperty": "+ Property",
      "removeContact": "Remove contact",
      "removeCompany": "Remove company",
      "removeProperty": "Remove property",
      "removeContactFailed": "Could not remove contact",
      "removeCompanyFailed": "Could not remove company",
      "removeFailed": "Could not remove link",
      "attachContactFailed": "Could not link contact",
      "attachCompanyFailed": "Could not link company",
      "attachFailed": "Could not link property",
      "details": "Details / Edit"
    },
    "priority": {
      "HIGH": "High",
      "LOW": "Low",
      "MEDIUM": "Medium",
      "URGENT": "Urgent"
    },
    "private": "Private",
    "public": "Public",
    "quickAdd": "Quick Add",
    "reopen": "Reopen",
    "resetChat": "Chat zurücksetzen",
    "search": {
      "placeholder": "Search tasks — name, email, phone, company, property...",
      "aria": "Full-text search across tasks",
      "clear": "Clear search",
      "noResults": "No results",
      "noResultsHint": "No tasks found for \"{{query}}\"."
    },
    "smartCreate": {
      "hint": "What's your goal? Describe the task — companies, contacts and properties are recognised automatically.",
      "placeholder": "e.g. \"Sales email to the CEO of Mansory for Industriestrasse 11 in Dielsdorf\"",
      "analyzing": "Analysing...",
      "proposalTitle": "Suggestion",
      "steps": "steps",
      "manual": "Create manually",
      "smartMode": "Smart mode",
      "adjust": "Adjust",
      "create": "Create",
      "error": "Analysis failed",
      "goalPrefix": "Goal"
    },
    "sort": {
      "createdAt": "Created Date",
      "dueDate": "Due Date",
      "priority": "Priority",
      "title": "Title"
    },
    "stats": {
      "done": "Done",
      "inProgress": "In Progress",
      "open": "Open",
      "overdue": "Overdue",
      "total": "Total"
    },
    "status": {
      "CANCELLED": "Cancelled",
      "DONE": "Done",
      "IN_PROGRESS": "In Progress",
      "OPEN": "Open",
      "cancelled": "Abgebrochen",
      "done": "Erledigt",
      "inProgress": "In Bearbeitung",
      "open": "Offen"
    },
    "statuses": {
      "CANCELLED": "Abgebrochen",
      "DONE": "Erledigt",
      "IN_PROGRESS": "In Arbeit",
      "OPEN": "Offen"
    },
    "subtasks": {
      "create": "Create Sub-Task",
      "done": "done",
      "empty": "No sub-tasks",
      "progress": "Fortschritt",
      "short": "Sub",
      "title": "Sub-Pendenzen"
    },
    "subtitle": "Manage tasks and to-dos",
    "title": "Tasks",
    "updateSuccess": "Task updated",
    "widget": {
      "empty": "No open tasks",
      "showAll": "Show All",
      "title": "My Tasks"
    },
    "workflow": {
      "customize": "Anpassen",
      "dismiss": "Ignorieren",
      "exit": "Workflow verlassen",
      "exitShort": "Verlassen",
      "start": "Workflow starten"
    },
    "saveError": "Speichern fehlgeschlagen",
    "deleteError": "Löschen fehlgeschlagen",
    "purge": "Delete permanently",
    "purging": "Deleting permanently …",
    "purged": "Task permanently deleted",
    "purgeError": "Permanent deletion failed",
    "purgeForbidden": "No permission: only an admin or the creator may permanently delete this task.",
    "purgeNotFound": "Task not found — it may already have been deleted.",
    "purgeConfirmTitle": "Permanently delete task?",
    "purgeConfirmDescription": "This action is irreversible. Chat, history, knowledge items and ALL sub-tasks will be completely and permanently removed. Unlike normal deletion, no restore is possible.",
    "purgeConfirmButton": "Delete permanently",
    "purgeHint": "Irreversible – no recycle bin, cannot be restored.",
    "uploadError": "Upload fehlgeschlagen",
    "deleteAttachmentError": "Anhang löschen fehlgeschlagen",
    "toggleError": "Status ändern fehlgeschlagen",
    "saved": "Pendenz gespeichert",
    "deleted": "Pendenz gelöscht",
    "deleting": "Löschen...",
    "searchProperty": "Immobilie suchen...",
    "noPropertiesFound": "Keine Immobilien gefunden"
  },
  "teaser": {
    "salesContact": "Sales contact"
  },
  "teaserCard": {
    "accessGranted": "Access granted",
    "clubDeal": "Club Deal",
    "noAccess": "No access",
    "priceLocked": "Price after NDA",
    "yieldLocked": "Yield after NDA"
  },
  "timeline": {
    "activities": "Activities",
    "activityCreated": "Activity created",
    "addCall": "Log call",
    "addMeeting": "Log meeting",
    "addNote": "Add note",
    "all": "All",
    "createContact": "Create contact",
    "createContactFor": "Create contact for {{name}}",
    "descriptionPlaceholder": "Details (optional)...",
    "dueDate": "Due",
    "durationPlaceholder": "Duration in minutes",
    "emailFrom": "From:",
    "emailHasAttachments": "Attachment",
    "emailInbound": "Received",
    "emailOutbound": "Sent",
    "emailTo": "To:",
    "emails": "Emails",
    "empty": "No entries yet",
    "entries": "entries",
    "handledBy": "handled by {{name}}",
    "mailbox": "Mailbox {{label}}",
    "mailboxPersonal": "Personal mailbox",
    "mailboxShared": "Shared mailbox",
    "newCall": "Log call",
    "newMeeting": "Log meeting",
    "newNote": "New note",
    "subjectPlaceholder": "Subject...",
    "tasks": "Tasks",
    "thread": {
      "label": "Conversation",
      "last": "last {{date}}",
      "mails": "{{n}} emails",
      "moreContacts": "+{{n}}",
      "noSubject": "(No subject)",
      "participantsLabel": "Participants:",
      "unknownParticipant": "Unknown"
    },
    "title": "Timeline",
    "unanswered": "unanswered",
    "activity": "Activities",
    "activity_one": "{{count}} activity",
    "activity_other": "{{count}} activities",
    "daysLeft_one": "1 day left",
    "daysLeft_other": "{{count}} days left",
    "endsToday": "Ends today!",
    "today": "Today",
    "lastHours": "Last {{count}} hours — {{phase}} ending soon!",
    "onlyDaysLeft": "Only {{count}} days left — {{phase}} ending soon!",
    "phases": {
      "marketing": "Exclusive Marketing",
      "nbo": "Offer Round",
      "evaluation": "Evaluation",
      "bo": "Final Round",
      "closing": "Closing",
      "sale": "Sold"
    }
  },
  "users": {
    "addCompany": "Add Company",
    "addUser": "Add User",
    "allRoles": "All roles",
    "allStatuses": "All statuses",
    "companyAdded": "Company added successfully",
    "companyRemoved": "Association removed",
    "companyRoles": "Company Associations",
    "companyUpdated": "Association updated",
    "confirmDelete": "Are you sure you want to delete this user?",
    "confirmRemoveCompany": "Are you sure you want to remove this association?",
    "contact": "Linked Contact",
    "createGroupDescLabel": "Description (optional)",
    "createGroupFromSelection": "Create Group",
    "createGroupNameLabel": "Group Name",
    "createGroupSuccess": "Group \"{{name}}\" created with {{count}} investors",
    "createGroupTitle": "Create Investor Group",
    "createSuccess": "User created successfully",
    "createdAt": "Created At",
    "creatingFromContact": "Creating user from contact \"{{name}}\". Will be linked automatically.",
    "deleteSuccess": "User deleted successfully",
    "deleteUser": "Delete User",
    "editUser": "Edit User",
    "email": "Email",
    "emailExists": "Email address already taken",
    "firstName": "First Name",
    "function": "Function",
    "isActive": "Active",
    "lastLogin": "Last Login",
    "lastName": "Last Name",
    "noContact": "No contact linked",
    "noInvestorsSelected": "No investors in selection",
    "password": "Password",
    "passwordReset": "Password Reset",
    "passwordResetHint": "Sends a reset link via email",
    "removeContact": "Remove link",
    "resetLinkCopied": "Reset link copied to clipboard",
    "resetSent": "Reset link sent via email",
    "resultsLabel": "Users",
    "role": "Role",
    "saveSuccess": "User saved successfully",
    "searchContacts": "Search contacts...",
    "selectContact": "Select contact",
    "selectedCount": "{{count}} selected",
    "sendReset": "Send Reset",
    "signatureType": "Signature Authority",
    "status": "Status",
    "title": "User Management",
    "updateSuccess": "User updated successfully"
  },
  "validation": {
    "email": "Please enter a valid email address",
    "maxLength": "Maximum {{max}} characters allowed",
    "minLength": "At least {{min}} characters required",
    "passwordMismatch": "Passwords do not match",
    "required": "This field is required"
  },
  "regulatedWhitelist": {
    "category": {
      "LISTED": "Listed",
      "PUBLIC_LAW": "Public law",
      "REGULATED": "Supervised"
    },
    "columnCategory": "Category",
    "columnCompany": "Company",
    "columnCount": "Entries",
    "columnDate": "Date",
    "columnEntry": "List entry",
    "columnLastImport": "Last import",
    "columnList": "List",
    "columnMatch": "Match",
    "confirm": "Confirm",
    "confirmFailed": "Confirmation failed.",
    "confirmSuccess": "Company confirmed as a supervised counterparty.",
    "forbidden": "No permission — this page is reserved for administrators.",
    "hint": "UID matches are confirmed automatically during the monthly run. Name matches have to be reviewed here. Company pension funds without a list entry: self-declaration in the company profile.",
    "importBtn": "Import lists now",
    "importFailed": "Import failed.",
    "importListError": "List {{list}}: {{error}}",
    "importSuccess": "Import finished: {{created}} new, {{updated}} updated, {{removed}} removed.",
    "listsEmpty": "No lists imported yet.",
    "listsTitle": "Imported lists",
    "matchRunBtn": "Start matching",
    "matchRunFailed": "Matching failed.",
    "matchRunSuccess": "Matching finished: {{confirmed}} auto-confirmed, {{pending}} to review, {{stale}} outdated.",
    "matchType": {
      "name_exact": "Exact name",
      "name_fuzzy": "Fuzzy name",
      "uid": "UID"
    },
    "never": "Never",
    "noMatches": "No entries in this view.",
    "queueTitle": "Matches to review",
    "reject": "Reject",
    "rejectFailed": "Rejection failed.",
    "rejectSuccess": "Match rejected.",
    "staleHint": "List entry no longer exists — check the status of the company manually.",
    "subtitle": "Supervised counterparties (FINMA, SIX, OAK BV): import lists and review matches.",
    "tabs": {
      "CONFIRMED": "Confirmed",
      "PENDING": "Open",
      "REJECTED": "Rejected",
      "STALE": "Outdated"
    },
    "title": "Supervisory lists"
  },
  "zefixSync": {
    "companies": "Organizations",
    "companiesProcessed": "companies processed",
    "configFailed": "Zefix configuration failed.",
    "configSaved": "Configuration saved",
    "configuration": "Configuration",
    "duration": "Duration",
    "errors": "Errors",
    "history": "History",
    "interval": "Interval",
    "lastRun": "Last Run",
    "mockModeWarning": "Mock mode active — no real Zefix data is being fetched",
    "noLogs": "No sync runs yet",
    "rateLimit": "Rate Limit",
    "result": "Result",
    "running": "Sync running...",
    "startedAt": "Started",
    "status": {
      "completed": "Completed",
      "failed": "Failed",
      "running": "Running"
    },
    "subtitle": "Automatic synchronization with the commercial register",
    "syncFailed": "Zefix synchronisation failed.",
    "syncStarted": "Zefix synchronisation started.",
    "title": "Zefix Sync",
    "trigger": "Trigger",
    "triggerManual": "Manual",
    "triggerScheduler": "Automatic",
    "triggerSync": "Start Sync",
    "revert": "Undo",
    "revertTitle": "Undo sync run",
    "revertConfirm": "{{added}} added and {{updated}} updated contacts will be reset. Continue?",
    "revertFailed": "Revert failed"
  },
  "research": {
    "applyFailed": "Applying failed",
    "proposalTitle": "Research proposal",
    "new": "new",
    "changed": "changed",
    "selectAll": "All",
    "selectOnlyNew": "New only",
    "field": "Field",
    "currentValue": "Current (CRM)",
    "proposedValue": "Proposal (research)",
    "applyHtmlReport": "Apply HTML report",
    "applyKeyPersons": "Synchronise contacts",
    "applySelected": "Apply",
    "applied": "{{count}} fields applied"
  },
  "researchCard": {
    "location": "Location"
  },
  "emailTemplatePicker": {
    "uncategorized": "Allgemein",
    "loading": "Vorlagen laden...",
    "noTemplate": "Ohne Vorlage",
    "preview": "Vorschau"
  },
  "softDelete": {
    "showDeleted": "Show deleted",
    "archived": "Archived",
    "restore": "Restore",
    "restoreSuccess": "Successfully restored"
  },
  "unifiedProcess": {
    "heading": {
      "create": "Create new property",
      "edit": "Edit property — {{name}}",
      "editStatic": "Edit property",
      "untitled": "Untitled property"
    },
    "loadError": "Could not load property",
    "tabsAriaLabel": "Editing tabs",
    "skeletonNote": "This tab will be populated in a follow-up step.",
    "tabs": {
      "ai": "AI capture",
      "object": "Object",
      "location": "Location",
      "pricing": "Price & rent",
      "media": "Media & texts",
      "review": "Mandate & marketing",
      "protocol": "AI extraction log",
      "knowledge": "Knowledge",
      "aiInsights": "AI notes"
    },
    "tabHints": {
      "ai": "Upload documents — the AI extracts the fields automatically.",
      "object": "Areas, rooms, condition and energy class.",
      "location": "Map, building register (GWR) data and environmental restrictions.",
      "pricing": "Offer price, mandate type and conditions.",
      "media": "Images, virtual tour, highlights and descriptions.",
      "review": "Principal, sales configuration and quality gate.",
      "protocol": "Overview of all AI extraction jobs for this property.",
      "knowledge": "Notes pinned to this property from tasks."
    },
    "protocol": {
      "title": "AI extraction log",
      "subtitle": "Overview of all AI jobs that contributed data to this property.",
      "empty": "No AI extraction available for this property yet.",
      "loadFailed": "Could not load the extraction log.",
      "jobLabel": "Job #{{id}}",
      "confidenceLabel": "Confidence:",
      "kpi": {
        "confidence": "Confidence",
        "documents": "Documents",
        "images": "Images",
        "fields": "Fields",
        "tokens": "Tokens"
      },
      "documents": {
        "title": "Document classification"
      },
      "location": {
        "title": "Location data",
        "summary": "{{found}} of {{total}} detected",
        "fields": {
          "address": "Address",
          "zip": "ZIP code",
          "city": "City",
          "municipality": "Municipality",
          "canton": "Canton",
          "country": "Country",
          "coordinates": "Coordinates"
        }
      },
      "fields": {
        "title": "Detected fields ({{count}})"
      },
      "images": {
        "title": "Image classification",
        "summary": "Kept {{kept}} of {{total}} images"
      },
      "coverage": {
        "title": "Data coverage",
        "summary": "{{found}} of {{total}} fields detected ({{pct}}%)",
        "found": "Detected",
        "missing": "Missing",
        "none": "No entries"
      },
      "warnings": {
        "title": "{{count}} warning(s)"
      },
      "technical": {
        "title": "Technical details"
      }
    },
    "location": {
      "readOnlyHint": "All data is filled in automatically — by AI upload or address input. Direct editing is not possible here.",
      "notAvailable": "not available",
      "sections": {
        "basics": "Location overview",
        "energy": "Energy & environment",
        "gwr": "Building register (GWR)",
        "taxLaw": "Tax & legal",
        "environment": "Environment & restrictions"
      },
      "fields": {
        "map": "Map",
        "municipality": "Municipality",
        "inhabitants": "Population",
        "coordinates": "Coordinates (lat / lon)",
        "zoneType": "Zone type",
        "zoneRegulations": "Zone regulations",
        "egid": "EGID (building identifier)",
        "egrid": "EGRID (parcel identifier)",
        "constructionYear": "Construction year (register)",
        "noiseSensitivity": "Noise sensitivity level (ES)",
        "groundwaterZone": "Groundwater protection zone",
        "naturalHazard": "Natural hazards",
        "floodRisk": "Flood risk zone",
        "earthquakeZone": "Earthquake zone",
        "contaminatedSite": "Contaminated site entry",
        "heritageProtection": "Heritage protection",
        "co2Emissions": "CO₂ emissions (building)",
        "minergie": "Minergie certificate",
        "solarPotential": "Solar potential (roof)",
        "taxRateMunicipality": "Municipal tax rate",
        "taxRateCanton": "Cantonal tax rate",
        "taxRateMunicipalityLegal": "Municipal tax rate (legal entities)",
        "taxRateCantonLegal": "Cantonal tax rate (legal entities)",
        "zoning": "Land-use zone (municipal + cantonal)",
        "bauzone": "Building zone (category)",
        "oevQuality": "Public-transport quality",
        "noiseDb": "Road noise (day, dB)"
      },
      "taxRateValue": "Income: {{income}} · Wealth: {{wealth}}",
      "taxRateLegalValue": "Profit: {{profit}} · Capital: {{capital}}",
      "tooltip": {
        "showDetails": "Show details",
        "rawValue": "Original value: {{raw}}"
      },
      "noiseClassify": {
        "es1": {
          "label": "Quiet zone (ES I)",
          "description": "Recreational area. Strictest noise limits — ideal for noise-sensitive uses such as hospitals or schools."
        },
        "es2": {
          "label": "Residential zone (ES II)",
          "description": "Pure residential areas. Good noise protection — standard residential use without restrictions."
        },
        "es3": {
          "label": "Mixed zone (ES III)",
          "description": "Residential mixed with moderately disturbing trades. Some commercial noise possible — usually acceptable for living."
        },
        "es4": {
          "label": "Industrial zone (ES IV)",
          "description": "Heavily disturbing trades / industry. Hardly any noise protection — not suitable for pure residential use."
        },
        "db_quiet": {
          "label": "Very quiet (<45 dB)",
          "description": "Rural location, no traffic noise. Ideal living environment."
        },
        "db_calm": {
          "label": "Quiet (45–54 dB)",
          "description": "Normal residential setting, low background noise."
        },
        "db_moderate": {
          "label": "Moderate (55–64 dB)",
          "description": "Noticeable — keeping windows closed at night recommended."
        },
        "db_loud": {
          "label": "Loud (65–74 dB)",
          "description": "Main road or near rail. Sound-proof windows recommended."
        },
        "db_very_loud": {
          "label": "Very loud (≥75 dB)",
          "description": "Motorway or airport. Living only with comprehensive sound-proofing."
        },
        "unknown": {
          "label": "Classification unknown",
          "description": "The noise value could not be classified clearly."
        }
      },
      "hazardClassify": {
        "none": {
          "label": "No hazard",
          "description": "No natural-hazard record — no known risks."
        },
        "low": {
          "label": "Low",
          "description": "Minimal risk. No special protective measures required."
        },
        "medium": {
          "label": "Medium",
          "description": "Landslide, rock fall or flooding possible. Check insurance coverage."
        },
        "high": {
          "label": "Substantial",
          "description": "Protective measures or official requirements possible. Consider impact on value."
        },
        "severe": {
          "label": "High",
          "description": "Construction ban or strict requirements likely. Notable valuation discount to be expected."
        },
        "unknown": {
          "label": "Classification unknown",
          "description": "The natural-hazard value could not be classified clearly."
        }
      },
      "earthquakeClassify": {
        "z1": {
          "label": "Low seismic zone (Z1)",
          "description": "Lowest hazard in Switzerland. Standard construction sufficient."
        },
        "z2": {
          "label": "Moderate seismic zone (Z2)",
          "description": "Increased construction requirements per SIA 261."
        },
        "z3a": {
          "label": "High seismic zone (Z3a)",
          "description": "Stricter design required — higher construction costs possible."
        },
        "z3b": {
          "label": "Very high seismic zone (Z3b)",
          "description": "Highest Swiss hazard (Valais, Basel). Earthquake-resistant construction mandatory."
        }
      },
      "groundwaterClassify": {
        "none": {
          "label": "No protection zone",
          "description": "No groundwater-protection restrictions for construction or refurbishment."
        },
        "au": {
          "label": "Protection area Au",
          "description": "General protection area for usable groundwater. Minor requirements for construction."
        },
        "s3": {
          "label": "Protection zone S3",
          "description": "Outer protection zone — restrictions on excavation, infiltration and storage of water-polluting substances."
        },
        "s2": {
          "label": "Protection zone S2",
          "description": "Inner protection zone — significant requirements, most construction needs approval."
        },
        "s1": {
          "label": "Catchment area S1",
          "description": "Direct area around drinking-water catchment. Effectively a construction ban."
        },
        "unknown": {
          "label": "Classification unknown",
          "description": "The groundwater protection zone could not be classified clearly."
        }
      },
      "co2Classify": {
        "neutral": {
          "label": "Climate-neutral",
          "description": "Renewable energy (heat pump, district heating, wood). No CO₂-driven refurbishment need."
        },
        "low": {
          "label": "Low emissions",
          "description": "Below the Swiss average — no short-term refurbishment obligation expected."
        },
        "high": {
          "label": "High emissions",
          "description": "Typical for oil or gas heating. CO₂ Act: refurbishment obligation expected in the coming years."
        },
        "unknown": {
          "label": "Emissions unknown",
          "description": "The CO₂ value could not be classified clearly."
        }
      },
      "co2Tone": {
        "green": "Low CO₂ emissions (renewable)",
        "yellow": "Moderate CO₂ emissions",
        "red": "High CO₂ emissions",
        "gray": "CO₂ emissions unknown"
      },
      "hazardTone": {
        "green": "Low",
        "yellow": "Moderate",
        "red": "High",
        "gray": "Unknown"
      },
      "noiseTone": {
        "green": "Quiet",
        "yellow": "Moderate",
        "red": "Loud",
        "gray": "Unknown"
      },
      "zoneRegulationsDocuments": "Regulation documents",
      "zoneRegulationsDocument": "Document",
      "minergie": {
        "none": "No certificate"
      },
      "oevClassify": {
        "a": {
          "label": "PT A (excellent)",
          "description": "Excellent public-transport access — high-frequency tram or train station nearby (prime urban location)."
        },
        "b": {
          "label": "PT B (good)",
          "description": "Good access — frequent service with a short walk. Typical for well-connected city districts."
        },
        "c": {
          "label": "PT C (moderate)",
          "description": "Moderate access — bus or train at roughly hourly intervals."
        },
        "d": {
          "label": "PT D (limited)",
          "description": "Limited access — few connections per day. A car is effectively required."
        },
        "e": {
          "label": "PT E (marginal)",
          "description": "Marginal access — hardly any public transport. Peripheral or rural location."
        },
        "none": {
          "label": "No public-transport access",
          "description": "No public transport within usable distance."
        },
        "unknown": {
          "label": "Public-transport class unknown",
          "description": "The PT quality class could not be determined."
        }
      },
      "bauzoneInfo": {
        "wohnen": "Residential zones — primarily for housing (low to multi-storey).",
        "arbeit": "Work zones — for industry, commerce and services. Residential use usually limited.",
        "misch": "Mixed zones — housing and moderately disturbing commerce equally allowed.",
        "zentrum": "Centre zones — town and old-town zones with high density and urban character.",
        "oeffentlich": "Public-use zones — schools, administration, hospitals, sports facilities.",
        "tourismus": "Tourism and leisure zones — hotels, resorts, sports and recreation.",
        "eingeschraenkt": "Restricted building zones — e.g. hamlets or specially protected areas with limited construction.",
        "generic": "Building-zone category per the Federal Building Zone Statistics (ARE)."
      },
      "links": {
        "googleMaps": "Open Google Maps",
        "geoAdmin": "Source: map.geo.admin.ch",
        "geodienste": "Source: geodienste.ch",
        "housingStat": "Source: housing-stat.ch (GWR)",
        "cadastre": "Source: cadastre.ch",
        "oereb": "Source: OEREB cadastre",
        "bfs": "Source: FSO",
        "bafu": "Source: FOEN (CO₂ cadastre)",
        "minergie": "Source: minergie.ch",
        "sonnendach": "Source: sonnendach.ch",
        "estv": "Source: FTA tax calculator",
        "bauzone": "Source: ARE building-zone statistics",
        "oevQuality": "Source: ARE PT quality classes"
      }
    },
    "ai": {
      "upload": {
        "title": "Upload documents for AI capture",
        "subtitle": "Upload sales documentation, land register extracts, plans or images — the AI then fills in the following tabs automatically.",
        "dragDrop": "Drag files here or click",
        "hint": "PDF, images or Office documents (max. 250 MB per file)",
        "chooseFiles": "Choose files",
        "chooseDirectory": "Choose directory",
        "noSupportedInDirectory": "No supported files found in the directory (PDF, images or Office documents)",
        "selectedFiles": "{{count}} file(s) selected",
        "removeFile": "Remove {{name}}",
        "fileTooLarge": "{{name}}: file too large (max. 250 MB)",
        "startButton": "Start AI capture",
        "starting": "Uploading…",
        "started": "Analysis started",
        "uploadFailed": "Upload failed",
        "startHint": "Analysis runs in the background — progress is shown here.",
        "attachImagesLabel": "Add images from documents to the gallery",
        "attachImagesHint": "Off by default — faster, the AI does not analyse the photos when images are disabled. Better to upload property images separately."
      },
      "processing": {
        "title": "AI is processing the documents",
        "hint": "Please wait — the result will appear automatically."
      },
      "result": {
        "title": "Capture complete",
        "subtitle": "Please review the summary and accept the data.",
        "confidenceLabel": "Confidence",
        "documentsLabel": "Detected documents",
        "imagesLabel": "Images",
        "warningsLabel": "{{count}} warning(s)",
        "warningsMore": "+{{count}} more…",
        "confirmButton": "Accept data & continue",
        "confirming": "Creating…",
        "confirmed": "Property created — {{count}} fields populated.",
        "confirmedRecovered": "Object #{{id}} was created (the connection was briefly interrupted).",
        "confirmFailed": "Could not accept data",
        "cancelButton": "Discard & restart"
      },
      "failed": {
        "title": "AI capture failed",
        "retryButton": "Restart"
      },
      "history": {
        "title": "AI capture history",
        "subtitle": "The following AI jobs contributed data to this property.",
        "empty": "No AI capture for this property.",
        "loadFailed": "Could not load history.",
        "editNoUploadHint": "No new AI upload is possible in edit mode. Use the following tabs to add data manually.",
        "openInJobs": "Open in AI jobs",
        "jobLabel": "Job #{{id}}",
        "summary": "{{docs}} document(s) · {{date}}",
        "confidenceLabel": "Confidence:"
      }
    },
    "save": {
      "idle": "Synced",
      "pending": "Pending changes",
      "saving": "Saving…",
      "saved": "Saved",
      "error": "Save failed"
    },
    "aiHints": {
      "title": "AI notes",
      "toggleAria": "Expand or collapse AI notes"
    },
    "pricing": {
      "groups": {
        "pricing": "Pricing & Terms",
        "rentSituation": "Rental situation",
        "rentSituationToggle": "Toggle rental situation"
      },
      "sections": {
        "financialKpis": "Financial KPIs",
        "unitMix": "Unit mix",
        "rentRoll": "Rent roll"
      },
      "tablesUnavailableInCreateMode": "Unit mix and rent roll can be edited after the first save.",
      "unitMixSellerHint": "The unit mix is maintained by the broker — read-only here.",
      "rentRollSellerHint": "You can update the rent roll yourself — please save after editing.",
      "saveUnitMix": "Save unit mix",
      "saveRentRoll": "Save rent roll",
      "noUnitMix": "No unit mix entries yet.",
      "noRentRoll": "No rent roll entries yet."
    },
    "media": {
      "requiresProperty": "Please save the basic data first — uploads are available afterwards.",
      "images": {
        "title": "Images",
        "hint": "Mark the primary image and reorder additional images by drag & drop. Visualisations, photos, plans and maps are grouped automatically.",
        "noFilterMatch": "No images match the selected filter.",
        "filters": {
          "ariaLabel": "Filter images by medium",
          "all": "All",
          "photo": "Photos",
          "visualisierung": "Visualisations",
          "plan": "Plans",
          "karte": "Maps",
          "other": "Other"
        },
        "teaser": {
          "teaserOption": "Teaser",
          "ndaOption": "NDA only",
          "toggleAria": "Teaser visibility",
          "riskBadge": "Location",
          "riskTitle": "Allows conclusions about the exact location",
          "confirmUpgrade": "This image reveals the location. Show it in the teaser (before NDA) anyway?",
          "confirmYes": "Show anyway",
          "captionEmpty": "No AI description",
          "showFull": "Show full description",
          "summaryTeaser": "{{count}} in teaser",
          "summaryNda": "{{count}} NDA only",
          "summaryRisk": "{{count}} with location risk",
          "previewToggle": "Teaser preview",
          "previewHint": "Show only images visible to buyers without an NDA",
          "previewEmpty": "No image is enabled for the teaser."
        },
        "mediumLabels": {
          "photo": "Photo",
          "visualisierung": "3D",
          "plan": "Plan",
          "karte": "Map",
          "scan": "Scan",
          "logo": "Logo"
        },
        "subjectLabels": {
          "fassade": "Facade",
          "wohnraum": "Living room",
          "kueche": "Kitchen",
          "bad": "Bathroom",
          "schlafzimmer": "Bedroom",
          "buero": "Office",
          "treppenhaus": "Staircase",
          "keller": "Basement",
          "garten": "Garden",
          "umgebung": "Surroundings",
          "luftbild": "Aerial view",
          "grundriss": "Floor plan",
          "schnitt": "Section",
          "ansicht": "Elevation",
          "lageplan": "Site plan"
        }
      },
      "dossier": {
        "title": "Dossier documents",
        "hint": "Upload sales documents by category (land register, transfer, …)."
      },
      "accessLog": {
        "title": "Access log",
        "hint": "Who viewed or downloaded which document and when — evidence for the confidentiality agreement.",
        "count": "{{count}} accesses logged",
        "filterLabel": "Buyer",
        "filterAll": "All buyers",
        "empty": "No document accesses logged yet.",
        "loadError": "The access log could not be loaded.",
        "pageOf": "Page {{page}} of {{total}}",
        "typeDownload": "Download",
        "typePreview": "Preview",
        "typePreviewPage": "Preview page {{page}}",
        "mayanDocument": "Document {{id}}",
        "columns": {
          "time": "Time",
          "buyer": "Buyer",
          "document": "Document",
          "type": "Type",
          "ip": "IP"
        }
      },
      "identifyLeak": {
        "button": "Identify leak",
        "title": "Identify leak",
        "description": "Upload the leaked file — the invisible fingerprint reveals which buyer received it.",
        "fileLabel": "Leaked file",
        "fileHint": "Image or PDF, max. 30 MB. Works with excerpts and compressed copies too.",
        "submit": "Identify",
        "tooLarge": "File is too large (max. 30 MB).",
        "error": "Identification failed. Please try again.",
        "resultFound": "Belongs to: {{buyer}}, {{document}}, {{time}}",
        "resultNotFound": "No fingerprint found.",
        "unknownDocument": "Unknown document"
      },
      "immotron": {
        "title": "Immotron documents",
        "hint": "System-generated documents — internal only."
      },
      "highlights": {
        "title": "Highlights & description",
        "hint": "Show at most 5 highlights — reorder via drag & drop."
      },
      "vrTour": {
        "title": "Virtual tour & links",
        "hint": "Paste an external tour URL (Matterport, Kuula, …)."
      },
      "translations": {
        "title": "Translations",
        "hint": "Maintain texts in DE/EN/FR/IT — empty fields can be auto-translated.",
        "cards": {
          "title": "Title",
          "description": "Description",
          "location": "Location"
        },
        "placeholders": {
          "name": "e.g. Residential & commercial building Zurich-Seefeld",
          "subheader": "e.g. Prime location in the business district",
          "highlights": "e.g. • Fully let • Renovated 2021 • Public transport class A",
          "description": "Detailed description of the property: location, condition, fit-out, special features and possible uses ...",
          "macro": "e.g. Central location in the city of Zurich, established economic area ...",
          "micro": "e.g. Quiet side street, shops and public transport within walking distance ..."
        },
        "aiBadge": "AI suggestion",
        "aiTitle": "This text was suggested by the AI. Edit it to remove the hint.",
        "translated": "Translated",
        "notTranslated": "Not translated",
        "copyFromMaster": "Copy from DE",
        "reference": "German original",
        "charCount": "{{count}} characters",
        "charCountMax": "{{count}}/{{max}} characters"
      }
    },
    "object": {
      "sections": {
        "classification": "Classification & status",
        "address": "Address & location",
        "land": "Land",
        "building": "Building",
        "energy": "Energy & condition"
      },
      "fields": {
        "dealState": "Deal state",
        "dealStateNotSet": "Not set",
        "inhabitants": "Inhabitants (municipality)",
        "coordinates": "Coordinates",
        "minGroundFloorHeight": "Min. ground floor height",
        "egidNumber": "EGID number (building identifier)",
        "egidPlaceholder": "e.g. 100123456",
        "energyClassPlaceholder": "e.g. A, B, C…"
      },
      "noSubtypes": "No subtypes available for this type."
    },
    "review": {
      "sections": {
        "auftraggeber": "Principal",
        "sales": "Sales configuration",
        "listing": "Listing configuration",
        "qualityGate": "Quality gate",
        "timeline": "Deal timeline"
      },
      "timeline": {
        "subtitle": "Current phase and activities at a glance."
      },
      "auftraggeber": {
        "subtitle": "Who issued the marketing mandate?",
        "contactLabel": "Principal",
        "contactPlaceholder": "Search existing contact…",
        "contactHint": "Used in the marketing mandate and contracts.",
        "sellerReadOnly": "These details are maintained by the broker.",
        "notSet": "Not set yet",
        "searchButton": "Search contract",
        "changeButton": "Change contract",
        "removeButton": "Remove",
        "removeConfirmTitle": "Remove principal?",
        "removeConfirmText": "“{{name}}” will be removed as the principal of this property. Existing contracts remain in place; you can link a new principal at any time.",
        "removeConfirmTextNoName": "The principal will be removed from this property. Existing contracts remain in place; you can link a new principal at any time.",
        "removeSuccess": "Principal removed",
        "removeFailed": "The principal could not be removed",
        "saveFirstHint": "Please save the property first to link a principal."
      },
      "sales": {
        "subtitle": "Responsible advisor and mandate term.",
        "salesUserLabel": "Responsible advisor",
        "salesUserPlaceholder": "Select advisor…",
        "saleStartDate": "Mandate start",
        "saleEndDate": "Mandate end",
        "assignedTo": "Currently assigned: {{name}}"
      },
      "listing": {
        "subtitle": "Visibility and publication settings.",
        "privateLabel": "Private listing",
        "privateHint": "Only selected investors or groups see this property.",
        "expirationLabel": "Listing expires on",
        "expirationHint": "After this date the listing is deactivated automatically.",
        "investorGroupHint": "Manage investor and group access on the property detail page.",
        "openDetailPage": "Open detail page"
      },
      "qualityGate": {
        "subtitle": "Status and submission for internal review.",
        "statusLabel": "Current status",
        "submitButton": "Submit for review",
        "submitting": "Submitting…",
        "submitted": "Submitted for review.",
        "submitFailed": "Submission failed. Please retry.",
        "submitHint": "After submission an internal team member reviews the property.",
        "inReviewHint": "The property is currently being reviewed. You can keep updating data until a decision is made.",
        "sellerStateHint": "The current status is managed by the broker.",
        "submittedAt": "Submitted on {{date}}",
        "reviewedAt": "Reviewed on {{date}}",
        "rejectedTitle": "Rejection reason",
        "rejectedHint": "Please address the points above and resubmit."
      }
    },
    "aiInsights": {
      "title": "AI notes",
      "description": "All AI information about this property in one place: extraction notes, the extraction log and pinned knowledge.",
      "sectionsAriaLabel": "AI notes: sections",
      "warningIndicatorAria": "Contains warnings",
      "sections": {
        "hints": {
          "label": "Notes",
          "description": "Notes from the AI extraction (owners, easements, mortgage liens, conflicts). Entries with ⚠️ are highlighted.",
          "empty": "No AI notes available for this property."
        },
        "protocol": {
          "label": "Extraction log"
        },
        "knowledge": {
          "label": "Knowledge",
          "description": "Notes pinned to this property from tasks."
        }
      }
    }
  },
  "knowledgeBoard": {
    "pageTitle": "Arrange Notes",
    "pageSubtitle": "Drag notes from research into the target area and reorder them.",
    "instructions": "Drag and drop — or use space / arrow keys for keyboard control.",
    "reset": "Reset",
    "sourceTitle": "Research",
    "sourceHint": "Pool of collected notes.",
    "sourceEmpty": "No more notes in research.",
    "targetTitle": "Target",
    "targetHint": "Working area — drop and sort notes here.",
    "targetEmpty": "Drag a note here to add it to the target.",
    "dragHandle": "Drag note “{{title}}”",
    "a11y": {
      "start": "Picked up note {{id}}.",
      "over": "Note {{id}} over {{target}}.",
      "outside": "Note {{id}} outside any droppable area.",
      "end": "Note {{id}} dropped on {{target}}.",
      "cancel": "Move of note {{id}} cancelled."
    },
    "samples": {
      "market": {
        "title": "Market analysis Zurich West",
        "summary": "Average price per m² rose 3.2 % last quarter to CHF 11,400.",
        "source": "Research · Market data"
      },
      "location": {
        "title": "Location: Industrial quarter",
        "summary": "Excellent public transport, planned upgrade with new district park.",
        "source": "Research · Location"
      },
      "zefix": {
        "title": "Company profile Musterhaus AG",
        "summary": "Active since 1998, 24 employees, construction & renovation industry.",
        "source": "Zefix"
      },
      "news": {
        "title": "News: New tram line 17 from 2027",
        "summary": "Direct connection to main station planned — likely uplift for properties along the corridor.",
        "source": "Research · News"
      }
    }
  },
  "buyerSearch": {
    "placeholder": "Search name, company or email …",
    "hint": "Enter at least 2 characters to search CRM contacts, companies and the commercial register.",
    "empty": "No matches found in the CRM or the commercial register.",
    "searchFailed": "Search failed. Please try again.",
    "assign": "Assign",
    "assignFailed": "Assignment failed",
    "alreadyAssigned": "Assigned",
    "typeContact": "Contact",
    "typeCompany": "Company",
    "statusActive": "Active",
    "statusPending": "Onboarding required",
    "zefixBadge": "Zefix",
    "createFromZefix": "Create company",
    "createdFromZefix": "{{name}} and {{count}} people created",
    "createFromZefixFailed": "Company could not be created",
    "noZefixHint": "Not in the commercial register?",
    "noZefixHintLink": "Create a new organisation in the CRM",
    "inactiveAt": "inactive at {{company}}",
    "inactiveAssignBlocked": "Role at {{company}} has ended",
    "noEmailAssignBlocked": "No email address — cannot be assigned"
  },
  "emailConflict": {
    "duplicateContactTitle": "Email already linked to a contact",
    "duplicateCompanyTitle": "Email already linked to an organisation",
    "existingEntry": "Existing entry",
    "switchToContact": "Switch to contact",
    "switchToCompany": "Switch to organisation",
    "merge": "Merge",
    "mergeTitle": "Merge contacts",
    "matchReasonEmail": "Same email address",
    "genericTitle": "Generic address — move it to the organisation?",
    "genericDescription": "This address belongs to an organisation, not to an individual person.",
    "moveToCompany": "Move to {{name}}",
    "moveToCompanyHint": "The address is stored with the organisation and removed from the contact.",
    "saveAnyway": "Save anyway",
    "noCompany": "This contact is not linked to an organisation.",
    "movedToCompany": "Email moved to the organisation",
    "moveFailed": "Could not move the address to the organisation"
  }
}
